import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { detectInitialLanguage } from '../lib/initialLanguage';

i18n
  .use(initReactI18next)
  .init({
    debug: true,
    // ?lang=es|en en la URL, o el idioma elegido con la bandera; si no, español
    // (src/lib/initialLanguage.js). Da una URL directa al inglés: /privacy?lang=en.
    lng: detectInitialLanguage(),
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },


    resources: {
      en: {
        translation: {
          navbar_home: "Home",
          navbar_about_us: "About",
          navbar_services: "Systems",
          navbar_portfolio: "White label",
          navbar_resources: "Playbooks",
          navbar_blog: "Blog",
          navbar_documentation: "Documentation",
          contact_us: "Book a Call",

          cookies_text:
            "We use cookies to improve your experience and understand how agencies use our site. Cookies help us personalize content, measure performance, and keep the platform reliable. By clicking 'Accept All', you consent to the use of cookies. You can learn more in our Cookie Policy and adjust preferences anytime.",
          cookies_text_short:
            "We use analytics cookies only if you accept them.",
          cookies_button: "Accept",

          page_title_about_us: "Built for Agencies",
          about_video_kicker: "Our commitment",
          about_video_title: "Ready to grow your agency?",
          about_video_description:
            "Our AI automations are easy to use, strategically designed to help you, organized by projects and clients, and fully tracked with analytics so you can see the impact in real time.",
          about_video_bullet_1: "Simple workflows",
          about_video_bullet_2: "Organized orchestration",
          about_video_bullet_3: "Traceability & analytics",
          about_video2_kicker: "Beyond marketing: customer service and sales for your clients",
          about_video2_title: "Organize by project and activate flows per client",
          about_video2_description:
            "Structure every account, activate automations, and link them to the right client. Easy to explain, scalable, and under your agency's control. Book a demo or contact us.",
          about_video2_bullet_1: "Easy to sell",
          about_video2_bullet_2: "Grows with your client base",
          about_video2_bullet_3: "Actionable processes",
          about_video3_kicker: "Agency impact",
          about_video3_title: "A new recurring service line for your agency",
          about_video3_description:
            "Managed and secure automations that expand margin without adding operational chaos.",
          about_video3_bullet_1: "Customer service, appointments and CRM",
          about_video3_bullet_2: "New recurring revenue",
          about_video3_bullet_3: "Managed, scalable, secure",
          about_meet_team_cta: "Meet the team",
          page_title_services: "Systems That Scale",
          page_title_portfolio: "Proof & Outcomes",
          page_title_resources: "Agency Toolkit",
          page_title_blog: "Operator Notes",
          page_title_blog_details: "Insight Details",
          page_title_policies: "Policies",
          page_title_contact_us: "Let’s Talk",
          page_title_documentation: "Help center",
          docs_page_title: "Help center",
          docs_page_subtitle: "Browse the Invokeapp manual by section",
          docs_empty: "No documentation available right now.",
          page_title_partnerships: "Partnerships",
          page_title_features: "Playbooks",
          page_title_demo: "Live Demo",
          page_title_operators: "Operators",
          page_title_reviews: "Reviews",
          page_title_home: "Customer service, appointments and CRM for agencies",
          page_meta_home: "The platform for agencies and their clients: customer service, appointments, CRM and sales follow-up in one place, with AI assisting each process. No engineers needed.",
          page_meta_about: "InvokeApp gives agencies the platform for customer service, appointments, CRM and sales follow-up, so they deliver more for their clients without growing the technical team.",
          page_meta_services: "Services for agencies and their clients: lead capture, customer service, appointments, sales follow-up and client retention, with automation and AI as support.",
          page_meta_platform: "The InvokeApp platform: customer service, appointments, CRM, sales follow-up and integrations for agencies and their clients, with AI assisting each process.",
          page_meta_pricing: "Simple, scalable pricing for agencies: customer service, appointments, CRM and sales follow-up for your clients, without hiring more staff.",
          page_meta_operators: "Discover InvokeApp certified operators — agencies delivering AI & automation with proven performance. Browse certified, advanced and elite operators.",
          page_meta_reviews: "What agencies say about InvokeApp: real reviews on running customer service, appointments and sales follow-up for their clients.",
          page_meta_contact: "Talk to the InvokeApp team. Book a call to see how to run customer service, appointments, CRM and sales follow-up for your agency's clients.",
          page_title_team: "Team",
          team_hero_title: "Our Team",
          team_breadcrumb: "Team",
          team_section_kicker: "Our Team",
          team_section_title: "We help to create great future agencies.",
          team_role_ceo: "CEO, CTO & Founder",
          team_role_cfo: "CFO, Co-Founder",
          team_role_cmo: "CMO, Co-Founder",
          page_title_privacy: "Privacy Policy",
          page_title_terms: "Terms of Service",
          page_title_cookies: "Cookie Policy",
          page_title_legal_notice: "Legal Notice",
          page_title_data_deletion: "Data Deletion",
          page_title_subprocessors: "Sub-processors",
          page_title_dpa: "Data Processing Agreement",
          legal_header_subtitle: "Legal information",
          footer_privacy: "Privacy",
          footer_terms: "Terms",
          footer_cookies: "Cookies",
          footer_legal_notice: "Legal notice",
          footer_data_deletion: "Data deletion",
          footer_subprocessors: "Sub-processors",
          footer_dpa: "DPA",
          cookies_decline: "Reject",
          cookies_policy_link: "Cookie Policy",
          cookies_meta: "InvokeApp Cookie Policy: which cookies the website uses and how to accept or reject them.",
          legal_notice_meta: "InvokeApp legal notice: owner of invokeapp.io, MARTÍNEZ CAMPOY CONSULTING, S.L.",
          data_deletion_meta: "How to disconnect your Google, WhatsApp, Instagram or Facebook accounts from InvokeApp and request deletion of your data.",
          subprocessors_meta: "Service providers that process personal data on behalf of InvokeApp, with their location and safeguards.",
          dpa_meta: "InvokeApp Data Processing Agreement (Article 28 GDPR) for agencies and businesses using the platform.",
          // Versiones de los textos legales: /legal/history y /legal/history/:doc/:version
          legal_previous_versions: "Previous versions",
          legal_history_title: "Legal document versions",
          legal_history_meta: "The current and previous versions of the InvokeApp legal documents, with their date and fingerprint.",
          legal_history_intro: "Each version of our legal documents is identified by a number and a date. Here you can read, exactly as they were published, the version in force and the archived previous versions of each document, or download the original file in Spanish or English.",
          legal_history_intro_hash: "Next to each file is the start of its sha256 fingerprint: if you download the file and compute its sha256, it matches the one we publish. This shows that the text has not changed since it was published.",
          legal_history_index: "Documents",
          legal_history_live: "See the version in force",
          legal_history_col_version: "Version",
          legal_history_col_date: "Date",
          legal_history_col_status: "Status",
          legal_history_col_files: "Files and sha256 fingerprint",
          legal_history_current: "In force",
          legal_history_previous: "Previous",
          legal_history_version: "Version",
          legal_history_version_meta: "{{doc}}, version {{version}} of {{date}}, archived exactly as published.",
          legal_history_current_notice: "This is the version in force, archived exactly as published.",
          legal_history_archived_notice: "Historical version, no longer in force.",
          legal_history_see_current: "See the version in force ({{version}})",
          legal_history_download: "Download the original file",
          legal_history_all_versions: "All versions",
          legal_history_loading: "Loading the archived text…",
          legal_history_error: "The archived text could not be loaded. You can open the original file here:",
          legal_history_doc_terms: "Terms of Service",
          legal_history_doc_dpa: "Data Processing Agreement (DPA)",
          legal_history_doc_privacy: "Privacy Policy",
          legal_history_doc_subprocessors: "Sub-processors",
          legal_history_doc_cookies: "Cookie Policy",
          legal_history_doc_data_deletion: "Data deletion",
          legal_history_doc_legal_notice: "Legal notice",
          footer_cursor_off: "Use normal cursor",
          footer_cursor_on: "Use InvokeApp cursor",
          home_footer_resources_hub: "Resources",
          home_footer_company_jobs: "Jobs",
          home_footer_company_press: "Press",
          resources_page_title: "Resources",
          resources_page_description: "Kits, webinars and articles from InvokeApp to build and sell AI services.",
          resources_page_intro: "Everything we publish to help you build and sell AI services: kits, webinars and articles.",
          resources_aikit_text: "Templates and guides to define, price and deliver your first AI service.",
          resources_open: "Open",
          resources_webinars_title: "Webinars and community",
          resources_webinars_text: "Live sessions and the Meetup community for agencies, freelancers and consultants working with AI.",
          resources_webinars_cta: "Go to Meetup",
          resources_blog_title: "Blog",
          resources_blog_text: "Articles on how agencies are building and selling AI services.",
          jobs_page_title: "Jobs",
          jobs_page_description: "Work at InvokeApp.",
          jobs_page_intro: "This is where we will publish the positions we open.",
          jobs_none_title: "No open positions right now",
          jobs_none_text: "If you would like to work with us anyway, send us your CV and tell us what you would bring.",
          jobs_mail_subject: "Application - InvokeApp",
          jobs_apply_cta: "Send an open application",
          press_page_title: "Press",
          press_page_description: "InvokeApp brand resources: logos, colours and press contact.",
          press_page_intro: "Brand resources for press, partners and events. Please use the logos as they are, without changing their colours or proportions.",
          press_logo_color: "Logo",
          press_logo_white: "Logo on dark backgrounds",
          press_logo_negative: "Negative logo",
          press_logo_cyan: "Cyan logo",
          press_icon_title: "Icon",
          press_icon_text: "For avatars and small spaces.",
          press_colors_title: "Brand colours",
          press_color_cyan: "Cyan",
          press_color_violet: "Violet",
          press_contact_title: "Press contact",
          press_contact_text: "Interviews, information or other brand formats.",
          press_mail_subject: "Press - InvokeApp",
          bvb_kicker: "Build vs Buy",
          bvb_title: "Build it yourself or start selling this month?",
          bvb_subtitle: "Building your own AI services platform sounds cheaper until you add up the time, the team and everything that has to keep working. This is what changes when you buy.",
          bvb_build: "Build it yourself",
          bvb_buy: "With InvokeApp",
          bvb_race_kicker: "Time to revenue",
          bvb_race_title: "While you build, others are already selling",
          bvb_race_text: "Same timeline, two paths. Building means every step comes before your first sale. With InvokeApp the setup is short and the rest of the time is spent selling.",
          bvb_race_build_1: "Choose models",
          bvb_race_build_2: "Infrastructure",
          bvb_race_build_3: "Integrations",
          bvb_race_build_4: "Testing",
          bvb_race_build_5: "Security",
          bvb_race_build_6: "Interface",
          bvb_race_buy_1: "Activate",
          bvb_race_buy_2: "Configure",
          bvb_race_buy_3: "Brand it",
          bvb_race_selling: "Selling to your clients",
          bvb_race_build_finish: "Finally, first sale",
          bvb_race_buy_finish: "First sale",
          bvb_race_axis_start: "Today",
          bvb_race_axis_time: "Time",
          bvb_ice_kicker: "What you do not see",
          bvb_ice_title: "Your client sees the tip. Someone has to carry the rest",
          bvb_ice_text: "An AI service is the visible part. Underneath there is everything that keeps it running every day.",
          bvb_ice_tip: "Your AI service",
          bvb_ice_l1: "Models and prompts",
          bvb_ice_l2: "Integrations: CRM, WhatsApp, email",
          bvb_ice_l3: "Hosting and scaling",
          bvb_ice_l4: "Monitoring and failures",
          bvb_ice_l5: "Model updates",
          bvb_ice_l6: "Support and maintenance",
          bvb_ice_yours: "On you",
          bvb_ice_included: "Included",
          bvb_cost_kicker: "Cost over time",
          bvb_cost_title: "Building costs up front, and then keeps costing",
          bvb_cost_text: "Building starts with a big investment and keeps growing with maintenance and changes. Buying is a predictable fee from day one.",
          bvb_cost_aria: "Accumulated cost over time: building grows faster than buying",
          bvb_cost_gap: "What you do not spend",
          bvb_cost_axis_x: "Time",
          bvb_cost_axis_y: "Accumulated cost",
          bvb_cost_note_upfront: "Initial investment",
          bvb_verdict_title: "Why buying pays off",
          bvb_verdict_1_title: "Sell sooner",
          bvb_verdict_1_text: "Spend your time selling AI services, not building the platform behind them.",
          bvb_verdict_2_title: "Focus on your clients",
          bvb_verdict_2_text: "Your team stays on strategy and accounts, not on servers and integrations.",
          bvb_verdict_3_title: "Grow without rebuilding",
          bvb_verdict_3_text: "New processes and clients on the same platform, with your agency in charge of the relationship.",
          bvb_verdict_cta: "Book a demo",
          privacy_meta: "InvokeApp Privacy Policy: how MARTÍNEZ CAMPOY CONSULTING, S.L. processes personal data, including Google and Meta data and AI.",
          terms_meta: "InvokeApp Terms of Service — the rules for using our website, platform and integrations.",
          page_title_platform: "Platform",
          page_title_changelog: "Changelog",
          page_title_guidelines: "Guidelines",
          feature_vote_page_title: "Feature Roadmap",
          feature_vote_page_subtitle: "Vote for what we build next",
          feature_vote_section_mini: "Have a say",
          feature_vote_section_title: "What should we build next?",
          feature_vote_section_desc: "Vote on upcoming features and help shape our roadmap. The most requested features get prioritized.",
          feature_vote_total_votes: "total votes",
          feature_vote_votes: "votes",
          feature_vote_voted: "Voted",
          feature_vote_button: "Vote",
          feature_vote_sort_default: "Default order",
          feature_vote_sort_votes: "Most votes",
          feature_vote_title_1: "Advanced Analytics Dashboard",
          feature_vote_desc_1: "Real-time KPIs with drill-down charts, custom date ranges, and exportable reports for client presentations.",
          feature_vote_title_2: "Smart Workflow Automation",
          feature_vote_desc_2: "AI-powered triggers that learn from your team's patterns and auto-suggest optimizations for recurring tasks.",
          feature_vote_title_3: "Third-Party Integrations Hub",
          feature_vote_desc_3: "Connect with 100+ tools including Slack, Notion, HubSpot, and QuickBooks through a unified integration manager.",
          feature_vote_title_4: "AI Content Generator",
          feature_vote_desc_4: "Generate client proposals, reports, and email sequences using your agency's brand voice and past deliverables.",
          feature_vote_title_5: "Client Portal 2.0",
          feature_vote_desc_5: "Client dashboard with your agency's logo where clients track progress, download reports, and approve deliverables in real time.",
          feature_vote_title_6: "Automated QA Testing",
          feature_vote_desc_6: "Run regression tests on automations after every update and get notified before clients catch a broken workflow.",
          faq_page_title: "FAQs",
          faq_page_subtitle: "Answers for agencies running InvokeApp",
          faq_section_title: "Frequently Asked Questions",
          faq_section_subtitle: "Clear, direct answers to help you launch and scale fast.",
          faq_schema_title: "2. FAQ Schema (Dominate \"How...\" searches)",
          faq_schema_text:
            "If your Features or Home page has a FAQ section, don’t leave it as plain text. Using FAQ Schema helps Google show your questions directly in search results, taking more space and winning clicks from competitors.",
          guidelines_page_title: "Guidelines",
          guidelines_page_subtitle: "Standards for agencies operating Invokeapp",
          guidelines_intro_title: "Operating guidelines",
          guidelines_intro_subtitle: "Best practices to protect delivery quality and client outcomes.",
          guidelines_item_1: "Define the outcome and KPIs before activation.",
          guidelines_item_2: "Review automations weekly to prevent drift.",
          guidelines_item_3: "Report results consistently to secure renewal.",
          changelog_page_title: "Changelog",
          changelog_page_subtitle: "Product updates for agencies using Invokeapp",
          changelog_intro_title: "Latest updates",
          changelog_intro_subtitle: "Release notes and operational improvements",
          changelog_item_1: "New automation templates and AI workflows",
          changelog_item_2: "Reporting and KPI insights enhancements",
          changelog_item_3: "Platform stability and performance updates",
          changelog_empty: "No updates available right now.",
          platform_page_title: "Invokeapp Platform",
          platform_page_subtitle: "The operating layer for agencies delivering Automation and AI",
          platform_hero_kicker: "Agency Mode",
          platform_hero_title: "Customer service, appointments and sales for your clients, without a technical team",
          platform_hero_subtitle:
            "Invokeapp is the platform your agency uses to run customer service, appointments, CRM and sales follow-up for its clients, with AI assisting each process. You keep the client relationship and the recurring revenue while we run the technology.",
          platform_hero_bullet_1: "Delivery under your agency's control and client-ready reporting",
          platform_hero_bullet_2: "Automations, AI assistants, and integrations already connected",
          platform_hero_bullet_3: "Operational monitoring, alerts, and quality control",
          platform_hero_bullet_4: "Data layer that turns results into renewal",
          platform_cta_primary: "Go to the platform",
          platform_cta_secondary: "Talk to our team",
          platform_form_title: "Agency Mode",
          platform_form_subtitle: "Connect. Scale. Automate.",
          platform_form_section_company: "Company details",
          platform_form_company_name: "Company Name",
          platform_form_section_language: "Specify language",
          platform_form_language_en: "English",
          platform_form_language_es: "Spanish",
          platform_form_section_contact: "Admin contact",
          platform_form_first_name: "First Name",
          platform_form_last_name: "Last Name",
          platform_form_email: "Email Address",
          platform_form_section_security: "Security",
          platform_form_password: "Password",
          platform_form_password_confirm: "Repeat Password",
          platform_form_password_toggle: "Toggle password visibility",
          platform_form_section_business: "Business type",
          platform_form_business_entrepreneur_title: "Entrepreneur",
          platform_form_business_entrepreneur_desc:
            "Ideal for freelancers and solopreneurs. Start automating simple workflows.",
          platform_form_business_studio_title: "Studio",
          platform_form_business_studio_desc:
            "Designed for creative studios and small teams.",
          platform_form_business_agency_title: "Agency",
          platform_form_business_agency_desc:
            "Perfect for growing agencies. Unlock advanced workflows and multi-channel automation.",
          platform_form_business_corporate_title: "Corporate",
          platform_form_business_corporate_desc:
            "Tailored for corporations managing multiple teams and departments.",
          platform_form_business_enterprise_title: "Enterprise",
          platform_form_business_enterprise_desc:
            "Exclusive for large enterprises and tech builders.",
          platform_form_terms_prefix: "I accept the",
          platform_form_terms_link: "Terms and Conditions",
          platform_form_error_password: "Passwords do not match.",
          platform_form_error_terms: "Please accept the Terms and Conditions.",
          platform_form_error_email: "Enter a valid email address.",
          platform_form_error_required: "Complete all required fields.",
          platform_form_error_generic: "We could not create the account. Please try again.",
          platform_form_success: "Account created. Check your email to continue.",
          platform_form_submit: "Continue",
          platform_form_submit_loading: "Creating account...",
          platform_form_signin: "Already have an account?",
          platform_form_signin_link: "Sign in",
          platform_capabilities_title: "Capabilities you can monetize",
          caps_split_title: "Sell the whole system, or just the piece",
          caps_split_subtitle:
            "The same processes, packaged two ways: a playbook is the whole service, already sequenced into stages; the catalogue is each process on its own.",
          shop_tab_playbooks: "Playbooks",
          shop_tab_catalog: "Catalogue",
          caps_tabs_aria: "Playbooks or process catalogue",
          caps_playbooks_intro:
            "A playbook is the service already built: one or more processes chained into stages, in the order they switch on. It is designed to be bought whole, because the stages hold each other up — an appointment nobody reminds about or rescues when it falls through never gets invoiced — and each stage is meant to take over work that is done by hand today. That is why it is priced monthly rather than once.",
          caps_catalog_intro:
            "The catalogue is that same work in pieces: every process on its own and, where its commercial profile is already published, its price. Use it when you know what a given client is missing, or when you would rather build your own ladder. The processes a playbook is made of come from this very catalogue.",
          caps_playbooks_cta: "See the full ladder, stage by stage",
          platform_capabilities_subtitle:
            "Prebuilt systems your agency can sell as monthly retainers.",
          faq_q1: "How does InvokeApp help an agency with its clients' customer service, appointments and sales?",
          faq_a1:
            "InvokeApp gives you ready-made playbooks, integrations and client activation flows for customer service, appointments, CRM and sales follow-up, so you can deliver outcomes without building from scratch.",
          faq_q2: "How do I onboard a client without seeing their credentials?",
          faq_a2:
            "Use Secure Client Activation (SCA): clients connect their tools on a dedicated page and credentials remain private.",
          faq_q3: "How are workflows and playbooks delivered?",
          faq_a3:
            "Choose an integration, set the project context, and the workflow runs with monitoring, alerts, and analytics.",
          faq_q4: "How fast can we go live with a new client?",
          faq_a4:
            "Most agencies activate in hours; complex stacks typically take a few days depending on approvals.",
          faq_q5: "How do I measure results and ROI?",
          faq_a5:
            "InvokeApp tracks KPIs, conversions, and execution steps so you can report impact and defend renewals.",
          faq_q6: "Who manages the relationship with my clients?",
          faq_a6:
            "Your agency does: you set the offer and the process and you talk to your clients, while InvokeApp provides the platform as your technology partner.",
          platform_capability_1_title: "Infinite Content Engine",
          platform_capability_1_desc:
            "Turn one idea into LinkedIn, X, and Instagram content in hours.",
          platform_capability_2_title: "Lead Qualification via WhatsApp",
          platform_capability_2_desc:
            "An AI assistant filters and sends only hot leads to the CRM.",
          platform_capability_3_title: "Intelligent Performance Reports",
          platform_capability_3_desc:
            "Executive summaries that translate GA4 and Ads into business decisions.",
          platform_capability_4_title: "Executive Ghostwriting",
          platform_capability_4_desc:
            "Personal branding automation that monitors industry news.",
          platform_outcomes_title: "What changes for your agency",
          platform_outcomes_subtitle:
            "You sell the result; Invokeapp runs the delivery.",
          platform_outcomes_bullet_1: "Launch new retainers in weeks.",
          platform_outcomes_bullet_2: "Increase margins with standardized delivery.",
          platform_outcomes_bullet_3: "Reduce churn with clear reporting.",
          platform_outcomes_bullet_4: "Scale without hiring developers.",
          platform_outcomes_bullet_5:"Keep ownership of client relationships and billing.",
          platform_outcomes_panel_title: "What the platform includes",
          platform_outcomes_panel_subtitle:"Modules ready to deploy with end clients.",
          platform_outcomes_panel_item_1: "Workflow orchestration and integrations",
          platform_outcomes_panel_item_2: "AI assistants and proven templates",
          platform_outcomes_panel_item_3: "KPI database and executive reporting",
          platform_outcomes_panel_item_4: "Client deliverables portal and follow-up",
          platform_pillars_title: "Operational infrastructure for agencies",
          platform_pillars_subtitle:"Deliver consistently without building a technical team.",
          platform_pillar_1_title: "Delivery Engine",
          platform_pillar_1_desc:"Preconfigured workflows, integrations, and AI models.",
          platform_pillar_2_title: "Quality and Monitoring",
          platform_pillar_2_desc:"Automated checks, alerts, and QA for every account.",
          platform_pillar_3_title: "Client-ready Reporting",
          platform_pillar_3_desc:"Dashboards and summaries that justify the retainer.",
          platform_pillar_4_title: "Knowledge Layer",
          platform_pillar_4_desc:"Playbooks and context that compound delivery speed.",
          platform_steps_title: "How agencies scale with Invokeapp",
          platform_steps_subtitle:"A simple loop that turns delivery into recurring revenue.",
          platform_step_1_title: "Package the outcome",
          platform_step_1_desc:"Define the result you sell and the KPI you promise.",
          platform_step_2_title: "Deploy in our infrastructure",
          platform_step_2_desc:"We activate automations, AI assistants, and integrations.",
          platform_step_3_title: "Monitor, report, renew",
          platform_step_3_desc:"Your client sees results while you protect margins.",
          reviews_page_title: "Opiniones de Clientes",
          reviews_page_subtitle: "Opiniones de agencias que usan Invokeapp",
          reviews_intro_title: "Lo que dicen las agencias",
          reviews_intro_subtitle: "Feedback de operadores que entregan IA con Invokeapp.",
          reviews_quote_1: "Invokeapp nos permitió paquetizar entrega con IA sin equipo técnico.",
          reviews_quote_1_name: "Dueño de Agencia",
          reviews_quote_2: "Mejoramos margen y reducimos el caos operativo en semanas.",
          reviews_quote_2_name: "Responsable de Growth",
          reviews_quote_3: "Nuestros clientes reciben reporting claro y resultados cada mes.",
          reviews_quote_3_name: "Directora de Operaciones",
          investors_page_commercial_dossier_title: "Commercial Dossier",
          investors_page_commercial_dossier_description:
            "What InvokeApp is, who it serves and how it generates recurring revenue for agencies that run customer service, appointments and sales follow-up for their clients.",
          investors_page_commercial_dossier_download: "Download Dossier",
          investors_page_investor_deck_title: "Investor Deck",
          investors_page_investor_deck_description:
            "The investor presentation: market, product, business model, traction and growth plan.",
          investors_page_investor_deck_download: "Download Deck",
          home_footer_resources_reviews: "Opiniones",
          home_footer_resources_guidelines: "Guidelines",
          features_page_title: "Playbooks",
          features_page_subtitle: "A clear view of what Invokeapp delivers",
          features_intro_title: "Core capabilities",
          features_intro_subtitle: "Everything you need to sell AI delivery as an agency.",
          features_item_1: "White label automation and AI workflows",
          features_item_2: "Client-ready reporting and insights",
          features_item_3: "Lead qualification and routing systems",
          features_item_4: "Content engines and distribution pipelines",
          features_item_5: "Monitoring, alerts, and operational control",
          features_playbook_1_title: "Lead intake & qualification",
          features_playbook_2_title: "Content engine & distribution",
          features_playbook_3_title: "Client reporting & QBR",
          features_playbook_4_title: "Delivery ops & renewals",
          features_playbook1_card1_title: "Lead intake pipeline",
          features_playbook1_card1_desc: "Capture leads and standardize data in seconds.",
          features_playbook1_card2_title: "Speed-to-lead alerts",
          features_playbook1_card2_desc: "Notify your team the moment a form is submitted.",
          features_playbook1_card3_title: "Qualification snapshot",
          features_playbook1_card3_desc: "Summarize intent and fit with AI.",
          features_playbook2_card1_title: "AI content briefs",
          features_playbook2_card1_desc: "Generate outlines and briefs ready to publish.",
          features_playbook2_card2_title: "Multi-channel publishing",
          features_playbook2_card2_desc: "Distribute content across social and messaging.",
          features_playbook2_card3_title: "Performance recap",
          features_playbook2_card3_desc: "Auto-report clicks and conversions.",
          features_playbook3_card1_title: "Client KPI dashboard",
          features_playbook3_card1_desc: "Sync performance metrics into one view.",
          features_playbook3_card2_title: "Weekly executive summary",
          features_playbook3_card2_desc: "Send a clean recap to clients every week.",
          features_playbook3_card3_title: "QBR storyboard",
          features_playbook3_card3_desc: "Compile wins and results for quarterly reviews.",
          features_playbook4_card1_title: "Project kickoff automation",
          features_playbook4_card1_desc: "Automate onboarding and task creation.",
          features_playbook4_card2_title: "Delivery QA checklist",
          features_playbook4_card2_desc: "Ensure outputs meet your standards.",
          features_playbook4_card3_title: "Renewal signals",
          features_playbook4_card3_desc: "Track health and intervene before churn.",
          features_card_price_label: "Sell for",
          calc_roi_btn: "ROI",
          calc_roi_card: "this automation",
          calc_roi_section: "this playbook",
          features_playbook_total_label: "Total package",
          features_playbook_roi_label: "ROI",
          eco_infra_badge: "INFRASTRUCTURE",
          eco_infra_title: "Invokeapp AI Automation Platform",
          eco_infra_desc: "We build and maintain the playbooks, workflows, and AI agents. Think of us as the operating system for agency automation.",
          eco_ops_badge: "OPERATORS",
          eco_ops_title: "Certified Implementation Agencies",
          eco_ops_desc: "These agencies are trained and certified to implement our playbooks for end clients. Each tier reflects proven expertise.",
          eco_tier_elite: "Elite Operator",
          eco_tier_advanced: "Advanced Operator",
          eco_tier_certified: "Certified Operator",
          eco_clients_badge: "END CLIENTS",
          eco_clients_title: "Businesses That Need Automation",
          eco_clients_desc: "From dental clinics to auto repair shops — any business that wants to serve its customers better, keep its appointments in order and follow up every sale. In clinics, WhatsApp only handles appointment logistics (date, time, confirmation and reminder), never diagnoses, treatments or health data.",
          eco_cta_agency: "I\u2019m an agency \u2014 become an operator",
          eco_cta_business: "I need automation \u2014 find an operator",
          features_playbook_pricing_note: "Pricing shown is an estimated resale value for agencies, not what Invokeapp charges. You can sell processes individually, but playbooks are designed to increase your clients\u2019 lifetime value.",
          playbooks_banner_kicker: "Playbooks",
          playbooks_banner_title: "Launch playbooks that lift client LTV",
          playbooks_banner_description: "Discover packaged workflows your agency can sell quickly while keeping delivery consistent and measurable.",
          playbooks_banner_cta: "View playbooks",

          webinar_live_label: "Live webinar",
          webinar_cta: "Save your spot on Meetup",
          webinar_note: "Free · Limited seats",
          webinar_platform: "Online via Meetup",
          webinar_dismiss: "Dismiss",
          webinar_aria_label: "Webinar announcement",
          roi_calc_hero_kicker: "ROI Calculator",
          roi_calc_hero_title: "Estimate Your SaaS ROI",
          roi_calc_hero_subtitle: "See how much revenue and operational leverage you could generate selling AI automation systems.",
          roi_calc_scenario_conservative: "Conservative",
          roi_calc_scenario_growth: "Growth",
          roi_calc_scenario_scale: "Scale",
          roi_calc_mode_agency: "Agency / Implementer",
          roi_calc_mode_internal: "Internal Business",
          roi_calc_currency_eur: "\u20AC EUR",
          roi_calc_currency_usd: "$ USD",
          roi_calc_currency_gbp: "\u00A3 GBP",
          roi_calc_inputs_title_agency: "Agency Parameters",
          roi_calc_inputs_title_internal: "Business Parameters",
          roi_calc_inputs_subtitle: "Adjust the inputs below to match your business model.",
          roi_calc_label_clients: "Number of Clients",
          roi_calc_label_impl_fee: "Implementation Fee",
          roi_calc_label_retainer: "Monthly Retainer/Client",
          roi_calc_label_automations: "Automations Delivered/Month",
          roi_calc_label_token_cost: "Monthly AI Token Cost",
          roi_calc_label_platform_cost: "Platform Monthly Cost",
          roi_calc_label_setup_fee: "Initial Setup Fee",
          roi_calc_label_employees: "Employees",
          roi_calc_label_salary: "Avg Annual Salary",
          roi_calc_label_hours_lost: "Hours Lost/Week to Manual Work",
          roi_calc_label_hours_saved_week: "Hours Saved/Week via AI",
          roi_calc_label_processes: "AI Processes Implemented",
          roi_calc_tooltip_clients: "Number of active client accounts you manage.",
          roi_calc_tooltip_impl_fee: "One-time fee charged per automation implementation.",
          roi_calc_tooltip_retainer: "Monthly recurring fee per client.",
          roi_calc_tooltip_automations: "Number of automation projects delivered per month.",
          roi_calc_tooltip_hours_saved_internal: "Weekly hours recovered through AI automation.",
          roi_calc_tooltip_token_cost: "Monthly cost of AI token usage across all automations.",
          roi_calc_tooltip_platform_cost: "Monthly Invokeapp subscription cost.",
          roi_calc_tooltip_setup_fee: "One-time onboarding or integration fee.",
          roi_calc_tooltip_employees: "Total employees in your organization.",
          roi_calc_tooltip_salary: "Average annual employee salary.",
          roi_calc_tooltip_hours_lost: "Weekly hours lost to manual repetitive tasks.",
          roi_calc_tooltip_processes: "AI automation processes implemented.",
          roi_calc_results_title: "Your ROI Summary",
          roi_calc_results_subtitle: "Real-time calculation based on your inputs",
          roi_calc_metric_monthly_revenue: "Monthly Revenue",
          roi_calc_metric_annual_revenue: "Annual Revenue",
          roi_calc_metric_token_cost: "Monthly Token Cost",
          roi_calc_metric_net_profit: "Net Monthly Profit",
          roi_calc_metric_annual_profit: "Annual Profit (excl. setup)",
          roi_calc_metric_setup_fee: "Setup Fee",
          roi_calc_metric_time_savings: "Monthly Time Savings",
          roi_calc_metric_cost_reduction: "Monthly Cost Reduction",
          roi_calc_metric_productivity_gain: "Productivity Gain",
          roi_calc_metric_annual_savings: "Annual Savings",
          roi_calc_metric_roi_multiple: "ROI Multiple",
          roi_calc_metric_platform_cost: "Platform Cost/Month",
          roi_calc_chart_revenue_growth: "Projected Annual Revenue Growth",
          roi_calc_chart_monthly_comparison: "Monthly Comparison",
          roi_calc_chart_cost_impact: "Cost Impact",
          roi_calc_chart_monthly_savings_year: "Monthly Savings Over the Year",
          roi_calc_chart_roi_multiplier: "ROI Multiplier",
          roi_calc_comparison_without: "Without Automation",
          roi_calc_comparison_with: "With Automation",
          roi_calc_comparison_cost_lost: "Cost of Lost Time",
          roi_calc_comparison_savings_ai: "Savings with AI",
          roi_calc_gauge_platform_roi: "Platform ROI",
          roi_calc_gauge_platform_roi_desc: "How many times the platform cost is covered by net profit each month.",
          roi_calc_gauge_efficiency_roi: "Efficiency ROI",
          roi_calc_gauge_efficiency_roi_desc: "Monthly savings relative to platform investment.",
          roi_calc_payback_title: "Time to recover platform cost",
          roi_calc_payback_immediate: "Immediate",
          roi_calc_payback_month: "Month",
          roi_calc_payback_months: "Months",
          roi_calc_footer_msg_strong: "This platform is not an expense \u2014 it\u2019s a revenue infrastructure.",
          roi_calc_footer_msg_prefix: "With just",
          roi_calc_footer_msg_one_client: "1 client",
          roi_calc_footer_msg_employees: "employees",
          roi_calc_footer_msg_suffix: "you cover the platform cost. Everything else is margin.",
          roi_calc_playbook_selected: "Workflow selected:",
          roi_calc_playbook_selected_section: "Playbook selected:",
          roi_calc_btn_share: "Share",
          roi_calc_btn_book_demo: "Book Demo",
          demo_page_title: "Live Demo",
          demo_page_subtitle: "See the platform in action and map your first AI workflow",
          demo_video_kicker: "Platform walkthrough",
          demo_video_title: "Watch this Invokeapp video and book a call with us",
          demo_video_description:
            "From intake to reporting, this video shows how agencies deploy automation, AI assistants, and KPI tracking without extra ops.",
          demo_video_bullet_1: "Client-ready workflows",
          demo_video_bullet_2: "Automated reporting",
          demo_video_bullet_3: "Fast onboarding",
          demo_calendar_kicker: "Book your slot",
          demo_calendar_title: "Choose a time for your demo",
          demo_calendar_subtitle:
            "Pick a date and we’ll tailor the walkthrough to your agency.",
          demo_intro_title: "Ready to see your use case?",
          demo_intro_subtitle:
            "Tell us your goals and we’ll show the exact flow you can launch.",
          demo_cta: "Book a Demo",
          demo_calendar_cta: "Open calendar",
          operators_page_title: "Operators",
          operators_page_subtitle: "Awarded agencies recognized by performance",
          operators_intro_title: "Performance tiers",
          operators_intro_subtitle: "Operators are agencies with consistent delivery and outstanding client outcomes.",
          operators_level_1: "Certified Operator",
          operators_level_2: "Advanced Operator",
          operators_level_3: "Elite Operator",
          operators_directory_title: "Our operators",
          operators_directory_subtitle: "Certified agencies delivering with Invokeapp.",
          operators_visit_site: "Visit website",
          operators_empty: "No operators to show yet.",
          operators_error: "We couldn't load the operators. Please try again later.",
          home_footer_resources_operators: "Operators",
          home_footer_platform_features: "Playbooks",
          home_footer_platform_demo: "Demo",
          home_footer_sales_followup: "AI sales follow-up",
          home_footer_sales_followup_to: "/ai-sales-follow-up?lang=en",
          home_footer_consulting: "AI consulting",
          home_footer_consulting_to: "/ai-consulting?lang=en",
          home_footer_contact_affiliates: "Affiliates",
          home_footer_contact_agencies: "Agencies",
          home_footer_contact_partners: "Partners",
          home_footer_contact_product: "Product",
          home_footer_contact_scale: "Scale",
          home_footer_contact_explore: "Explorar",
          google_for_startups_label: "Google for Startups",
          google_for_startups_tooltip:
            "Selected by Google for Startups to scale our infrastructure with high-performance cloud technology.",
          partner_page_title: "Partner Program",
          partner_page_subtitle: "Become an Invokeapp technology partner",
          partner_hero_kicker: "Partner Program",
          partner_hero_title: "Implement InvokeApp with your clients",
          partner_hero_subtitle: "Offer customer service, appointments, CRM and sales follow-up to your clients with recurring revenue, while we run the platform.",
          partner_hero_cta_primary: "Request Partnership",
          partner_hero_cta_secondary: "Learn More",
          partner_program_title: "What the Technology Partner Program Includes",
          partner_program_subtitle: "A ready-to-use platform for agencies that implement customer service, appointments and sales follow-up for their clients.",
          partner_program_col_1_title: "Commercial Ownership",
          partner_program_col_1_desc: "You control pricing, positioning, and the client relationship. We provide and maintain the platform you deliver with.",
          partner_program_col_1_bullet_1: "Demos, implementation and first-level support by your agency",
          partner_program_col_1_bullet_2: "Recurring billing stays with your agency",
          partner_program_col_1_bullet_3: "Client-facing reporting and outcomes",
          partner_program_col_2_title: "Operational Infrastructure",
          partner_program_col_2_desc: "We provide the systems, automation, and AI workflows to deliver consistently at scale.",
          partner_program_col_2_bullet_1: "Proven playbooks and implementations",
          partner_program_col_2_bullet_2: "Monitoring, alerts, and quality control",
          partner_program_col_2_bullet_3: "Support for rollout and optimization",
          partner_benefits_paragraph: "The program is designed for agencies that want to scale AI delivery without hiring engineers. You keep control of margins while we ensure execution is reliable. We also offer an incentives program that rewards partners who expand accounts, maintain retention, and grow MRR month over month.",
          partner_features_title: "What You Get",
          partner_features_subtitle: "Everything you need to sell AI delivery without building tech.",
          partner_feature_1_title: "White Label Execution",
          partner_feature_1_desc: "We operate the delivery layer while you own the client and billing.",
          partner_feature_2_title: "Fast Time to Revenue",
          partner_feature_2_desc: "Launch offers in weeks with proven systems and playbooks.",
          partner_feature_3_title: "Reliable Operations",
          partner_feature_3_desc: "Monitoring, reporting, and automation that scales with your clients.",
          partner_feature_4_title: "Margin Protection",
          partner_feature_4_desc: "Predictable delivery costs so you keep control of pricing.",
          partner_benefits_title: "Why Agencies Choose It",
          partner_benefits_subtitle: "A simple model that upgrades your offer without adding headcount.",
          partner_benefit_1: "No engineers or AI team required",
          partner_benefit_2: "Retainers justified with clear reporting",
          partner_benefit_3: "Operations run on repeatable systems",
          partner_benefit_4: "You keep the commercial relationship",
          partner_social_title: "Partner Proof",
          partner_social_subtitle: "Agencies scaling delivery with Invokeapp.",
          partner_testimonial_1_quote: "We launched a new AI retainer in 30 days without hiring.",
          partner_testimonial_1_name: "Marina A.",
          partner_testimonial_1_company: "Growth Studio",
          partner_testimonial_2_quote: "Our team finally sells AI without technical chaos.",
          partner_testimonial_2_name: "Luis C.",
          partner_testimonial_2_company: "Demand Ops",
          partner_testimonial_3_quote: "Margins improved and delivery is now predictable.",
          partner_testimonial_3_name: "Sofia R.",
          partner_testimonial_3_company: "ScaleUp Agency",
          partner_final_kicker: "Ready to partner",
          partner_final_title: "Turn AI delivery into recurring revenue",
          partner_final_cta: "Request Partnership",
          partner_intro_mini: "Partnership",
          partner_intro_title: "Add AI delivery without building the tech",
          partner_intro_subtitle: "Invokeapp lets agencies resell automation and AI under their own brand while we run execution.",
          partner_offer_title_1: "White Label Delivery",
          partner_offer_desc_1: "You own the client relationship and recurring billing. We run the infrastructure and operations.",
          partner_offer_title_2: "Fast Time to Revenue",
          partner_offer_desc_2: "Launch new AI-powered offers without hiring developers or building internal tooling.",
          partner_offer_title_3: "Agency-Controlled Margins",
          partner_offer_desc_3: "Keep pricing control and protect margin with predictable delivery costs.",
          partner_how_mini: "How It Works",
          partner_how_title: "From partner to recurring revenue",
          partner_how_step_1_title: "Apply & Qualify",
          partner_how_step_1_desc: "We validate your fit and the offers you want to sell.",
          partner_how_step_2_title: "Launch Offers",
          partner_how_step_2_desc: "We configure the systems and hand you a sellable playbook.",
          partner_how_step_3_title: "Operate & Scale",
          partner_how_step_3_desc: "You sell the outcome. We operate the delivery behind the scenes.",
          partner_requirements_mini: "Requirements",
          partner_requirements_title: "What we look for",
          partner_requirements_title_1: "Agency with Active Clients",
          partner_requirements_desc_1: "You already sell recurring services and want higher-margin AI delivery.",
          partner_requirements_title_2: "Commitment to Outcomes",
          partner_requirements_desc_2: "You focus on client results and long-term retention.",
          partner_identity_title: "Dynamic Brand Identity",
          partner_identity_logo: "[LOGO_PARTNER] in the top bar (4:1 ratio)",
          partner_identity_color: "[PRIMARY_COLOR] applied to CTAs and active states",
          partner_identity_domain: "[CUSTOM_DOMAIN] across client URLs",
          partner_structure_title: "Interface Structure",
          partner_structure_sidebar: "Collapsible sidebar: Pages, Sections, Global Styles, AI Agent, Media",
          partner_structure_canvas: "Central canvas with device preview (Desktop, Tablet, Mobile)",
          partner_structure_topbar: "Top bar: project selector, agent status, publish, SMTP",
          partner_admin_title: "Partner Settings (Admin)",
          partner_admin_email: "Email Module",
          partner_admin_support: "Support Module",
          partner_admin_domain: "Domain Module",
          partner_domain_label: "CUSTOM_DOMAIN",
          partner_project_select: "Select project / client",
          partner_agent_status: "Agent: Online",
          partner_publish_button: "Publish to Client Domain",
          partner_smtp_button: "SMTP Settings",
          partner_sidebar_title: "Toolbox",
          partner_sidebar_pages: "Pages",
          partner_sidebar_sections: "Sections",
          partner_sidebar_styles: "Global Styles",
          partner_sidebar_ai: "AI Agent Settings",
          partner_sidebar_media: "Media",
          partner_canvas_placeholder: "Live AI render preview",
          partner_admin_mini: "Partner Settings",
          partner_admin_heading: "Admin Configuration",
          partner_admin_email_desc: "Host, port, user and password so notifications go out from your agency email.",
          partner_admin_support_desc: "Floating support button routed to your ticketing or chat system.",
          partner_admin_domain_desc: "Validate CNAME/A records pointing to the Invokeapp infrastructure.",

          home_slider_title_superior_one: "Scale Without Hiring",
          home_slider_title_superior_two: "Systems for Modern Agencies",
          home_slider_title_main_copy_one1: "Turn your operations into ",
          home_slider_title_main_copy_one2: "repeatable systems clients pay for",
          home_slider_title_main_copy_two1: "Run on workflows + insight, ",
          home_slider_title_main_copy_two2: "not on chaos and heroics",

          home_two_features_title_superior_mini: "Agency-First Systems",
          home_two_features_title_one: "Build ",
          home_two_features_title_two: "a sellable agency",
          home_two_features_subtitle:
            "Stop improvising. Deploy proven systems that protect margins, standardize delivery, and make growth predictable. Less manual work, more leverage, clearer outcomes for clients.",
          home_two_features_button_text: "See the Systems",
          
          // home_techgrid_kicker: "Signal Grid",
          // home_techgrid_title: "A living surface for every workflow",
          // home_techgrid_text:"Watch the operational layer pulse in real time as data moves across your stack.",


          home_techgrid_kicker: "Subscribe. Activate. Serve your clients.",
          // home_techgrid_title: "Infrastructure ready to increase your revenue",
          home_techgrid_title: "Customer service, appointments and sales follow-up for agencies and their clients",
          home_techgrid_text: "The platform you activate by subscription: ready-built processes for customer service, appointments, CRM and sales follow-up that you set up for each client, with AI assisting along the way. No technical hires.",
          home_techgrid_cta_secondary: "See pricing",

          // Banner de la auditoría gratuita (home): habla de VENDER IA a los
          // clientes de la agencia, en linea con el hero, no de automatizar por dentro.
          ai_audit_kicker: "Free audit for agencies",
          ai_audit_title: "We review your agency and show you which processes you can offer your clients",
          ai_audit_text:
            "A 30-minute session where we go through your client base and leave you with a concrete list: which customer service, appointment, CRM and sales follow-up processes you can offer your clients, at what price and how much margin you keep. No cost, no commitment.",
          ai_audit_cta: "Book my audit",
          

          wa_fab_title: "Chat with our AI receptionist",
          wa_fab_text: "It is the same one your clients can use for their own customer service. Try it on WhatsApp.",
          wa_fab_aria: "Open WhatsApp",
          wa_fab_close: "Dismiss message",

          dvm_headline: "Offer customer service, appointments and sales follow-up. We give you the whole system.",
          dvm_prefix: "With",
          dvm_all_solved: "All of it already solved.",
          dvm_lead: "Activate complete Playbooks to solve a need end to end, or pick individual processes from the Catalogue.",
          dvm_cta_playbooks: "Explore Playbooks",
          dvm_cta_catalog: "See the Catalogue",

          pbs_kicker: "How a Playbook works",
          pbs_title: "From choosing what to sell to proving the return",
          pbs_subtitle: "The same system, activated stage by stage. Scroll to walk through it.",
          pbs_stage_of: "Stage {{current}} of {{total}}",
          pbs_recommended: "Recommended",
          pbs_see: "See",
          pbs_no_passwords: "You never receive or store passwords.",
          pbs_roadmap: "In development",
          pbs_live: "Live",
          pbs_problem: "Problem it solves",
          pbs_result: "Result it produces",
          pbs_automates: "What it automates",
          pbs_price: "Suggested selling price",
          pbs_month: "month",
          pbs_impact: "Estimated impact",

          demo_modal_new_tab: "Open in a new tab",
          demo_modal_close: "Close the demo",

          discovery_kicker: "Live session",
          discovery_title: "Try the discovery session",
          discovery_subtitle: "A guided conversation that turns what your agency does today into a business blueprint: which processes to automate first, what to sell and where the margin is.",
          discovery_facade_title: "Start the discovery session",
          discovery_facade_text: "It opens right here. It takes a few minutes and you end up with a concrete plan.",
          discovery_facade_cta: "Start",
          discovery_iframe_title: "InvokeApp discovery session",
          discovery_open_tab: "Open in a new tab",

          home_sell_faq_title: "Frequently asked questions",
          home_sell_faq_q1: "Why not just build it with Lovable or n8n?",
          home_sell_faq_a1: "With those platforms you have to build it, test it and maintain it yourself. With InvokeApp it is already built and ready to offer directly to your clients.",
          home_sell_faq_q2: "Do I need technical skills?",
          home_sell_faq_a2: "No. Configure the services, adapt them to each client and start selling.",
          home_sell_faq_q3: "Who manages the relationship with my clients?",
          home_sell_faq_a3: "Your agency. You keep the relationship and the commercial proposal with your clients; InvokeApp is your technology partner.",
          home_sell_faq_q4: "Can I customize it for each client?",
          home_sell_faq_a4: "Yes. Each client has their own projects, agents, data, integrations and processes.",
          home_sell_faq_q5: "Does it connect with my current tools?",
          home_sell_faq_a5: "Yes. InvokeApp integrates with the platforms your agency and your clients already use.",
          home_sell_faq_q6: "What services can I sell?",
          home_sell_faq_a6: "Lead generation, sales follow-up, customer service, content, automation, data and reporting services.",
          home_sell_faq_q7: "Who takes care of maintenance?",
          home_sell_faq_a7: "We maintain the platform and its features so you can focus on selling and serving your clients.",
          home_sell_faq_q8: "How long does it take to get started?",
          home_sell_faq_a8: "You can start with the services already available, without building a solution from scratch.",
          home_techgrid_step_1_title: "You subscribe",
          home_techgrid_step_1_text: "Pick a plan and get into the platform. Nothing to install or build.",
          home_techgrid_step_2_title: "You activate the process",
          home_techgrid_step_2_text: "Choose it from the catalogue and configure it for each client.",
          home_techgrid_step_3_title: "You offer it as your agency's service",
          home_techgrid_step_3_text: "You keep the client relationship, set the price of your service and keep the margin.",
          home_techgrid_chip_one: "Ready-to-sell processes",
          home_techgrid_chip_two: "All clients, one panel",
          home_techgrid_chip_three: "From €149/month",
          home_two_features_card_title_one: "Margins & Capacity",
          home_two_features_card_description_one:
            "Replace manual delivery with repeatable systems that increase throughput without adding headcount.",
          home_two_features_card_title_two: "Operational Control",
          home_two_features_card_description_two:
            "Know what’s running, what’s failing, and what’s costing money—before clients notice.",
          home_two_features_card_title_three: "Retention by Trust",
          home_two_features_card_description_three:
            "Deliver clarity with automated reporting and insights clients understand and value.",
          home_two_features_card_title_four: "Conversion by Speed",
          home_two_features_card_description_four:
            "Capture, qualify, and follow up automatically so leads don’t die in the inbox.",

          home_about_title_mini: "The Operating Model",
          home_about_title_big: "Systems, Not Tools",
          home_about_subtitle:
            "InvokeApp helps agencies run like businesses: standardized delivery, monitored workflows, client-ready reporting, and a knowledge layer that compounds over time—without drowning your team in complexity.",
          home_about_caption_one: "Deployable Systems",
          home_about_caption_two: "Reliable Automation",
          home_about_caption_three: "Knowledge That Compounds",
          home_about_discover_services: "Explore Systems",

          home_capabilities_title_mini: "How We Work",
          home_capabilities_title_big: "From Chaos to Control",
          home_capabilities_subtitle:
            "We help agencies replace ad-hoc work with structured systems: build, deploy, monitor, and improve. Every system is designed to be sellable, measurable, and easy to operate.",
          home_capabilities_caption_one: "- Design the system",
          home_capabilities_caption_two: "- Deploy with guided steps",
          home_capabilities_caption_three: "- Monitor and improve",

          home_services_title_mini: "Core Systems",
          home_services_title_big: "What Agencies Deploy",
          home_services_title_mobileapps: "Content & Distribution Engine",
          home_services_subtitle_mobileapps:
            "Create, adapt, and publish content across channels with consistency and speed.",
          home_services_title_backend: "Lead Capture & Qualification System",
          home_services_subtitle_backend:
            "Capture leads, qualify intent, route opportunities, and trigger follow-ups automatically.",
          home_services_title_consulting: "Client Reporting & Insights System",
          home_services_subtitle_consulting:
            "Automate reporting clients understand, with insights you can act on and sell.",
          home_services_title_database: "Agency Operations Monitor",
          home_services_subtitle_database:
            "Track executions, failures, costs, and performance across your systems in one place.",
          home_services_title_analytics: "Profit & KPI Dashboard",
          home_services_subtitle_analytics:
            "See what drives revenue, what drains margin, and where to optimize delivery.",
          home_services_title_uiuxdesign: "Client Deliverable Hub",
          home_services_subtitle_uiuxdesign:
            "A clean client-facing layer: results, activity logs, reports, and next actions.",
          home_services_title_webapps: "Workflow Calendar & Scheduling",
          home_services_subtitle_webapps:
            "Schedule systems safely and repeatably—without manual reminders and missed runs.",
          home_services_title_saas: "Company Brain (Knowledge Layer)",
          home_services_subtitle_saas:
            "Store decisions, context, assets, and learnings so your agency never starts from zero.",

          home_contact_area_title_mini: "Talk Strategy",
          home_contact_area_title_big: "Want to make your agency scalable and sellable?",

          home_brands_customers_title_mini: "Built With Operators",
          home_brands_customers_title_big: "Designed for agencies that care about margin",
          home_brands_customers_subtitle:
            "Better systems create better outcomes. Less chaos. More consistency. More leverage.",

          core_coreprelaunch_title_mini: "Invokeapp Infrastructure",
          core_coreprelaunch_title_slogan: "The operating layer that turns services into recurring revenue",
          core_coreprelaunch_description:
            "Your agency keeps the client relationship and billing. Invokeapp runs the Automation and AI behind each delivery.",
          core_coreprelaunch_button_text: "Get early access",
          core_coreprelaunch_title_more_info: "What you gain by operating with Invokeapp",
          core_coreprelaunch_description1_more_info:
            "Standardize solutions, protect margins, and scale without hiring engineers or integration experts.",
          core_coreprelaunch_description2_more_info:
            "Sell the outcome, delegate execution, and renew month to month with reporting clients understand.",
          core_coreprelaunch_button_more_information: "Let's talk",
          home_core_start_cta: "Start in four steps",

          home_faqs_questions_title_superior_1: "Not another tool.",
          home_faqs_questions_title_superior_2: "It's your revenue engine.",
          home_faqs_questions_title_inferior_2:
            "We handle the technical layer so you can sell the outcome.",
          home_faqs_questions_button: "See how it works",
          home_faqs_questions_tileline_title_1:
            "What exactly does my agency sell with Invokeapp?",
          home_faqs_questions_tileline_subtitle_1:
            "You sell packaged operational outcomes: automation, AI, and reporting. We run the infrastructure.",
          home_faqs_questions_tileline_title_2: "Do I need developers or an AI team?",
          home_faqs_questions_tileline_subtitle_2:
            "No. Everything is ready to operate without code and with expert support.",
          home_faqs_questions_tileline_title_3: "How do I create recurring revenue?",
          home_faqs_questions_tileline_subtitle_3:
            "With monthly offers based on processes that deliver continuous value.",
          home_faqs_questions_tileline_title_4: "How fast can we launch?",
          home_faqs_questions_tileline_subtitle_4:
            "In weeks, not months. We use proven systems and adapt them to your offer.",

          home_integrations_title_mini: "Ready-to-monetize solutions",
          home_integrations_title_big: "Operational capabilities you can sell",
          home_integrations_item_1_title: "Infinite Content Strategy",
          home_integrations_item_1_desc:
            "From one idea to content for LinkedIn, X, and Instagram.",
          home_integrations_item_2_title: "WhatsApp Lead Qualification 24/7",
          home_integrations_item_2_desc:
            "Filters and sends only hot leads to your CRM.",
          home_integrations_item_3_title: "Intelligent Performance Reports",
          home_integrations_item_3_desc:
            "GA4 and Ads translated into business language.",
          home_integrations_item_4_title: "Executive Ghostwriting",
          home_integrations_item_4_desc:
            "CEO positioning with sector news monitoring.",
          home_integrations_item_5_title: "Automated Onboarding & Briefs",
          home_integrations_item_5_desc:
            "Collects data and assets without email back-and-forth.",
          home_integrations_item_6_title: "Lead Follow-Up & Reactivation",
          home_integrations_item_6_desc:
            "Sequences that recover stalled opportunities.",
          home_integrations_item_7_title: "Campaign Alerts & Anomalies",
          home_integrations_item_7_desc:
            "Warnings when performance drops so you act fast.",
          home_integrations_item_8_title: "Retention & Upsell Signals",
          home_integrations_item_8_desc:
            "Insights to renew accounts and expand services.",

          home_two_expert_tab_integrations: "Sell services",
          home_two_expert_tab_learning: "Operations",
          home_two_expert_tab_gamification: "Margin",
          home_two_expert_integration_title_line1: "Sell services",
          home_two_expert_integration_title_line2: "without building them yourself",
          home_two_expert_integration_description:
            "Launch automation offers clients understand and buy. Pre-structured processes so you start closing projects without relying on technical profiles or weeks of development.",
          home_two_expert_learning_title_line1: "Deliver projects",
          home_two_expert_learning_title_line2: "without operational chaos",
          home_two_expert_learning_description:
            "Centralize clients, data, and execution in one system. Avoid errors, disconnected tools, and hours lost managing every project.",
          home_two_expert_gamification_title_line1: "Turn every project",
          home_two_expert_gamification_title_line2: "into margin",
          home_two_expert_gamification_description:
            "Standardize delivery so every sale is profitable from day one. Less improvisation, more control, and more profit per client.",

          home_two_blogs_title_mini: "Latest news",
          home_two_blogs_title_big:
            "Stay up to date with automation, AI, and agency insights.",
          home_two_blogs_button: "Read more news",

          home_contact_title: "Contact",
          home_contact_address: "Invokeapp",
          home_contact_email: "Email Us",

          home_footer_title_company: "Company",
          home_footer_company_about_us: "Why InvokeApp",
          home_footer_company_services: "Systems",
          home_footer_company_consulting: "Strategy",
          home_footer_company_blog: "Insights",
          home_footer_company_policies: "Policies",
          home_footer_company_contactus: "Contact",
          home_footer_title_resources: "Resources",
          home_footer_resources_customers: "Case Studies",
          home_footer_resources_pricing: "Plans",
          home_footer_resources_news: "Updates",
          home_footer_resources_support: "Support",
          home_footer_resources_faqs: "FAQs",
          home_footer_title_usecases: "Systems",
          home_footer_usecases_uiuxdesign: "Client Deliverables",
          home_footer_usecases_mobileapp: "Content Engine",
          home_footer_usecases_apiintegration: "Integrations",
          home_footer_usecases_database: "Operations Monitor",
          home_footer_usecases_software: "Workflow Library",
          home_footer_usecases_analytics: "KPIs & Profit",
          home_footer_title_information: "Learn",
          home_footer_title_contact: "Contact",
          home_footer_platform_core: "Platform",
          home_footer_platform_pricing: "Pricing",
          home_footer_platform_plans: "Plans",
          home_footer_platform_partnerships: "Partnerships",
          home_footer_platform_docs: "Help center",
          home_footer_platform_changelog: "Changelog",
          home_footer_platform_playbook_demo: "Playbook demo",

          about_us_two_faq_title_mini: "Why It Works",
          about_us_two_faq_title_big_one: "Agency Systems",
          about_us_two_faq_title_big_two: "built for reliability",
          about_us_two_faq_function_one_title: "Simple On The Surface",
          about_us_two_faq_function_one_content:
            "Complex workflows, simple operation—so your team can deploy systems without becoming engineers.",
          about_us_two_faq_function_two_title: "Built for Consistency",
          about_us_two_faq_function_two_content:
            "Monitoring, logs, and safeguards so delivery doesn’t depend on luck or heroic effort.",
          about_us_two_faq_function_three_title: "Sellable Outcomes",
          about_us_two_faq_function_three_content:
            "Systems are packaged around results clients understand—reporting, performance, and measurable value.",

          about_us_two_achievement_title_mini: "Outcomes",
          about_us_two_achievement_title_big: "Leverage That Compounds",
          about_us_two_achievement_subtitle:
            "Standardize delivery, protect margins, and scale without hiring. Systems create capacity and trust.",
          about_us_two_achievement_function_one: "Repeatable delivery",
          about_us_two_achievement_function_two: "Monitored automation",
          about_us_two_achievement_discover_more: "See Examples",

          services_three_second_services_title: "Systems Library",
          services_three_second_services_subtitle:
            "Choose the systems you need now. Expand as your agency scales.",

          services_three_second_services_section_one_title_superior: "Content Engine",
          services_three_second_services_section_one_title: "Content Engine",
          services_three_second_services_section_one_subtitle:
            "Build a consistent content machine: plan, create, repurpose, and distribute across channels with minimal effort.",
          services_three_second_services_section_one_power_phrase: "Consistency at scale",

          services_three_second_services_section_two_title_superior: "Leads & CRM",
          services_three_second_services_section_two_title: "Leads & CRM",
          services_three_second_services_section_two_subtitle:
            "Capture and qualify leads, route them instantly, and trigger follow-ups so opportunities never stall.",
          services_three_second_services_section_two_power_phrase: "Speed wins deals",

          services_three_second_services_section_three_title_superior: "Reporting & KPIs",
          services_three_second_services_section_three_title: "Reporting & KPIs",
          services_three_second_services_section_three_subtitle:
            "Automated reporting and insights that reduce churn and justify your retainers with clarity.",
          services_three_second_services_section_three_power_phrase: "Retention through trust",

          services_three_second_services_section_four_title_superior: "Operations Monitor",
          services_three_second_services_section_four_title: "Operations Monitor",
          services_three_second_services_section_four_subtitle:
            "Logs, alerts, scheduling, and health checks so workflows stay reliable at client scale.",
          services_three_second_services_section_four_power_phrase: "Control without micromanagement",

          services_three_second_services_get_started_button: "Get Started",

          resources_download_ebook_section_title_mini: "Free playbook",
          resources_download_ebook_section_title: "Download the Agency Systems Playbook",
          resources_download_ebook_section_title_story_one:
            "A practical guide to package systems, standardize delivery, and protect margins—without adding headcount.",
          resources_download_ebook_section_title_story_one_author: "InvokeApp Team",
          resources_download_ebook_section_title_story_one_position: "Agency Systems Operators",
          resources_download_ebook_section_title_story_two:
            "Use the playbook to build repeatable offers, reduce churn, and turn operations into a competitive advantage.",
          resources_download_ebook_section_title_story_two_author: "Workflow Library",
          resources_download_ebook_section_title_story_two_position: "Your deployable systems catalog",
          resources_download_ebook_section_download_history:
            "Enter your email to receive the free playbook and templates for deploying sellable agency systems.",
          resources_download_ebook_section_language_ebook: "Playbook Language",
          resources_download_ebook_section_boton_download: "Download",

          blog_newsletter_title: "Newsletter",
          blog_newsletter_subtitle:
            "Weekly operator notes on scaling agencies with systems: workflows, reporting, positioning, and delivery.",
          blog_newsletter_newsletter_language: "Newsletter language",
          blog_newsletter_policy_one: "I accept the",
          blog_newsletter_policy_two: " Privacy Policy",
          blog_newsletter_email_adress_input: "Email Address",
          blog_newsletter_subscribe_button: "Subscribe",

          blog_recent_news_title: "Latest",
          blog_categories_title: "Topics",
          blog_recent_comments_title: "Recent Comments",
          blog_recent_comments_empty_title: "No comments yet",
          blog_recent_comments_empty_subtitle: "Be the first to leave one!",
          blog_read_more_card: "Read More",
          blog_comments_card: "Comments",

          blog_comments_reply: "Leave a Reply",
          blog_comments_email_not_published: "Your email address will not be published",
          blog_comments_consent:
            "By accepting the policy I consent to my name and email being stored and used to send me updates and news.",

          blog_details_article_category: "Topic:",
          blog_details_article_share: "Share:",
          blog_details_article_author: "Author",
          blog_details_article_last_comments: "Latest comments:",
          blog_details_no_content: "This article is not available in {{lang}} yet.",

          generic_your_message: "Your message...",
          generic_your_name: "Your Name",
          generic_your_email: "Your Email",
          generic_send_message: "Send Message",
          pricing_kicker: "Plans & Access",
          pricing_title: "Choose your plan",
          pricing_subtitle: "Start free, then scale with the plan that fits your delivery.",
          pricing_free_label: "Free",
          pricing_free_period: "No commitment",
          pricing_free_days: "{{days}}-day free trial",
          pricing_per_month: "/month",
          pricing_cta: "Talk to sales",
          // Etiqueta de cada plan según sus asientos (limits.team.seats): 1 = para usarlo tú; más = para venderlo.
          pricing_badge_use: "Use it",
          pricing_badge_use_hint: "For your own business",
          pricing_badge_sell: "Sell it",
          pricing_badge_sell_hint: "For your team and your clients",
          pricing_per_year: "/year",
          pricing_buy_now: "Buy now",
          pricing_finance_klarna: "Finance annual with Klarna",
          pricing_annual_note: "annual billing not available for this plan",
          pricing_free_cta: "Start free in the app",
          pricing_email_title: "Buy {{plan}}",
          pricing_email_body: "Enter your email to continue to secure checkout. We will create your account with this email after payment.",
          pricing_email_placeholder: "you@company.com",
          pricing_email_invalid: "Please enter a valid email.",
          pricing_continue: "Continue to payment",
          pricing_cancel: "Cancel",
          pricing_checkout_error: "We could not start the checkout. Please try again.",
          pricing_checkout_ok: "Payment completed! Check your email: we sent you the steps to access your new account.",
          pricing_checkout_ko: "The payment was cancelled. You can try again whenever you want.",
          pricing_default_desc: "Contact us to customize this plan for your agency.",
          pricing_error: "We could not load the plans. Please try again.",
          pricing_badge_popular: "Most Popular",
          pricing_badge_save: "Save {{pct}}%",
          pricing_toggle_monthly: "Monthly",
          pricing_toggle_annual: "Annual",
          pricing_plan_starter: "Starter",
          pricing_plan_professional: "Professional",
          pricing_plan_enterprise: "Enterprise",
          pricing_plan_starter_desc: "For small teams getting started with InvokeApp.",
          pricing_plan_professional_desc: "For growing agencies ready to scale operations.",
          pricing_plan_enterprise_desc: "For large organizations with custom needs.",
          pricing_feat_users: "Team members",
          pricing_feat_users_starter: "Up to 3",
          pricing_feat_users_pro: "Up to 15",
          pricing_feat_users_enterprise: "Unlimited",
          pricing_feat_integrations: "Integrations",
          pricing_feat_integrations_starter: "5 connectors",
          pricing_feat_integrations_pro: "All connectors",
          pricing_feat_integrations_enterprise: "All connectors + custom",
          pricing_feat_automations: "Automations",
          pricing_feat_automations_starter: "100 / month",
          pricing_feat_automations_pro: "5,000 / month",
          pricing_feat_automations_enterprise: "Unlimited",
          pricing_feat_support: "Support",
          pricing_feat_support_starter: "Email",
          pricing_feat_support_pro: "Priority chat & email",
          pricing_feat_support_enterprise: "Dedicated 24/7",
          pricing_feat_analytics: "Analytics",
          pricing_feat_analytics_starter: "Basic dashboard",
          pricing_feat_analytics_pro: "Advanced reporting",
          pricing_feat_analytics_enterprise: "Custom BI tools",
          pricing_feat_whitelabel: "Your agency's logo",
          pricing_feat_whitelabel_starter: "—",
          pricing_feat_whitelabel_pro: "Branded portal",
          pricing_feat_whitelabel_enterprise: "On the portal and reports",
          pricing_feat_api: "API access",
          pricing_feat_api_starter: "Basic",
          pricing_feat_api_pro: "Full",
          pricing_feat_api_enterprise: "Full + SLA",
          pricing_feat_onboarding: "Onboarding",
          pricing_feat_onboarding_starter: "Self-serve",
          pricing_feat_onboarding_pro: "Guided setup",
          pricing_feat_onboarding_enterprise: "Dedicated manager",
          pricing_annual_savings: "Save {{amount}}/year with annual billing",
          pricing_cta_starter: "Start Free",
          pricing_cta_pro: "Get Started",
          pricing_cta_enterprise: "Contact Us",
          how_it_works_page_title: "How It Works",
          how_it_works_page_subtitle: "From zero to operational in a few steps — see how InvokeApp works",
          how_it_works_step_1_title: "Discover",
          how_it_works_step_1_desc: "Tell us about your agency and goals. We'll map your current workflow and identify where InvokeApp can drive the most impact.",
          how_it_works_step_2_title: "Connect",
          how_it_works_step_2_desc: "Integrate your existing tools — CRMs, payment gateways, communication platforms — in minutes with our one-click connectors.",
          how_it_works_step_3_title: "Configure",
          how_it_works_step_3_desc: "Customize automations, add your agency's logo, and define your delivery playbooks to match your exact business processes.",
          how_it_works_step_4_title: "Launch",
          how_it_works_step_4_desc: "Go live with your first client. Your branded portal is ready, your team is onboarded, and your automations are running.",
          how_it_works_step_5_title: "Scale",
          how_it_works_step_5_desc: "Grow with confidence. Add more clients, unlock advanced analytics, and expand your capabilities as your agency evolves.",
          how_it_works_cta_title: "Ready to see it in action?",
          how_it_works_cta_desc: "Book a personalized demo and we'll walk you through the entire process.",
          how_it_works_cta_button: "Book a Demo",
          product_tour_page_title: "Product Tour",
          product_tour_page_subtitle: "Explore every corner of InvokeApp — a guided tour of the platform",
          product_tour_section_1_title: "Dashboard",
          product_tour_section_1_desc: "Your command center. Get a real-time snapshot of active clients, pending tasks, revenue metrics, and system health — all in one place.",
          product_tour_section_2_title: "Client Portal",
          product_tour_section_2_desc: "A portal with your agency's logo for each client. They can track progress, communicate with your team, and approve deliverables without leaving your ecosystem.",
          product_tour_section_3_title: "Automation Engine",
          product_tour_section_3_desc: "Design complex workflows without code. Trigger actions based on client behavior, schedule recurring tasks, and chain automations across multiple tools.",
          product_tour_section_4_title: "Playbooks & ROI",
          product_tour_section_4_desc: "Pre-built delivery playbooks that encode your best practices. Use the built-in ROI calculator to show clients the tangible value you deliver.",
          product_tour_section_5_title: "Analytics & Reports",
          product_tour_section_5_desc: "Go beyond basic metrics. Track client acquisition cost, lifetime value, delivery velocity, and team utilization with customizable dashboards.",
          product_tour_section_6_title: "Integrations Hub",
          product_tour_section_6_desc: "Connect with 50+ popular tools — CRMs, accounting software, communication platforms, and payment gateways — all managed from a single interface.",
          product_tour_cta_title: "Start your journey",
          product_tour_cta_desc: "Try InvokeApp free or schedule a walkthrough with our team.",
          product_tour_cta_demo: "Book a Demo",
          product_tour_cta_try: "Try Free",
          customer_portal_page_title: "Customer Portal",
          customer_portal_page_subtitle: "Access your InvokeApp dashboard, invoices, and support.",
          customer_portal_login_title: "Sign In",
          customer_portal_login_subtitle: "Enter your credentials to access your portal.",
          customer_portal_email_label: "Email",
          customer_portal_email_placeholder: "you@agency.com",
          customer_portal_password_label: "Password",
          customer_portal_password_placeholder: "Enter your password",
          customer_portal_remember: "Remember me",
          customer_portal_forgot: "Forgot password?",
          customer_portal_button: "Sign In",
          customer_portal_button_loading: "Signing in...",
          customer_portal_no_account: "Don't have an account?",
          customer_portal_signup: "Request access",
          customer_portal_error_required: "Please fill in all fields.",
          customer_portal_error_invalid: "Invalid email or password.",
          customer_portal_divider: "or continue with",

          portal_dash_page_title: "Dashboard — Customer Portal",
          portal_hero_kicker: "Your journey starts here",
          portal_hero_welcome_name: "Welcome, {{name}}",
          portal_hero_welcome: "Welcome aboard",
          portal_hero_subtitle: "Your account is active. Let's set everything up so you start seeing results from week one.",
          portal_hero_subtitle_done: "Setup complete — your platform is fully operational. Enjoy the ride.",
          portal_journey_progress: "{{done}} of {{total}} steps completed",
          portal_journey_kicker: "Onboarding",
          portal_journey_title: "Your launch journey",
          portal_journey_subtitle: "Follow these steps to get the most out of InvokeApp from day one.",
          portal_journey_current: "Current step",
          portal_journey_done: "Completed",
          portal_journey_pending: "Pending",
          portal_dash_panel_onboarding: "Onboarding",
          portal_journey_mark_done: "Mark as completed",
          portal_journey_mark_undone: "Mark as pending",
          portal_intro_skip: "Click to skip",
          portal_journey_completed_title: "Onboarding complete!",
          portal_journey_step_welcome_video_title: "A thank-you from the team",
          portal_journey_step_welcome_video_desc: "We recorded this short video to thank you for trusting us and show you what's ahead.",
          portal_journey_step_welcome_video_cta: "Watch the video",
          portal_journey_step_methodology_title: "The InvokeApp methodology",
          portal_journey_step_methodology_desc:
            "Our commitment is that your agency opens a new revenue line selling packaged services. What sits behind them is on us: defining the processes, maintenance, scalability, the legal side and compliance. You keep what you already do well: taking it to market, setting your price and being the face your client deals with.",
          portal_journey_step_certification_title: "Operator certification",
          portal_journey_step_certification_desc:
            "Operator certifications are coming. Once they open, your agency will be listed inside the platform with a link back to your site, so anyone looking for an automation in their sector can find you and hire you. We'll let you know as soon as they're live.",
          portal_journey_step_community_title: "Join the community",
          portal_journey_step_community_desc:
            "That's where we announce things first: new processes in the catalogue, plan changes and when operator certifications open. It's also where you can ask without opening a ticket, and see what other agencies are selling. The WhatsApp group is the day-to-day; Meetup is where we announce meetups and live sessions.",
          portal_journey_step_community_cta_whatsapp: "Join the WhatsApp group",
          portal_journey_step_community_cta_meetup: "Follow us on Meetup",
          portal_company_logo_alt: "Your company logo",
          portal_journey_step_setup_config_title: "First configuration steps",
          portal_journey_step_setup_config_desc:
            "Fill in your company details and upload your logo here. With that, the portals and reports your clients receive carry your brand from day one.",
          portal_journey_step_team_title: "Add your team",
          portal_journey_step_team_desc:
            "Create accounts for the people who will work in the platform. How many you can create depends on your plan. The addresses you add here are the ones we'll bring to the setup call, so nobody hears things second-hand.",
          portal_journey_step_setup_config_cta: "Upload my details and logo",
          portal_journey_step_team_cta: "Manage my team",
          portal_journey_step_client_demos_title: "Demos for your clients and your website",
          portal_journey_step_client_demos_desc:
            "Every playbook has an animated demo that shows, step by step, how the process will work for your client. It carries your agency’s brand (the logo you have just uploaded or, if you have set one up in the platform, your brand for external portals) and uses fictitious data, so you can show it safely. You can use it in two ways: send the demo link by WhatsApp or email, or embed the components on your own website with an iframe.",
          portal_journey_step_client_demos_howto:
            "Open “Components for your website” and create an embed key (only the account administrator can). You can have up to 10 active, one per website, and revoke them whenever you want.\nPick the playbook and copy the snippet: one iframe with every stage, or one per process if you prefer to spread them across your page.\nPaste it into your website as an HTML block (in WordPress, Webflow or Wix, the “HTML” or “Embed” block) and, once per page, the auto-height script shown below the snippets. It shows while your subscription is active.",
          portal_journey_step_client_demos_example_key: "pek_YOUR_KEY",
          portal_journey_step_client_demos_example_pb: "PLAYBOOK_ID",
          portal_journey_step_client_demos_example_title: "Your playbook demo",
          portal_journey_step_client_demos_example: "This is what a snippet looks like (yours, with your key, is copied in “Components for your website”):",
          portal_journey_step_client_demos_cta_demos: "See my demos",
          portal_journey_step_client_demos_cta_embeds: "Embed on my website",
          portal_company_title: "Your company details",
          portal_company_subtitle:
            "What you fill in here is what your clients see in the portals and in the branded reports they receive.",
          portal_company_group_private: "Legal details",
          portal_company_group_public: "Contact details and profile",
          portal_company_group_logo: "Your logo",
          portal_company_loading: "Loading your company details…",
          portal_company_load_error:
            "We couldn't load your company details. Try reloading the page.",
          portal_company_save: "Save changes",
          portal_company_saving: "Saving…",
          portal_company_saved: "Saved. Your details are up to date.",
          portal_company_save_error: "We couldn't save your changes.",
          portal_company_not_admin:
            "Only the account administrator can change the company details. Ask whoever created the account to do it.",
          portal_company_logo_cta: "Choose an image",
          portal_company_logo_ok: "Logo uploaded.",
          portal_company_logo_error: "We couldn't upload the logo.",
          portal_company_logo_too_big:
            "The image is too heavy (5 MB max). Try a lighter one.",
          portal_company_logo_bad_type:
            "That image format isn't supported. Use PNG, JPG, WEBP or GIF (an iPhone photo is usually HEIC: export it as JPG first).",
          portal_company_logo_current: "You already have a logo",
          portal_company_logo_none: "You haven't uploaded one yet",
          portal_company_field_name: "Trading name",
          portal_company_field_legal_name: "Legal name",
          portal_company_field_tax_id: "Tax ID",
          portal_company_field_industry: "Industry",
          portal_company_field_slogan: "Tagline",
          portal_company_field_description: "Description",
          portal_company_field_website: "Website",
          portal_company_field_email: "Contact email",
          portal_company_field_phone_number: "Phone",
          portal_company_field_address: "Address",
          portal_company_field_city: "City",
          portal_company_field_state: "State / Province",
          portal_company_field_country: "Country",
          portal_company_field_postal_code: "Postal code",
          portal_gate_title: "Your subscription isn't active yet",
          portal_gate_desc:
            "Your account exists, but we can't find an active subscription. As soon as the payment is confirmed the portal opens on its own, and your setup will be waiting here.",
          portal_gate_cta: "Choose my plan",
          portal_gate_note:
            "Just paid? The payment provider's confirmation can take a minute to reach us. Reload the page.",
          portal_gate_logout: "Sign out",
          portal_journey_step_contract_review_title: "Your service agreement",
          portal_journey_step_contract_review_desc: "Review your agreement calmly: scope, service levels and terms. Any questions, we're one email away.",
          portal_journey_step_contract_review_cta: "Request the agreement",
          portal_journey_step_setup_call_title: "Setup & audit call",
          portal_journey_step_setup_call_desc:
            "We book a session with your team: we audit your case and configure the platform with you. It comes near the end on purpose, so the call starts from your real data and not from a blank page.",
          portal_journey_step_setup_call_cta: "Book your call",
          portal_journey_step_platform_access_title: "Get into the platform",
          portal_journey_step_platform_access_desc:
            "Last step, and the one everything else was for. Open the platform with the same account you signed in with here and start switching on processes.",
          portal_journey_step_platform_access_cta: "Go to the platform",
          portal_journey_step_contract_sign_title: "Sign the agreement",
          portal_journey_step_contract_sign_desc: "The final step: sign the agreement and everything is officially up and running.",
          portal_journey_step_contract_sign_cta: "Request signature",
          portal_journey_step_contract_sign_note: "E-signature will be available soon; meanwhile we handle it by email.",
          portal_dash_stat_clients: "Active Clients",
          portal_dash_stat_automations: "Automations Run",
          portal_dash_stat_revenue: "Monthly Revenue",
          portal_dash_stat_delivery: "Avg. Delivery Time",
          portal_dash_panel_activity: "Recent Activity",
          portal_dash_panel_reports: "Reports",
          portal_dash_panel_settings: "Portal Settings",
          portal_dash_panel_team: "Manage Team",
          portal_dash_panel_billing: "Billing & Invoices",
          portal_dash_quick_actions: "Quick Actions",
          portal_dash_signout: "Sign out",
          portal_dash_role_admin: "Admin",
          portal_dash_role_editor: "Editor",
          portal_dash_role_user: "User",
          portal_dash_setting_1_label: "Email Notifications",
          portal_dash_setting_1_desc: "Receive alerts for completed automations",
          portal_dash_setting_2_label: "Two-Factor Auth",
          portal_dash_setting_2_desc: "Add an extra layer of security",
          portal_dash_setting_3_label: "API Access",
          portal_dash_setting_3_desc: "Manage your API keys and webhooks",
          portal_dash_badge_active: "Active",
          portal_dash_wip: "In progress",
          portal_dash_wip_title: "We are building this section",
          portal_dash_wip_activity:
            "You will see the real activity of your clients and processes here as soon as it is connected.",
          portal_dash_wip_reports:
            "You will be able to view and download your clients' reports here as soon as they are available.",
          portal_dash_wip_invoices:
            "The invoice history is being built. If you need an invoice now, write to us at letstalk@invokeapp.io.",
          portal_dash_plan_label: "{{name}} plan",
          portal_dash_billing_trial: "Trial",
          portal_dash_billing_inactive: "Inactive",
          portal_dash_billing_renews: "Current period until {{date}}",
          portal_dash_billing_no_plan: "No plan assigned",
          portal_dash_team_loading: "Loading team members...",
          portal_dash_team_empty: "No team members found.",
          portal_dash_invite_button: "Invite Member",
          portal_dash_invite_cancel: "Cancel",
          portal_dash_invite_email: "Email",
          portal_dash_invite_first_name: "First name",
          portal_dash_invite_last_name: "Last name",
          portal_dash_invite_sending: "Sending...",
          portal_dash_invite_send: "Send Invite",
          portal_dash_invite_error_required: "All fields are required.",
          portal_dash_invite_error_failed: "Failed to invite member.",
          portal_dash_invite_error_network: "Network error. Please try again.",
          portal_dash_billing_current: "Current Plan",

          gsw_step_account: "Account",
          gsw_step_session: "Sign in",
          gsw_step_plan: "Plan",
          gsw_step_onboarding: "Onboarding",
          gsw_account_title: "Create your account",
          gsw_account_subtitle: "The essentials only. You will be signed in automatically when you finish.",
          gsw_account_cta: "Create account",
          gsw_company: "Company",
          gsw_legal_name: "Legal name",
          gsw_tax_id: "VAT / Tax ID",
          gsw_optional: "Optional",
          gsw_first_name: "First name",
          gsw_last_name: "Last name",
          gsw_email: "Work email",
          gsw_password: "Password",
          gsw_password_hint: "At least 8 characters.",
          gsw_toggle_password: "Show or hide password",
          gsw_legal: "By creating an account you accept our",
          gsw_session_title: "Sign in",
          gsw_session_subtitle: "Your account is ready. Confirm your password to continue without leaving this page.",
          gsw_session_cta: "Sign in",
          gsw_login_manual: "Your account was created. Confirm your password to continue.",
          gsw_plan_title: "Choose your plan",
          gsw_plan_subtitle: "Pick the plan that fits you. Payment is handled by Stripe and you come straight back here.",
          gsw_plan_cta: "Pay and continue",
          gsw_plan_free_cta: "Continue with the free plan",
          gsw_plan_note: "No lock-in period: you can cancel giving thirty (30) calendar days of notice before renewal.",
          gsw_plan_needs_account: "Create your account in the first step to be able to pay: the plan is linked to your email.",
          gsw_done_title: "All set!",
          gsw_done_subtitle: "Your account is active. The last step is the guided onboarding in your Customer Portal.",
          gsw_done_cta: "Go to my Customer Portal",
          gsw_done_cta_login: "Sign in to your Customer Portal",
          gsw_checkout_cancelled: "The payment was not completed. You can pick a plan again whenever you want.",
          gsw_working: "Working...",
          gsw_error_required: "Please fill in all the fields.",
          gsw_error_email: "That email address does not look valid.",
          gsw_error_password: "The password needs at least 8 characters.",
          gsw_error_exists: "We could not create the account. That email may already be registered.",
          gsw_error_credentials: "Email or password are not correct.",
          gsw_error_generic: "Something went wrong. Please try again.",
          gsw_error_network: "Network error. Please check your connection and try again.",
          // Casilla obligatoria de condiciones (/get-started y compra en /pricing)
          legal_accept_prefix: "I accept InvokeApp's",
          legal_accept_terms: "Terms of Service",
          legal_accept_and: "and",
          legal_accept_dpa: "Data Processing Agreement",
          legal_accept_on_behalf: "on behalf of the company I represent.",
          legal_accept_privacy_prefix: "I have read the",
          legal_accept_privacy: "Privacy Policy",
          legal_accept_required: "To continue, accept the Terms of Service and the Data Processing Agreement.",

          roi2_kicker: "ROI calculator",
          roi2_title: "What can you bill with this?",
          roi2_subtitle: "Pick the processes you would sell, say how many clients you have and the margin you keep. Every figure comes from the catalogue commercial profile.",
          roi2_pick_processes: "Processes you would sell",
          roi2_selected_count: "{{n}} selected",
          roi2_clients: "Clients",
          roi2_margin: "Your margin",
          roi2_pick_to_start: "Pick at least one process to see the numbers.",
          roi2_no_data: "The catalogue does not have commercial data published yet. As soon as it does, this calculator fills in on its own.",
          roi2_without_profile: "{{n}} more processes are in the catalogue but do not have a published commercial profile yet, so they are left out of the calculation.",
          roi2_metric_revenue: "Recurring billing",
          roi2_metric_margin: "Your margin",
          roi2_metric_annual: "Margin per year",
          roi2_metric_hours: "Manual hours saved",
          roi2_metric_value: "Value delivered to clients",
          roi2_metric_value_hint: "per run, across all clients",
          roi2_per_month: "per month",
          roi2_per_year: "per year",
          roi2_breakdown: "Where the numbers come from",
          roi2_no_price: "No published price",
          roi2_per_use_note: "{{n}} of the processes you picked are priced per use, not monthly: they are not added to the recurring figure.",
          roi2_disclaimer: "Indicative catalogue estimates, not a measurement. The final price is always yours to set.",
          playbook_bundle_price: "Bundle price",
          playbook_month: "month",
          playbook_time_saved: "Time saved",
          playbook_simulate: "Simulate this playbook",
          playbook_simulate_one: "Simulate",
          playbook_no_commercial: "Commercial profile pending",
          playbook_no_commercial_card: "This process does not have a published commercial profile yet.",

          commercial_title: "Commercial profile",
          commercial_flip_open: "Commercial profile",
          commercial_flip_close: "Back",
          commercial_see_detail: "See full detail",
          commercial_pvp: "Suggested price",
          commercial_value: "Value generated",
          commercial_time_saved: "Manual time saved",
          commercial_runtime: "Run time",
          commercial_tokens: "AI tokens per run",
          commercial_observed_title: "Measured",
          commercial_observed_tokens: "Tokens",
          commercial_observed_runtime: "Run time",
          commercial_estimate_note: "Indicative catalogue estimates, not a measurement.",

          terms_index_title: "Contents",
          gs_page_title: "Getting started",
          gs_page_subtitle: "From sign-up to onboarding, step by step",
          gs_meta: "Step-by-step guide to getting started with InvokeApp: create your account, sign in to the platform, activate your plan and complete the onboarding in the Customer Portal.",
          gs_hero_kicker: "Step by step",
          gs_hero_title: "From zero to up and running in four steps",
          gs_hero_subtitle: "Here is exactly what happens from the moment you create your account until your platform is live with its first active process. No surprises.",
          gs_hero_cta_primary: "Create my account",
          gs_hero_cta_secondary: "See plans and pricing",
          gs_step_label: "Step {{n}}",
          gs_step_1_title: "Create your account",
          gs_step_1_desc: "Fill in the sign-up form with your company details. It takes under two minutes and you do not need a card to start.",
          gs_step_1_b1: "Company details, your name and a contact email",
          gs_step_1_b2: "Choose your platform language and business type",
          gs_step_1_b3: "You get a confirmation email with your access",
          gs_step_1_cta: "Create my account",
          gs_step_2_title: "Sign in to the platform",
          gs_step_2_desc: "With your credentials you access the Core: the workspace where your day to day happens, with projects, clients, processes and analytics.",
          gs_step_2_b1: "Web access at core.invokeapp.io, nothing to install",
          gs_step_2_b2: "Set up your company and invite your team",
          gs_step_2_b3: "Browse the catalogue of available processes and agents",
          gs_step_2_cta: "Go to the platform",
          gs_step_3_title: "Choose your plan and activate the subscription",
          gs_step_3_desc: "Compare the plans, pick the one that matches your volume and complete the payment. Your subscription activates instantly.",
          gs_step_3_b1: "Monthly or annual billing (annual can be financed with Klarna)",
          gs_step_3_b2: "Secure payment through Stripe, with no lock-in period",
          gs_step_3_b3: "Automatic invoicing and subscription management from your portal",
          gs_step_3_cta: "See plans and pricing",
          gs_step_4_title: "Complete the onboarding in the Customer Portal",
          gs_step_4_desc: "Once your payment is confirmed you get access to the Customer Portal, where we guide you step by step until everything is operational.",
          gs_step_4_b1: "A guided journey with your progress always in sight",
          gs_step_4_b2: "Materials, agreement and setup call all in one place",
          gs_step_4_b3: "When you finish, your platform is ready to sell with",
          gs_step_4_cta: "Go to the Customer Portal",
          gs_journey_title: "What the onboarding covers",
          gs_journey_1: "A thank-you video from the team",
          gs_journey_2: "The InvokeApp methodology",
          gs_journey_3: "Operator certification",
          gs_journey_4: "First configuration steps",
          gs_journey_5: "Review of your service agreement",
          gs_journey_6: "Personalized setup and audit call",
          gs_journey_7: "Signing the agreement",
          gs_ready_title: "What to have ready",
          gs_ready_subtitle: "Nothing complicated: with these at hand, the whole sign-up is done in an afternoon.",
          gs_ready_bullet_1: "Your company billing details",
          gs_ready_bullet_2: "A valid payment method (card)",
          gs_ready_bullet_3: "The accounts you want to connect (calendar, WhatsApp, social media...)",
          gs_ready_bullet_4: "Half an hour for the setup call with our team",
          gs_timeline_title: "How long it takes",
          gs_timeline_subtitle: "Realistic timings for each phase, end to end.",
          gs_timeline_item_1: "Sign-up: under 2 minutes",
          gs_timeline_item_2: "First sign-in and basic setup: 15-20 minutes",
          gs_timeline_item_3: "Plan activation and payment: 3 minutes",
          gs_timeline_item_4: "Full onboarding: at your own pace, usually within the first week",
          gs_faq_title: "Common questions about signing up",
          gs_faq_subtitle: "What people ask us most before getting started.",
          gs_faq_1_q: "Do I need a card to create an account?",
          gs_faq_1_a: "No. You can register and explore the platform before choosing a plan. A card is only required when you activate a paid subscription.",
          gs_faq_2_q: "Is there a lock-in period?",
          gs_faq_2_a: "No. The subscription runs in monthly periods with automatic renewal, and you can cancel by giving thirty (30) calendar days of notice before the renewal date.",
          gs_faq_3_q: "Can I change plan later on?",
          gs_faq_3_a: "Yes. Write to letstalk@invokeapp.io and we will adjust your plan to the volume of projects, clients or AI usage you need.",
          gs_faq_4_q: "Does the onboarding cost anything?",
          gs_faq_4_a: "The guided onboarding in the Customer Portal is included. Tailored implementation services, if you need them, are quoted separately.",
          gs_cta_title: "Would you rather we do it together?",
          gs_cta_subtitle: "If you prefer us to walk you through the sign-up, book a call and we will do it with you live.",
          sca_activation_page_title: "SCA Activation",
          sca_activation_page_subtitle: "Configure your branded activation flow",
          sca_activation_section_brand: "Branding",
          sca_activation_section_copy: "Copy",
          sca_activation_section_links: "Policies",
          sca_activation_field_agency: "Agency name",
          sca_activation_field_primary: "Primary color",
          sca_activation_field_title: "Title",
          sca_activation_field_subtitle: "Subtitle",
          sca_activation_field_cta: "Button label",
          sca_activation_field_security: "Security note",
          sca_activation_field_privacy: "Privacy URL",
          sca_activation_field_terms: "Terms URL",
          sca_activation_default_agency: "Invokeapp Agency",
          sca_activation_default_title: "Activate your workflow",
          sca_activation_default_subtitle: "Connect your accounts to start delivering results.",
          sca_activation_default_cta: "Connect now",
          sca_activation_default_security: "Your agency will never see your credentials.",
          sca_activation_preview_badge: "Live preview",
          sca_activation_terms: "Terms",
          sca_activation_privacy: "Privacy",
          sca_activation_launch: "Open live form",
          sca_activation_unknown: "Unknown",
          sca_activation_preview_difficulty: "Difficulty:",
          sca_activation_preview_category: "Category:",
          sca_activation_preview_status: "Status:",
          sca_video_kicker: "Client activation",
          sca_video_title: "A clean SCA flow your clients trust",
          sca_video_description:
            "Show clients a branded, secure activation page where they connect their accounts in minutes. You keep control of delivery without ever seeing their credentials.",
          sca_video_bullet_1: "Client experience with your agency's logo",
          sca_video_bullet_2: "Fast, guided onboarding",
          sca_video_bullet_3: "Security-first credential handling",
          generic_error_message: "We could not load the integrations. Please try again.",
          // --- Componentes embebibles (/embed) y su apartado del Customer Portal ---
          pba_meta_title: "Assistants by department — preview",
          pba_kicker: "Coming soon",
          pba_title: "Assistants by department",
          pba_lead: "One app with your company’s chat in front: a Manager receives each request and passes it to the right department assistant. Each one has its own colour, consults only what it is allowed to, and asks for your confirmation before acting.",
          pba_all_title: "All the assistants",
          pba_all_caption: "The Manager receives each request (also by voice note) and routes it to the right department assistant.",
          pba_comercial_title: "Sales",
          pba_comercial_caption: "Opportunities without follow-up, CRM records created with your confirmation, and proposals ready to review.",
          pba_finanzas_title: "Finance",
          pba_finanzas_caption: "Quarterly invoicing, pending payments and overdue invoices, with payment reminders you approve.",
          pba_marketing_title: "Marketing",
          pba_marketing_caption: "Follow-up emails and campaigns: it drafts them, measures what worked, and nothing goes out without your review.",
          pba_atencion_title: "Customer service",
          pba_atencion_caption: "What your customers ask most, and replies prepared with your business information so you only have to confirm.",
          portal_upcoming_title: "Coming soon",
          portal_upcoming_badge: "Preview",
          portal_upcoming_desc: "What we are about to launch. It is not public yet, but you can already see it, and show it to your clients with your brand.",
          portal_upcoming_open: "Open preview",
          upcoming_assistants_title: "Assistants by department",
          upcoming_assistants_desc: "Your company’s chat app: a Manager and one assistant per department (Sales, Finance, Marketing, Customer service), each with its own colour, voice notes and confirmation before acting.",
          portal_demo_desc: "Generate the demo link of each playbook with your agency’s brand: a page with all its animated stages, ready to send to your client by WhatsApp or email. It is the same link as the “Demo for your client” button in the app’s Store.",
          portal_demo_brand_hint: "The demo uses the logo and colour from your company profile (Settings). Without a logo, it shows your agency’s initial.",
          portal_demo_lang_label: "Demo language",
          portal_demo_open: "Open demo",
          portal_demo_copy_link: "Copy link",
          portal_demo_step: "Step {{n}}",
          portal_demo_processes: "{{n}} processes",
          portal_demo_company_loading: "Loading your company details…",
          portal_demo_company_error: "We could not load your company details, so we cannot generate the links with your brand.",
          portal_upcoming_wait: "The link appears once your company details have loaded, so it carries your brand.",
          portal_embed_no_company: "Your user is not linked to any company, so it cannot have embed keys. Please contact support to fix it.",
          portal_embed_keys_forbidden: "Your user does not have access to this account's embed keys.",
          pbe_loading: "Loading…",
          pbe_scene_pending: "Illustrated preview coming soon.",
          pbe_simulation: "Demo with fictional data: names and figures are illustrative. In the real service, AI agents always identify themselves as such.",
          pbe_stage: "Stage {{n}}",
          portal_dash_panel_embeds: "Components for your website",
          portal_dash_panel_demos: "Demos for your clients",
          portal_embed_access_inactive: "Your subscription is not active, so your embedded components are currently showing “Content not available”. They will be back as soon as you reactivate it.",
          portal_embed_component_unavailable: "This process cannot be embedded on its own yet; it is included in the full playbook.",
          portal_embed_components_desc: "One iframe per process, in playbook order. Paste each one in the section of your website where it fits; you can stack several, one after another.",
          portal_embed_components_empty: "This playbook has no processes yet.",
          portal_embed_components_error: "The processes of this playbook could not be loaded.",
          portal_embed_components_loading: "Loading the playbook's processes…",
          portal_embed_components_title: "Single components",
          portal_embed_copied: "Copied",
          portal_embed_copy: "Copy",
          portal_embed_copy_failed: "Could not copy",
          portal_embed_full_desc: "A single iframe with every stage of the playbook, in order. The recommended option for a landing page.",
          portal_embed_intro: "Add the animated components of each playbook to your own website with an <iframe>. They show your agency's brand (the logo and colour from your company profile), they are simulations with fictional data, and they carry a small “Powered by InvokeApp”.",
          portal_embed_intro_availability: "They only work while your InvokeApp subscription is active. If it ends, your visitors will see a “Content not available” notice instead.",
          portal_embed_key_admin_required: "Only the account administrator can create or revoke embed keys.",
          portal_embed_key_create: "Create key",
          portal_embed_key_create_error: "The key could not be created. Please try again.",
          portal_embed_key_created_ok: "Key created. You can now copy the snippets below.",
          portal_embed_key_created_on: "Created {{date}}",
          portal_embed_key_creating: "Creating…",
          portal_embed_key_label: "Name of the new key (optional)",
          portal_embed_key_label_placeholder: "Main website",
          portal_embed_key_last_seen: "Last used: {{date}}",
          portal_embed_key_limit: "You have reached the limit of {{max}} active keys. Revoke one you no longer use to create a new one.",
          portal_embed_key_never_seen: "Never used yet",
          portal_embed_key_no_label: "Unnamed key",
          portal_embed_key_not_found: "That key no longer exists; the list has been reloaded.",
          portal_embed_key_revoke: "Revoke",
          portal_embed_key_revoke_confirm: "Revoke the key {{label}}?\n\nEvery website using it will show “Content not available” instead of the components. This cannot be undone.",
          portal_embed_key_revoke_error: "The key could not be revoked. Please try again.",
          portal_embed_key_revoked_ok: "Key revoked.",
          portal_embed_key_revoked_on: "Revoked {{date}}",
          portal_embed_key_revoking: "Revoking…",
          portal_embed_key_select: "Key used in the snippets",
          portal_embed_keys_desc: "Every snippet carries a key that identifies your agency. You can create one per website and revoke it at any time without affecting the others.",
          portal_embed_keys_empty: "You don't have any active keys yet.",
          portal_embed_keys_error: "The embed keys could not be loaded.",
          portal_embed_keys_loading: "Loading keys…",
          portal_embed_keys_readonly: "Only the account administrator can create or revoke keys. You can copy the snippets with the keys that already exist.",
          portal_embed_keys_revoked_more: "and {{n}} more",
          portal_embed_keys_revoked_toggle: "Revoked keys ({{n}})",
          portal_embed_keys_title: "Embed keys",
          portal_embed_lang_en: "English",
          portal_embed_lang_es: "Spanish",
          portal_embed_lang_label: "Component language",
          portal_embed_mode_full_desc: "one iframe with every stage in order. Recommended for a landing page.",
          portal_embed_mode_full_title: "Full playbook",
          portal_embed_mode_single_desc: "one iframe per process, to place each one in the section of your website where it fits. You can stack several, one after another.",
          portal_embed_mode_single_title: "Single component",
          portal_embed_modes_title: "Two ways to embed them",
          portal_embed_need_key: "Create an embed key first: the snippets need one to work.",
          portal_embed_playbook_label: "Playbook",
          portal_embed_playbooks_empty: "There are no published playbooks yet.",
          portal_embed_playbooks_error: "The playbooks could not be loaded.",
          portal_embed_playbooks_loading: "Loading playbooks…",
          portal_embed_preview_hide: "Hide preview",
          portal_embed_preview_note: "Live preview with the selected key: exactly what your visitors will see.",
          portal_embed_preview_show: "Preview",
          portal_embed_processes_count: "Processes: {{n}}",
          portal_embed_retry: "Retry",
          portal_embed_script_desc: "Paste this script once per page (not once per iframe) so the height of the components adjusts automatically. Without it, each iframe keeps the fixed height set in its snippet.",
          portal_embed_script_title: "Optional: automatic height",
          portal_embed_session_expired: "Your session has expired. Sign in again to manage your components.",
          portal_embed_snippet_aria: "Code to paste on your website",
          portal_embed_snippets_title: "Embed on your website",
          cmp_sdr_title: "Email sales agent",
          cmp_sdr_desc: "Emails the leads in your CRM, keeps the conversation going and takes it all the way to a meeting in the calendar.",
          portal_embed_dev_title: "Components in development",
          portal_embed_dev_desc: "New components you can already add to your website, even though they are not part of any published playbook yet.",
          portal_embed_dev_badge: "In development",
          portal_embed_dev_note: "Once it becomes part of a playbook, it will also appear inside that playbook, and this snippet will keep working unchanged.",
          portal_embed_dev_error: "We could not check which components are still in development.",
          pbc_unavailable: "This component is not available.",
          portal_embed_stage: "Stage {{n}}",
          // --- Demo de playbook con la marca de la agencia (/playbook-demo) ---
          pbd_meta_title: "{{playbook}} — demo",
          pbd_lab_title: "Lab (not public).",
          pbd_lab_note: "Scenes still being tested. They only appear with &lab=1 in the address and are not part of the demos agencies send to their clients.",
          pbd_lab_assistants_title: "Your company’s assistants",
          pbd_lab_assistants_caption: "A simple chat in front and the whole company working behind it: the Manager routes each request to the right department assistant, each with its own colour.",
          pbd_loading: "Loading the demo…",
          pbd_error: "We could not load the demo. Please try again in a few seconds.",
          pbd_not_found: "This demo does not exist or is no longer published.",
          pbd_simulation_title: "Demo with fictional data.",
          pbd_simulation_body: "Names and figures are illustrative examples, not measured results.",
          pbd_ai_notice: "Some scenes show AI agents at work; in the real service they always identify themselves as such.",
          pbd_brand_missing: "We could not find the agency's brand: showing the neutral version.",
          pba_brand_error: "The agency's brand could not be loaded right now: showing the neutral version. Reload the page in a few seconds.",
          pbd_stage: "Stage {{n}}",
          pbd_processes: "{{n}} processes",
          pbd_scene_pending: "Scene not illustrated yet: showing the process card.",
          pbd_economics_title: "What this system costs",
          pbd_economics_monthly: "Estimated monthly fee",
          pbd_economics_one_off: "One-off setup",
          pbd_economics_per_use: "Per use",
          pbd_economics_partial: "Some processes have no published price yet, so the total is a floor.",
          pbd_economics_note: "Indicative figures; the final proposal is prepared by the agency.",
          pbd_cta_title: "Want to see it running in your business?",
          pbd_cta_body: "Talk to {{agency}} and they will show it to you with your own data.",
          pbd_cta_button: "Visit {{agency}}",
          pbd_privacy: "Privacy",
          pbd_terms: "Terms",
          pbd_powered: "Demo with fictional data · Powered by InvokeApp",
          pbl_title: "The value ladder, step by step",
          pbl_subtitle:
            "A playbook is a complete system, not a single process: one or more processes that go live in stages and add up to a single monthly fee you charge your client as your agency's service.",
          pbl_chart_title: "What each playbook adds up to",
          pbl_chart_subtitle: "Recurring retail price per month, summed across the processes of each playbook.",
          pbl_chart_foot:
            "Retail prices come from the commercial profile of each process; your margin depends on your wholesale plan.",
          pbl_chart_partial: "Bars marked with + include processes with no published price yet, so the real figure is higher.",
          pbl_per_month: "per month",
          pbl_step: "Step {{n}}",
          pbl_stage: "Stage {{n}}",
          pbl_monthly: "Recurring / month",
          pbl_one_off: "One-off setup",
          pbl_processes_one: "{{count}} process included",
          pbl_processes_other: "{{count}} processes included",
          pbl_per_unit: "Per {{unit}}",
          pbl_use_in_calculator: "Use in the calculator",
          pbl_notice_estimate:
            "Figures come from the commercial profile of each process: a reference, not a quote.",
          pbl_notice_partial_one: "{{count}} process has no published price yet, so the total is a floor.",
          pbl_notice_partial_other: "{{count}} processes have no published price yet, so the total is a floor.",
          pbl_notice_mixed: "This playbook mixes currencies: amounts are never summed across them.",
          pbl_empty:
            "There are no published playbooks yet. Meanwhile you can browse the full process catalogue and build your own ladder.",
          pbl_empty_cta: "See the process catalogue",
          pbl_see_catalog: "See every process in the catalogue",
          category: "Category",
          integration: "Integration",
          maintenance: "Maintenance",
          agentic: "Agentic",
          pay_per_use: "Pay per use",
          platform: "Platform",
          integration_details_title: "Integration Details",
          integration_details_subtitle: "Integration Overview",
          integration_details_meta: "System status",
          integration_details_category: "Category",
          integration_details_platforms: "Platforms",
          integration_details_overview: "How it works",
          integration_details_activation: "Activations",
          integration_details_pay_per_use: "Pay per use",
          integration_details_yes: "Yes",
          integration_details_no: "No",
          integration_details_unknown: "Unknown",
          integration_details_back: "Back to integrations",
          integration_details_all: "All systems",
          integration_details_empty_platforms: "No platforms available yet.",
          integration_details_empty_desc: "Integration description not available.",

          generic_newsletter_toast_error_politics: "You must accept the privacy policy to subscribe.",
          generic_newsletter_toast_error_select_language: "Please select a language.",
          generic_toast_success_send_message: "Message sent successfully",
          generic_toast_success_send_message_moderation:
            "Your message has been successfully submitted. It will be reviewed by our moderators before being published. Thank you for your contribution!",
          generic_toast_error_notsend_message: "Could not send the message",

          // POLICIES
          newsletter_policies_title_footer: "Newsletter Policies",
          policies_title_mini_newsletter: "Terms and conditions",
          policies_newsletter_title: "Newsletter Policies",
          policies_newsletter_title_one: "Newsletter Subscription Policy",
          policies_newsletter_description_one:
            "By subscribing to our newsletter, you agree to receive periodic communications from MARTÍNEZ CAMPOY CONSULTING, S.L. (InvokeApp). These messages focus on agency systems, workflows, reporting, and product updates. We use your data in accordance with our Privacy Policy.",
          policies_newsletter_title_two: "Collection of Information",
          policies_newsletter_description_two:
            "To subscribe, we only require your email address. Additional information may be requested to personalize content, but it is optional.",
          policies_newsletter_title_three: "Use of Information",
          policies_newsletter_description_three:
            "Your information is used to deliver newsletters and relevant product communications. We do not sell your personal data and we do not share it with third parties without consent, except as required to provide the email service or by law.",
          policies_newsletter_title_four: "Opt-Out Right",
          policies_newsletter_description_four:
            "You can unsubscribe at any time using the `unsubscribe` link included in every email.",
          policies_newsletter_title_five: "Policy Updates",
          policies_newsletter_description_five:
            "We may update these policies at any time. Changes take effect immediately upon posting on our website.",
          policies_newsletter_title_six: "Contact",
          policies_newsletter_description_six:
            "If you have questions about these policies, please contact us through",

          ebook_download_policies_title_footer: "Playbook Download Policies",
          policies_title_mini_ebook: "Terms and conditions",
          policies_ebook_download_title: "Playbook Download Policies",
          policies_ebook_download_title_one: "Playbook Download Policy",
          policies_ebook_download_description_one:
            "By downloading our playbook, you consent to provide your email address and agree to receive communications from MARTÍNEZ CAMPOY CONSULTING, S.L. (InvokeApp) about agency systems, templates, and updates. We handle your data according to our Privacy Policy.",
          policies_ebook_download_title_two: "Information Collection",
          policies_ebook_download_description_two:
            "We require your email address to deliver the download. Any extra information is optional and only used to tailor the content.",
          policies_ebook_download_title_three: "Use of Information",
          policies_ebook_download_description_three:
            "We use the provided data to deliver the playbook and related communications. We do not share your data without permission except as necessary to provide the service or as required by law.",
          policies_ebook_download_title_four: "Opt-Out Right",
          policies_ebook_download_description_four:
            "You can opt out anytime using the `unsubscribe` link included in our emails.",
          policies_ebook_download_title_five: "Policy Modifications",
          policies_ebook_download_description_five:
            "We may modify these policies at any time. Updates are effective immediately upon posting.",
          policies_ebook_download_title_six: "Inquiries",
          policies_ebook_download_description_six:
            "If you have any questions, please feel free to reach out through",

          contact_policies_title_footer: "Contact Policies",
          policies_title_mini_contact: "Terms and Conditions",
          policies_contact_title: "Contact Policies",
          policies_contact_title_one: "Information Collection for Contact",
          policies_contact_description_one:
            "When you contact us, we collect your email and any details you provide so we can respond and support your agency effectively.",
          policies_contact_title_two: "Use of Contact Information",
          policies_contact_description_two:
            "We use your contact info to reply to your request and, if you consent, to send relevant updates about agency systems and InvokeApp.",
          policies_contact_title_three: "Protection of Your Information",
          policies_contact_description_three:
            "We store your data securely and do not share it with third parties without consent, except as needed to deliver services or as required by law.",
          policies_contact_title_four: "Opting Out",
          policies_contact_description_four:
            "You can request removal from our contact list at any time by using unsubscribe links or contacting us directly.",
          policies_contact_title_five: "Policy Updates",
          policies_contact_description_five:
            "We may update these policies at any time. Changes are effective immediately upon posting.",
          policies_contact_title_six: "Contact Us",
          policies_contact_description_six:
            "If you have questions about our contact policies, please reach out through",

          comment_policies_title_footer: "Comment Policies",
          policies_title_mini_comment: "Terms and Conditions",
          policies_comment_title: "Comment Policies",
          policies_comment_title_one: "Comment Posting Rules",
          policies_comment_description_one:
            "We welcome comments that improve the conversation around agency operations and systems. Be respectful. No hate speech. No illegal promotion. We may remove comments that violate these standards.",
          policies_comment_title_two: "Use of Personal Information",
          policies_comment_description_two:
            "To post a comment, you must provide your email address. This is used for moderation and abuse prevention. Your email is not shown publicly.",
          policies_comment_title_three: "Moderation and Approval",
          policies_comment_description_three:
            "Comments may be moderated before publishing. We may edit or reject comments that do not meet our standards.",
          policies_comment_title_four: "Rights to Comments",
          policies_comment_description_four:
            "By posting a comment, you grant us permission to display and distribute it on our platforms.",
          policies_comment_title_five: "Policy Updates",
          policies_comment_description_five:
            "We may update these policies at any time. Updates are effective immediately upon posting.",
          policies_comment_title_six: "Contact",
          policies_comment_description_six:
            "If you have questions about comment policies, please contact us through",

          cookies_policies_title_footer: "Cookie Policies",
          cookies_policies_title_mini: "Terms & Conditions",
          cookies_policies_title: "Cookie Policies",
          cookies_policies_subtitle: "Last update: 4 february 2026",

          cookies_policy_title_one: "Introduction",
          cookies_policy_description_one:"We use cookies to improve your experience, measure performance, and keep the site reliable.",
          cookies_policy_title_two: "Information Collection",
          cookies_policy_description_two:"We use essential cookies for site functionality and analytics cookies to understand usage patterns and improve the experience.",
          cookies_policy_title_three: "Use of Information",
          cookies_policy_description_three:"Cookie data helps personalize content, improve our services, and measure marketing performance.",
          cookies_policy_title_four: "Managing Cookies",
          cookies_policy_description_four:"You can manage cookie preferences anytime using your browser settings. Disabling cookies may affect site functionality.",
          cookies_policy_title_five: "Consent",
          cookies_policy_description_five:"By using our site, you consent to cookies as described in this policy. If you do not accept cookies, some features may not work as expected.",
          cookies_policy_title_six: "Contact",
          cookies_policy_description_six:"If you have questions about our cookie policy, please feel free to contact us at letstalk@invokeapp.io",



          affiliates_page_title: "Affiliates - InvokeApp",
          affiliates_badge: "Earn While You Refer",
          affiliates_h1_prefix: "Earn ",
          affiliates_h1_gradient: "from 25% per sale",
          affiliates_subtitle: "Join our affiliate program and earn from 25% commission for every client you refer. Simple, transparent, and paid per sale.",
          affiliates_cta_primary: "Become an Affiliate",
          affiliates_cta_secondary: "Learn More",
          affiliates_benefits_badge: "Why Join",
          affiliates_benefits_title: "The best partner program in automation",
          affiliates_benefits_desc: "We make it easy to earn by referring InvokeApp to your network. No technical skills required.",
          affiliates_benefit_1_title: "From 25% Per Sale",
          affiliates_benefit_1_desc: "Earn from 25% commission on every client you refer. Simple, one-time payment per successful sale.",
          affiliates_benefit_2_title: "No Limits",
          affiliates_benefit_2_desc: "No earning caps. The more you refer, the more you earn. Scale your income without limits.",
          affiliates_benefit_3_title: "Real-Time Dashboard",
          affiliates_benefit_3_desc: "Track your referrals, commissions, and payouts in real time from your own affiliate dashboard.",
          affiliates_benefit_4_title: "Quick Payouts",
          affiliates_benefit_4_desc: "Get paid monthly with no minimum threshold. Your earnings, your schedule.",
          affiliates_commission_badge: "Commission Structure",
          affiliates_commission_title: "Simple, transparent, rewarding",
          affiliates_commission_desc: "No complicated tiers. No hidden conditions. From 25% commission on every sale you generate.",
          affiliates_commission_1: "From 25% on every plan",
          affiliates_commission_1_sub: "Whether they sign up for Starter, Professional or Enterprise, you earn from 25%.",
          affiliates_commission_2: "Per sale, not per month",
          affiliates_commission_2_sub: "You earn a one-time commission for each new client you bring. No waiting for recurring payments.",
          affiliates_commission_3: "Transparent tracking",
          affiliates_commission_3_sub: "Every conversion is tracked via cookies and attributed to you. Full visibility in your dashboard.",
          affiliates_commission_rate: "Commission per Sale",
          affiliates_commission_note: "Starting at 25% on all plans, all tiers, no exceptions",
          affiliates_how_title: "How it works",
          affiliates_how_desc: "Three simple steps to start earning with InvokeApp.",
          affiliates_step_1_title: "Sign up",
          affiliates_step_1_desc: "Create your affiliate account in minutes. Get your unique referral link and marketing materials.",
          affiliates_step_2_title: "Share",
          affiliates_step_2_desc: "Share your referral link with your network, on social media, or embed it in your content.",
          affiliates_step_3_title: "Earn",
          affiliates_step_3_desc: "Earn from 25% commission for every client that signs up through your link. Paid per sale.",
          affiliates_audience_for_title: "Perfect for...",
          affiliates_audience_for_1: "Digital marketers and content creators with an audience in the agency space.",
          affiliates_audience_for_2: "Consultants who recommend automation tools to their clients.",
          affiliates_audience_for_3: "Anyone with a network of agency owners or business operators.",
          affiliates_audience_not_title: "Not ideal if...",
          affiliates_audience_not_1: "You don't have an audience or network in the agency/marketing space.",
          affiliates_audience_not_2: "You are looking for a one-time payout instead of recurring income.",
          affiliates_audience_not_3: "You prefer not to share links or promote products actively.",
          affiliates_cta_title: "Become an affiliate",
          affiliates_cta_desc: "Fill out the form below and we will send you everything you need to start earning.",
          affiliates_cta_button: "Send Application",
          affiliates_form_email: "Your email",
          affiliates_form_name: "Full name",
          affiliates_form_phone: "Phone number",
          affiliates_form_country: "Country",
          affiliates_form_platforms: "Where will you promote?",
          affiliates_form_audience: "Approx. audience size",
          affiliates_form_strategy: "How do you plan to promote?",
          affiliates_form_submitting: "Sending...",
          affiliates_form_success_title: "Application sent!",
          affiliates_form_success_desc: "We will review your application and get back to you within 48 hours.",
          affiliates_form_policies: "I accept the privacy policy and terms of use.",
          affiliates_form_note: "No credit card required. We will review and get back to you.",
          affiliates_login_title: "Already an affiliate?",
          affiliates_login_desc: "Access your dashboard to track referrals, commissions and payouts.",
          affiliates_login_pass: "Password",
          affiliates_login_cta: "Access Dashboard",
          affiliates_tier_badge: "Growth Tiers",
          affiliates_tier_title: "From affiliate to ambassador to elite",
          affiliates_tier_desc: "The more you sell, the higher your commission rate. Climb the tiers and earn up to 35% per sale.",
          affiliates_tier_1: "Affiliate",
          affiliates_tier_1_desc: "Earn from 25% commission on every sale. Perfect to start earning with your network.",
          affiliates_tier_2: "Ambassador",
          affiliates_tier_2_desc: "Reach 10+ conversions and unlock 30% commission. Exclusive resources and early access.",
          affiliates_tier_3: "Elite",
          affiliates_tier_3_desc: "Top performers with 25+ conversions earn 35% plus co-marketing opportunities and dedicated support.",
          affiliates_guide_title: "Affiliate Guide - InvokeApp",
          affiliates_guide_badge: "Resources & Guide",
          affiliates_guide_h1: "Everything you need to succeed as an affiliate",
          affiliates_guide_subtitle: "Learn how to promote InvokeApp, access ready-to-use resources, and stay updated with the latest improvements.",
          affiliates_guide_section1_title: "How to promote InvokeApp",
          affiliates_guide_1_title: "Share your referral link",
          affiliates_guide_1_desc: "Use your unique referral link in emails, social media bios, blog posts, or YouTube descriptions. Every click is tracked and attributed to you.",
          affiliates_guide_2_title: "Track your performance",
          affiliates_guide_2_desc: "Log into your dashboard to see clicks, conversions, and commissions in real time. Know exactly what works and optimize your strategy.",
          affiliates_guide_3_title: "Create content that converts",
          affiliates_guide_3_desc: "Use our guides, presentations and resources to create blog posts, comparison articles, and social content that drives signups.",
          affiliates_guide_4_title: "Leverage lead magnets",
          affiliates_guide_4_desc: "Offer free resources like guides, checklists or templates to capture leads, then promote InvokeApp as the solution to their automation needs.",
          affiliates_guide_updates_title: "Updates & Changelog",
          affiliates_guide_updates_desc: "Stay informed about new features, improvements and resources available for affiliates.",
          affiliates_update_1_title: "New affiliate dashboard launched",
          affiliates_update_1_desc: "Real-time statistics, improved referral tracking and detailed commission reports now available.",
          affiliates_update_2_title: "Lead magnet templates pack",
          affiliates_update_2_desc: "New set of customizable presentations, checklists and email templates to help you generate leads.",
          affiliates_update_3_title: "Commission starting at 25%",
          affiliates_update_3_desc: "We updated the affiliate commission starting at 25% per sale across all plans. No tiers, no exceptions.",
          affiliates_guide_resources_title: "Resources & Lead Magnets",
          affiliates_guide_resources_desc: "Ready-to-use materials to promote InvokeApp and capture leads in your market.",
          affiliates_resource_1_title: "Presentation Deck",
          affiliates_resource_1_desc: "Customizable slides to present InvokeApp to your audience, clients or network.",
          affiliates_resource_2_title: "Social Media Kit",
          affiliates_resource_2_desc: "Banners, posts and stories ready to share on Instagram, LinkedIn, Twitter and Facebook.",
          affiliates_resource_3_title: "Email Templates",
          affiliates_resource_3_desc: "Pre-written emails for outreach, follow-ups and newsletter promotion of InvokeApp.",
          affiliates_resource_4_title: "Lead Magnet Kit",
          affiliates_resource_4_desc: "Guides, checklists and templates you can offer as free downloads to build your email list.",

          
          landing_nav_cta: "Get Started",
          landing_nav_agencies: "Agencies",
          landing_nav_partners: "Partners",
          landing_nav_product: "Product",
          landing_nav_scale: "Scale",
          landing_nav_explore: "Explore",
          landing_nav_affiliates: "Affiliates",

          // Partners Landing
          partners_badge: "Opening Doors to New Partners Q4 2026",
          partners_h1_prefix: "Grow Your Agency",
          partners_h1_middle: "with our",
          partners_h1_gradient: "Infrastructure",
          partners_subtitle: "The B2B Partnership program for automation leaders. We provide the tech foundation; you bring the strategy and implementation.",
          partners_cta_primary: "Become a Partner",
          partners_cta_secondary: "View Documentation",
          partners_roadmap_badge: "The Partner Journey",
          partners_roadmap_title: "Your Roadmap to AI Success",
          partners_roadmap_desc: "We'll guide you step by step, from understanding our ecosystem to successful implementation and continuous growth.",
          partners_step_1_label: "Step 1",
          partners_step_1_title: "Discover the Value of Being a Partner",
          partners_step_1_desc: "We believe in collaboration over competition. A strategic partner is an extension of our team, bringing their industry expertise while we provide the technology infrastructure. We don't sell services; we empower you to sell them.",
          partners_step_2_label: "Step 2",
          partners_step_2_title: "The Platform: Your Tech Backbone",
          partners_step_2_desc: "Access our cutting-edge tools designed to power your services. From complete APIs to customizable client dashboards.",
          partners_step_2_bullet_1: "Full API and Webhook Access",
          partners_step_2_bullet_2: "Client Dashboard with Your Agency's Logo",
          partners_step_2_bullet_3: "Level 1 Technical Support",
          partners_step_2_bullet_4: "Scalable Infrastructure",
          partners_step_3_label: "Step 3",
          partners_step_3_title: "Your Role: Strategy and Client Relationships",
          partners_step_3_desc: "You are the face and the engine of innovation for your clients. You bring strategic vision and the close relationships that drive success.",
          partners_step_3_bullet_1: "Industry-Specific Expertise",
          partners_step_3_bullet_2: "Client Relationship Management",
          partners_step_3_bullet_3: "On-Site Implementation",
          partners_step_3_bullet_4: "First-Line Support",
          partners_step_4_label: "Step 4",
          partners_step_4_title: "Define Your Collaboration Model",
          partners_step_4_desc: "We offer flexible options so you can choose the level of involvement that best fits your business strategy and operational capacity.",
          partners_step_4_model_1: "Referral — For Consultants",
          partners_step_4_model_2: "Technology Partner — For Agencies",
          partners_step_4_model_3: "Integrator — For Developers",
          partners_step_5_label: "Step 5",
          partners_step_5_title: "Apply and Start Your Growth",
          partners_step_5_desc: "If you align with our growth vision and bring value, we want to meet you! The application process is simple and fast.",
          partners_infra_badge: "For Partners",
          partners_infra_title: "The infrastructure layer that lets you sell automation as a product.",
          partners_infra_desc: "We don't give you scripts or loose tools. We give you an operable, scalable, and controllable platform to build your own offering on top of.",
          partners_infra_1_title: "Reusable and clonable templates",
          partners_infra_1_desc: "Design once, deploy across dozens of clients while maintaining control and consistency.",
          partners_infra_2_title: "Per-instance and per-client execution",
          partners_infra_2_desc: "Each client runs their processes in isolation — stable and auditable.",
          partners_infra_3_title: "Centralized credential management",
          partners_infra_3_desc: "Control access, integrations, and permissions for all your clients from a single place.",
          partners_infra_4_title: "Infrastructure built to sell",
          partners_infra_4_desc: "Versioning, change control, and rollback. Automation as a product, not as an experiment.",
          partners_audience_title: "Is this for you?",
          partners_audience_for_title: "You are an ideal candidate if...",
          partners_audience_for_1: "You run an agency with 10+ active B2B clients seeking automation.",
          partners_audience_for_2: "You have the technical ability to implement small JS snippets or API calls.",
          partners_audience_for_3: "You want to move from 'service revenue' to 'recurring revenue'.",
          partners_audience_not_title: "This is NOT for you if...",
          partners_audience_not_1: "You are a freelancer looking for one-off work.",
          partners_audience_not_2: "You are looking for a 'get rich quick' scheme without adding value.",
          partners_audience_not_3: "You have no technical knowledge or interest in AI.",
          partners_cta_title: "Ready to build the future?",
          partners_cta_desc: "Join the agencies leveraging our infrastructure to deliver next-gen AI automation to their clients.",
          partners_cta_button: "Apply to the Partner Portal",
          partners_cta_footnote: "No credit card required for application • Reviews within 48h",

          // Product Landing
          product_page_title: "InvokeApp - Automation & AI Infrastructure",
          product_badge: "Public Beta Access",
          product_h1_prefix: "Automation & AI",
          product_h1_gradient: "Break at Scale",
          product_h1_suffix: "Build Them as Infrastructure.",
          product_subtitle: "A platform for technical teams and agencies to design, deploy, and manage reusable automation and AI as scalable infrastructure.",
          product_cta_primary: "Request Access",
          product_cta_secondary: "Contact Us",
          product_problem_badge: "The Problem",
          product_problem_title: "Why the current model fails",
          product_problem_1_title: "One-off workflows",
          product_problem_1_desc: "Each new project means rebuilding, copy-pasting, and patching scripts manually.",
          product_problem_2_title: "Credential sprawl",
          product_problem_2_desc: "Managing access across multiple tools becomes a security and operational nightmare.",
          product_problem_3_title: "No governance",
          product_problem_3_desc: "Without a systematic approach, consistency and best practices are impossible.",
          product_problem_4_title: "AI glued on top",
          product_problem_4_desc: "AI models are often an afterthought, not integrated deeply into scalable processes.",
          product_solution_badge: "The Solution",
          product_solution_title: "We provide the missing layer for robust, scalable automation.",
          product_solution_desc: "Treat automation as a core part of your tech stack, not a series of scripts.",
          product_solution_1_title: "Reusable workflow templates",
          product_solution_1_desc: "Design once, deploy many times, tailored for each client or project.",
          product_solution_2_title: "Instance-based execution",
          product_solution_2_desc: "Each deployment runs independently, ensuring isolation and stability.",
          product_solution_3_title: "Centralized credential management",
          product_solution_3_desc: "Securely manage all integrations and access in one place.",
          product_solution_4_title: "Infrastructure-first approach",
          product_solution_4_desc: "Treat automation as code, with versioning and rollbacks.",
          product_intel_title: "How This Is Different",
          product_intel_subtitle: "From fragile scripts to interconnected systems.",
          product_intel_1_title: "Interconnected Systems",
          product_intel_1_desc: "Move beyond isolated tools. Build durable architectures that communicate seamlessly.",
          product_intel_2_title: "Scalable Products",
          product_intel_2_desc: "Turn one-off projects into repeatable, sellable products.",
          product_intel_3_title: "Durable Architecture",
          product_intel_3_desc: "Design systems that last. Infrastructure that evolves with your needs.",
          product_intel_4_title: "Reliable Infrastructure",
          product_intel_4_desc: "Built-in redundancy, monitoring, and self-healing for mission-critical operations.",
          product_future_title: "Where This Is Going",
          product_future_desc: "Our vision is to evolve from individual processes into interconnected, intelligent systems that adapt and operate with minimal human intervention.",
          product_phase_1_label: "Phase 1",
          product_phase_1_title: "Workflows",
          product_phase_1_desc: "Design and deploy individual automation workflows.",
          product_phase_2_label: "Phase 2",
          product_phase_2_title: "Systems",
          product_phase_2_desc: "Connect workflows into intelligent, coordinated systems.",
          product_phase_3_label: "Phase 3",
          product_phase_3_title: "Autonomy",
          product_phase_3_desc: "Self-operating systems that adapt and optimize in real time.",
          product_cta_bottom: "Request Early Access",

          // Scale Landing
          scale_page_title: "InvokeApp - Scaling Automation Services",
          scale_badge: "B2B Infrastructure",
          scale_h1_prefix: "Automation & AI at Scale:",
          scale_h1_gradient: "Standardize, Control, Profit.",
          scale_subtitle: "Infrastructure for agencies and advanced studios turning isolated projects into repeatable, profitable systems.",
          scale_cta_primary: "Request a Demo",
          scale_cta_secondary: "Talk to the Team",
          scale_problem_badge: "The Problem",
          scale_problem_title: "The chaos of scaling without infrastructure",
          scale_problem_1_title: "Every client, a universe",
          scale_problem_1_desc: "Managing automations becomes unmanageable when every project is unique.",
          scale_problem_2_title: "Ad-hoc automations",
          scale_problem_2_desc: "Lack of standardization hinders replicability and increases maintenance costs.",
          scale_problem_3_title: "Key person dependency",
          scale_problem_3_desc: "Knowledge resides in individuals, not the system, creating bottlenecks.",
          scale_problem_4_title: "Diffuse control",
          scale_problem_4_desc: "Critical difficulties monitoring access, executions, and performance across multiple accounts.",
          scale_control_badge: "The Solution",
          scale_control_title: "From improvisation to absolute control",
          scale_control_desc: "The paradigm shift your agency needs.",
          scale_control_1_title: "Reusable workflows",
          scale_control_1_desc: "Design once, deploy multiple times. Create master templates and apply them to new clients with controlled variations.",
          scale_control_2_title: "Per-client instances",
          scale_control_2_desc: "Isolate environments for each client, ensuring absolute security and preventing data contamination between projects.",
          scale_control_3_title: "Separate credential management",
          scale_control_3_desc: "Granular control of accesses and API credentials. Centralized yet secure, without sharing keys between environments.",
          scale_control_4_title: "Centralized control and traceability",
          scale_control_4_desc: "Monitor every execution, audit changes, and manage team permissions from a single dashboard.",
          scale_control_5_title: "Security and governance",
          scale_control_5_desc: "Regulatory compliance and total control over all your automation and AI operations.",
          scale_metric_1: "Revenue growth",
          scale_metric_2: "System uptime",
          scale_metric_3: "Deployment speed",
          scale_metric_4: "Operational cost reduction",
          scale_results_title: "Results that transform your business",
          scale_result_1_title: "Real standardization",
          scale_result_1_desc: "Implement consistent methodologies across all your projects without extra effort.",
          scale_result_2_title: "Fewer operational errors",
          scale_result_2_desc: "Drastically reduce human risk and improve final delivery quality.",
          scale_result_3_title: "Higher margins and profitability",
          scale_result_3_desc: "Optimize resources and scale services without sacrificing profits to maintenance costs.",
          scale_result_4_title: "Frictionless scaling",
          scale_result_4_desc: "Add new clients and services with the confidence of a solid foundation that doesn't break.",
          scale_result_5_title: "Automation governance",
          scale_result_5_desc: "Ensure compliance and consistency across all operations, vital for corporate clients.",
          scale_audience_for_title: "This infrastructure is for you if",
          scale_audience_for_1: "You are an agency, advanced studio, or service organization already selling automation or digital services.",
          scale_audience_for_2: "You need to standardize, control, and scale without chaos.",
          scale_audience_for_3: "You want to move from isolated projects to robust, replicable systems.",
          scale_audience_not_title: "This is NOT for you if",
          scale_audience_not_1: "You are looking for a personal experimentation tool or free trial software.",
          scale_audience_not_2: "You are an individual user looking for a single-purpose tool.",
          scale_audience_not_3: "You are not ready to operate at scale with structured processes.",
          scale_cta_title: "The next step toward operational control",
          scale_cta_desc: "Designed for leaders seeking order and margin. Let's talk about how our infrastructure can transform your operations.",
          scale_cta_button: "Request a Strategic Demo",

          // Explore Landing
          explore_page_title: "InvokeApp - Customer service, appointments and CRM platform for agencies",

          // ---- Landing del kit (/resources/ai-kit) ----
          aikit_page_title: "Kit to build and sell AI services",
          aikit_page_meta:
            "Templates, proposals and contract models to turn an idea into an AI service offering. Free, by email.",
          aikit_nav_label: "AI Kit",
          aikit_nav_offer: "Offer",
          aikit_skip_to_content: "Skip to content",
          aikit_motion_pause: "Pause the motion",
          aikit_motion_play: "Resume the motion",
          aikit_footer_legal:
            "MARTÍNEZ CAMPOY CONSULTING, S.L. · C.I.F. B88657853 · Calle Roma, 15 · 30600 Archena (Murcia), Spain",
          aikit_hero_kicker: "For freelancers, consultants and agencies",
          aikit_hero_title: "Your next AI service starts here.",
          aikit_hero_desc:
            "Templates, proposals and contract models to turn an idea into an offering.",
          aikit_cta_kit: "Get the kit for free",
          aikit_hero_offer_link: "See the webinar offer",
          aikit_hero_micro: "Free. By email. Newsletter optional.",
          aikit_res_title: "Define. Price. Deliver.",
          aikit_res_1_title: "Prepare your proposal (with the paperwork)",
          aikit_res_2_title: "Organise delivery",
          aikit_res_preview_alt: "Preview of the kit documents",
          aikit_faq_1_q: "Do I need to subscribe to InvokeApp?",
          aikit_faq_1_a:
            "No. You can get the kit without subscribing to the platform or to the newsletter.",
          aikit_faq_2_q: "How do I get the resources?",
          aikit_faq_2_a: "Leave your email and we will send you access to the kit.",
          aikit_plat_kicker: "The platform behind the kit",
          aikit_plat_title: "Your AI services. Your clients. One platform.",
          aikit_plat_desc:
            "With InvokeApp you can configure agents, connect tools and run the operation of every client.",
          aikit_plat_1: "Reusable processes",
          aikit_plat_2: "Client by client",
          aikit_plat_3: "Activity tracking",
          aikit_offer_kicker: "Webinar-only offer",
          aikit_offer_title: "Get your first service running with InvokeApp.",
          aikit_offer_desc:
            "The usual prices, with discounts that exist only here and only for these hours.",
          aikit_offer_cta: "Take the offer",
          aikit_offer_renewal: "Afterwards: {{price}}",
          aikit_offer_session: "Includes a {{duration}} consulting session for {{scope}}.",
          aikit_offer_deadline: "Available until {{date}}, at {{time}} (Madrid time).",
          aikit_offer_plain_kicker: "Start with InvokeApp",
          aikit_offer_plans_cta: "See plans",
          aikit_plan_first_month: "for the first month",
          aikit_plan_then: "Then, {{price}}",
          aikit_plan_code: "Discount code",
          aikit_plan_code_hint: "Enter the code at checkout so the discount applies.",
          aikit_plan_copied: "Copied",
          aikit_plan_copy: "Copy the code",
          aikit_plan_pending: "Code and payment link, available during the webinar.",
          aikit_plan_bonus: "Bonus included",
          aikit_plan_per_month: "per month",
          // ---- Landing AI Commercial System (/resources/ai-commercial-system) ----
          aics_nav_label: "AI Commercial System",
          aics_page_title: "AI Commercial System: sales follow-up as a billed service",
          aics_page_meta:
            "Free kit: seven steps to turn your clients' sales follow-up into a recurring service, with one tip per step and a checklist. By email.",
          aics_nav_plans: "Plans",
          aics_hero_kicker: "Free kit · Applied AI",
          aics_hero_title: "Turn sales follow-up into a billed service.",
          aics_hero_desc:
            "What to sell, which risks to check and what to require before going live: from your client's database to the first recovered sale.",
          aics_cta: "Get the kit for free",
          aics_hero_plans_link: "See plans",
          aics_res_title: "Seven steps, one tip per step and no sending without permission.",
          aics_res_1_title: "The seven steps, from the database to the first recovered sale",
          aics_res_2_title: "One tip per step to avoid what costs clients, reputation or fines",
          aics_res_3_title: "The eight-box checklist for your first client",
          aics_res_preview_alt: "Preview of the AI sales follow-up kit",
          aics_faq_1_q: "Do I need to subscribe to InvokeApp?",
          aics_faq_1_a:
            "No. You can get the kit without subscribing to the platform or to the newsletter.",
          aics_faq_2_q: "How do I get the kit?",
          aics_faq_2_a: "Leave your email and we will send you the link to download it as a PDF.",
          aics_plat_kicker: "The platform behind the system",
          aics_plat_title: "Your sales follow-up, running on its own.",
          aics_plat_desc:
            "With InvokeApp, AI agents draft and send the follow-up from each project's mailbox and log every step in the CRM.",
          aics_plat_1: "Pre-sale",
          aics_plat_2: "Post-sale",
          aics_plat_3: "Built-in CRM",
          aics_wheel_lead:
            "The kit gives you the method. The platform gives you what you run it with.",
          aics_demo_kicker: "See it working",
          aics_demo_title: "From the CRM lead to the booked meeting.",
          aics_demo_desc:
            "The SDR agent prepares each message with what it knows about the contact, a person reviews it and it is sent from the project's mailbox.",
          aics_plans_kicker: "Start with InvokeApp",
          aics_plans_title: "Put your sales system to work.",
          aics_plans_desc: "The usual plans, with everything each one includes.",
          aics_plans_cta: "Get started",
          aics_plans_compare: "Compare plans",
          aics_form_title: "Get the sales follow-up kit",
          aics_form_desc: "Seven steps, one tip per step and a checklist for the first client. Free, as a PDF.",
          aics_form_submit: "Send me the kit",
          aics_form_terms_error: "You need to accept the Terms and Conditions to get the kit.",
          aics_form_ok: "Your kit is on its way.",
          aics_form_ok_noemail: "Request received.",
          aics_form_ok_open: "Open the kit",
          aics_done_text_noemail: "It is logged. We will get you the kit.",
          resources_aics_text: "Seven steps to turn sales follow-up into a billed service. Free kit.",
          aikit_foot_home: "Home",
          aikit_foot_plans: "Plans",
          aikit_foot_playbooks: "Playbooks",
          aikit_foot_catalog: "Catalogue",
          aikit_foot_more: "More from InvokeApp",
          aikit_done_text:
            "We are sending it to the email you left us. If it does not show up, check your spam and promotions folders.",
          aikit_done_text_noemail: "It is logged. We will get you access to the kit.",
          aikit_done_next: "And while you are here: the webinar offer only lasts a few hours.",
          aikit_done_audit: "Book a free audit",
          aikit_audit_kicker: "Still unsure?",
          aikit_cd_title: "The offer closes in",
          aikit_cd_days: "days",
          aikit_cd_hours: "hours",
          aikit_cd_min: "min",
          aikit_cd_sec: "sec",
          aikit_cd_aria: "The offer closes on {{date}} at {{time}}, Madrid time.",
          aikit_offer_ended: "The webinar offer has ended.",
          aikit_offer_qr: "Scan to subscribe",
          aikit_wheel_lead:
            "The kit gives you the offering. The platform gives you what you deliver it with.",
          aikit_form_terms: "I have read and accept the Terms and Conditions.",
          aikit_form_terms_link: "Terms and Conditions",
          aikit_form_terms_error: "You need to accept the Terms and Conditions to get the kit.",
          aikit_form_title: "Get your kit for free",
          aikit_form_desc: "Templates and resources to build and sell AI services.",
          aikit_form_email: "Your email",
          aikit_form_email_ph: "name@company.com",
          aikit_form_newsletter:
            "I want to receive ideas, news and offers from InvokeApp by email.",
          aikit_form_submit: "Send me the kit",
          aikit_form_support: "The newsletter is optional. You can unsubscribe whenever you want.",
          aikit_form_sending: "Sending…",
          aikit_form_error_email: "Enter a valid email address.",
          aikit_form_error: "We could not complete the request. Please try again.",
          aikit_form_close: "Close",
          aikit_form_ok: "Your kit is on its way.",
          aikit_form_ok_noemail: "Request received.",
          aikit_form_ok_open: "Open the kit now",
          aikit_form_ok_offer: "See the webinar offer",
          newsletter_popup_title: "Subscribe to the InvokeApp newsletter",
          newsletter_popup_desc:
            "Ideas to sell AI services, platform news and offers for agencies, in your inbox.",
          newsletter_popup_consent:
            "By subscribing you agree to receive ideas, news and offers from InvokeApp by email. You can unsubscribe whenever you want.",
          newsletter_popup_submit: "Subscribe",
          newsletter_popup_terms_error: "You need to accept the Terms and Conditions to subscribe.",
          newsletter_popup_error: "We could not complete your subscription. Please try again.",
          newsletter_popup_ok: "Done! You are on the newsletter.",
          newsletter_popup_ok_fallback: "We have received your sign-up.",
          newsletter_popup_ok_text:
            "We will write to you with ideas, news and offers from InvokeApp.",
          newsletter_popup_ok_next:
            "And if you want to move faster: we review your agency and show you which processes you can offer your clients.",



          explore_page_meta:
            "Agencies, freelancers and consultants switch on ready-built customer service, appointment and sales follow-up processes for their clients, at their own price. A SaaS platform, not a course.",
          explore_badge: "A SaaS platform for agencies, freelancers and consultants",
          explore_h1_prefix: "You're not here to learn another tool.",
          explore_h1_gradient_1: "You're here to serve your clients better.",
          explore_subtitle:
            "You switch on ready-built customer service, appointment and sales follow-up processes and deliver them to your clients as your agency's service, at the price you set. You sell; we keep the machine running.",
          explore_how_title: "How the platform works",
          explore_how_desc:
            "The route is the same for everyone: it makes no difference whether you run an agency with twenty clients, work on your own or make a living advising. Four steps, and none of them involves writing code.",
          explore_how_1_title: "You pick what you'll deliver",
          explore_how_1_desc:
            "You open the catalogue and pick: a single process, or a whole playbook — the service already assembled in stages. Each one comes with a profile of what it does and what it costs.",
          explore_how_2_title: "You switch it on for a client",
          explore_how_2_desc:
            "You configure it for that specific business. Your client connects their accounts from a branded activation page, so their credentials never pass through your hands.",
          explore_how_3_title: "It runs on its own, you keep watch",
          explore_how_3_desc:
            "The process runs without anyone pushing it. The dashboard shows what it did and when, and where the process calls for it, you approve what goes out to the end client before it is sent.",
          explore_how_4_title: "You deliver it as your agency's service",
          explore_how_4_desc:
            "The relationship and the invoice are yours: your client hires you, not us. The reports and the portal your client sees can carry your agency's logo — Pricing shows which plan it starts at.",
          explore_how_cta: "See the process catalogue",
          explore_cta_primary: "See what you can sell",
          explore_cta_secondary: "How it works",
          explore_hero_note:
            "For agencies, freelancers and consultants. No sign-up to look around.",
          explore_what_title: "What this actually is",
          explore_what_desc:
            "A SaaS platform. You log in, pick a process from the catalogue, configure it for one specific client and switch it on: you write no code. This is not a course, not consulting, and not a tool you hand over for the client to operate: it's the machine you deliver with, whether you run an agency, work freelance or advise.",
          explore_areas_badge: "What you sell",
          explore_areas_title: "What you sell, by name",
          explore_areas_desc:
            "Five examples, written the way you would explain them to a client. The catalogue is the source of truth: what is published on Services is what you can switch on.",
          explore_tiers_badge: "The tiers",
          explore_tiers_title: "Each tier carries the one below it, and then some",
          explore_tiers_desc:
            "These aren't three different products: it's the same one with more rope. What's struck through is what that tier does NOT include, so you can see where the jump is before you choose.",
          explore_tiers_not_included: "Not included",
          explore_tiers_cta: "See the pricing",
          explore_area_1_title: "WhatsApp receptionist",
          explore_area_1_desc:
            "Covers the business WhatsApp at any hour, handles the usual questions and books the appointment. In clinics, only appointment logistics: date, time, confirmation and reminder, never health data.",
          explore_area_2_title: "Appointment reminders",
          explore_area_2_desc:
            "Remind the client before the appointment and collect the confirmation or the change, so the slot is not lost in silence.",
          explore_area_3_title: "Reactivation campaigns",
          explore_area_3_desc:
            "Talk again to the customer base that already bought once, without pulling the list together by hand.",
          explore_area_4_title: "Reports under your brand",
          explore_area_4_desc:
            "The report carries your logo and, if you connect your company email, goes out from your own address.",
          explore_area_5_title: "1:1 sales follow-up",
          explore_area_5_desc:
            "Every incoming lead gets followed up instead of going cold in an inbox, and you approve what goes out before it goes.",
          explore_area_6_title: "And the rest of the catalogue",
          explore_area_6_desc:
            "These are examples. The live list, with the details of each process, is on Services.",
          explore_area_6_cta: "See the full catalogue",
          explore_buy_note:
            "The processes inside a playbook come from this very catalogue, so both doors lead to the same place: you can start with a single piece for one client and build the whole ladder once that one works.",
          explore_margin_title: "Where your money comes from",
          explore_margin_step_1:
            "You pay for your platform plan plus the AI usage of the processes you have running. That is your cost, and it is published: no need to ask for it by email.",
          explore_margin_step_2:
            "You charge your client whatever you decide for the service you deliver.",
          explore_margin_step_3:
            "What is left between those two numbers is your margin, and it repeats every month for as long as the process keeps working, because what you sell is not a delivery that ends.",
          explore_margin_note:
            "We don't put numbers in your mouth: the plan price is on Pricing and the retail price is yours to set. Your client signs with you: the relationship and the invoice are yours.",
          explore_margin_cta: "See what the plan costs",
          explore_nohype_title: "What you won't find here",
          explore_nohype_desc:
            "Not one percentage, not one client logo, not one testimonial, and no \"agencies using this bill X% more\". They are missing because we have not measured them, and we would rather you knew exactly what you are buying: a mechanism, not a promised outcome. What you can check today is the product itself: open the catalogue, look at the processes one by one, look at what the plan costs, and decide for yourself.",
          explore_cta_title: "If you've only got twenty seconds",
          explore_cta_desc:
            "Join the WhatsApp group: one tap, no form, and you look at it tomorrow with a clear head. If you would rather see the product before talking to anyone, the full ladder is on Playbooks and the individual processes on Services. If your job is recommending, look at the platform from the inside or ask for a demo.",
          explore_cta_button: "Join the WhatsApp group",
          explore_cta_catalog: "See the catalogue",
          explore_cta_playbooks: "View Playbooks",
          explore_cta_demo: "Ask for a demo",
          explore_cta_signup: "Already sure? Sign up",

          // Agencies Landing
          agencies_page_title: "Customer service, appointments and CRM for your clients | InvokeApp",
          agencies_badge: "New Platform V2.0 Available",
          agencies_h1_prefix: "Offer",
          agencies_h1_gradient: "customer service, appointments and CRM",
          agencies_h1_suffix: "to your clients.",
          agencies_subtitle: "Platform for agencies that want to scale their tech services without hiring an expensive team of developers.",
          agencies_cta_primary: "Request Agency Access",
          agencies_cta_secondary: "Watch Intro (30 sec)",
          agencies_trust_text: "Powering the best digital agencies",
          agencies_brand_1: "360",
          agencies_brand_2: "COMUNICACIÓN",
          agencies_brand_3: "MARKETING",
          agencies_brand_4: "PAID MEDIA",
          agencies_brand_5: "PUBLICIDAD",
          agencies_problem_badge: "The Problem",
          agencies_problem_title: "Traditional agencies are becoming obsolete",
          agencies_problem_desc: "Trying to offer advanced technology services without the right infrastructure is expensive, risky, and slow.",
          agencies_problem_1_title: "Reduced Margins",
          agencies_problem_1_desc: "Hiring senior developers and maintaining engineering teams devours your profits. The technical cost is unsustainable for scaling.",
          agencies_problem_2_title: "Steep Learning Curve",
          agencies_problem_2_desc: "Mastering LangChain, OpenAI APIs, vectors, and servers requires dedicated time. Your marketing team doesn't have that.",
          agencies_problem_3_title: "Fast Competition",
          agencies_problem_3_desc: "Your competitors are already offering chatbots and automations. If you keep selling only hours, you'll lose clients.",
          agencies_paradigm_badge: "The New Paradigm",
          agencies_paradigm_title: "Your clients' customer service and sales, in one platform",
          agencies_paradigm_desc: "Transform your business model. Move from selling manual hours to offering customer service, appointments and sales follow-up as a recurring service.",
          agencies_paradigm_1_title: "Your agency, in front of the client",
          agencies_paradigm_1_desc: "You keep the client relationship and the invoice; InvokeApp is the technology partner behind your service.",
          agencies_paradigm_2_title: "No code, just configuration",
          agencies_paradigm_2_desc: "Visual drag-and-drop interface to create complex flows in minutes.",
          agencies_paradigm_3_title: "Published Pricing",
          agencies_paradigm_3_desc: "Your platform cost is published; you set the price of your service and keep the margin.",
          agencies_paradigm_4_title: "Instant Deployment",
          agencies_paradigm_4_desc: "Forget servers, Docker, or environment setups. Our managed cloud handles all the backend.",
          agencies_card_1: "Chatbot Configurator",
          agencies_card_2: "Client Dashboard",
          agencies_card_3: "Integration Marketplace",
          agencies_card_4: "Flow Builder",
          agencies_how_title: "How it works",
          agencies_how_desc: "Three simple steps to launch your tech offering.",
          agencies_step_1_title: "Select",
          agencies_step_1_desc: "Choose from 50+ pre-built automation templates (Lead gen, Support, Onboarding) from our library.",
          agencies_step_2_title: "Customize",
          agencies_step_2_desc: "Add your agency's logo and adapt each process to your client's needs.",
          agencies_step_3_title: "Monetize",
          agencies_step_3_desc: "Deliver access to your client and charge a recurring monthly subscription for software maintenance and usage.",
          agencies_cta_title: "Ready to offer more to your clients?",
          agencies_cta_desc: "Join the waitlist and get early access to the platform that's changing the game.",
          agencies_cta_primary_bottom: "Request Access Now",
          agencies_cta_secondary_bottom: "Talk to Sales",
          agencies_cta_footnote: "No credit card required • Limited spots this month",

          dash_page_title: "Affiliate Dashboard",
          dash_welcome: "Welcome back!",
          dash_tier: "Tier",
          dash_earnings: "Earnings",
          dash_pending: "Pending",
          dash_paid: "Paid",
          dash_active_users: "Active Users",
          dash_conv_week: "Conversions/Week",
          dash_top_kit: "Top Kit",
          dash_top_kit_name: "Real Estate AI",
          dash_logout: "Sign out",
          dash_save: "Save",
          dash_ref_email: "Email",
          dash_next_payout: "Next Payout",
          dash_payment_method: "Payment Method",
          dash_view_demo: "View Demo",
          dash_nav_overview: "Overview",
          dash_nav_kits: "Kits",
          dash_nav_links: "Links",
          dash_nav_resources: "Resources",
          dash_nav_referrals: "Referrals",
          dash_nav_payouts: "Payouts",
          dash_nav_settings: "Settings",
          dash_kits_title: "Promotable Kits",
          dash_kits_desc: "Share these AI systems with your audience and earn a commission on every sale.",
          dash_links_title: "Links & Campaigns",
          dash_links_desc: "Generate custom affiliate links with UTM parameters.",
          dash_links_generate: "Your affiliate link",
          dash_links_campaigns: "Saved campaigns",
          dash_resources_title: "Promotional Resources",
          dash_resources_desc: "Ready-to-use assets to promote InvokeApp on your channels.",
          dash_payouts_title: "Payouts",
          dash_payouts_desc: "Track your earnings, payout history, and next payment date.",
          dash_settings_title: "Settings",
          dash_settings_desc: "Manage your account and payment preferences.",
          dash_referrals_title: "Recent Referrals",
          dash_referrals_desc: "Users who signed up through your affiliate link.",
          dash_partners: "Partners",
          dash_reseller: "Partner clients",
          dash_referrals: "Referrals",
          dash_margin_partner: "Margin",
          dash_partner_search: "Search partners...",
          dash_partner_revenue: "Partner Revenue",
          dash_partner_activity: "Recent Activity",
          dash_see_more: "See more",
          dash_part_act_1: "New partner onboarding completed",
          dash_part_act_2: "Tier upgrade — Silver to Gold",
          dash_part_act_3: "Commission payout processed",
          dash_part_act_4: "New referral link generated",
          dash_pop_partners_title: "Partners Overview",
          dash_pop_partners_desc: "View all active partners, their tier status, and performance metrics in one place.",
          dash_pop_partners_detail: "Includes 48 active partners across 3 tiers with a 94% retention rate.",
          dash_pop_reseller_title: "Partner Client Revenue",
          dash_pop_reseller_desc: "Track total revenue from the clients your partners serve, monthly recurring value, and growth trends.",
          dash_pop_reseller_detail: "$340K total with 22% month-over-month growth across all partner client accounts.",
          dash_pop_referrals_title: "Referrals",
          dash_pop_referrals_desc: "Monitor referral traffic, conversion rates, and top-performing referral sources.",
          dash_pop_referrals_detail: "156 referrals this quarter with an 18% conversion rate from organic sources.",
          dash_pop_marginp_title: "Partner Margin",
          dash_pop_marginp_desc: "Analyze margin distribution across partner tiers and identify optimization opportunities.",
          dash_pop_marginp_detail: "Average 42% margin with top-tier partners achieving up to 58%.",
          dash_pop_partchart_title: "Revenue Chart",
          dash_pop_partchart_desc: "Visualize partner revenue trends over time with projected growth forecasts.",
          dash_pop_partchart_detail: "Projected to reach $420K ARR by end of quarter based on current trajectory.",
          dash_pop_partactivity_title: "Activity Panel",
          dash_pop_partactivity_desc: "Real-time feed of partner actions, system events, and important notifications.",
          dash_pop_partactivity_detail: "12 new activities in the last 24 hours, including 3 tier upgrades.",
          dash_clients: "Clients",
          dash_workflows: "Workflows",
          dash_success: "Success Rate",
          dash_margin: "Margin",
          dash_search: "Search...",
          dash_info_current: "Current",
          dash_activity_title: "Recent Activity",
          dash_act_1: "New workflow automation deployed",
          dash_act_2: "Client onboarding completed",
          dash_act_3: "Monthly report generated",
          dash_act_4: "System integration successful",
          dash_pop_clients_title: "Clients Overview",
          dash_pop_clients_desc: "View all active clients, their onboarding status, and engagement metrics.",
          dash_pop_clients_detail: "128 active clients with a 97.8% success rate and 12% month-over-month growth.",
          dash_pop_workflows_title: "Workflows",
          dash_pop_workflows_desc: "Monitor automated workflows, execution status, and performance analytics.",
          dash_pop_workflows_detail: "1.4K workflows executed this month with an average completion time of 3.2 minutes.",
          dash_pop_success_title: "Success Rate",
          dash_pop_success_desc: "Track client success metrics, satisfaction scores, and outcome achievements.",
          dash_pop_success_detail: "97.8% overall success rate with top-performing workflows reaching 99.2%.",
          dash_pop_margin_title: "Margin Analysis",
          dash_pop_margin_desc: "Analyze profit margins across services, clients, and workflow categories.",
          dash_pop_margin_detail: "Average 34% margin with high-value clients achieving up to 52%.",
          dash_pop_bar_title: "Revenue Chart",
          dash_pop_bar_desc: "Visualize revenue trends, monthly comparisons, and growth projections.",
          dash_pop_bar_detail: "Current MRR of $8.8K with a 12% projected increase next quarter.",
          dash_pop_activity_title: "Activity Panel",
          dash_pop_activity_desc: "Real-time feed of system events, client actions, and important notifications.",
          dash_pop_activity_detail: "8 new activities in the last hour, including 2 workflow completions.",
        },
      },


      es: {
        translation: {
          navbar_home: "Inicio",
          navbar_about_us: "Nosotros",
          navbar_services: "Sistemas",
          navbar_portfolio: "Marca Blanca",
          navbar_resources: "Playbooks",
          navbar_blog: "Blog",
          navbar_documentation: "Documentación",
          contact_us: "Contactar",

          // Estas claves solo existían en el bloque `en` (y encima con el texto ya en
          // español). Como fallbackLng es "es", /reviews publicaba el identificador en
          // crudo: su H1 era literalmente "reviews_page_title".
          reviews_page_title: "Opiniones de Clientes",
          reviews_page_subtitle: "Opiniones de agencias que usan Invokeapp",
          reviews_intro_title: "Lo que dicen las agencias",
          reviews_intro_subtitle: "Feedback de operadores que entregan IA con Invokeapp.",
          reviews_quote_1: "Invokeapp nos permitió paquetizar entrega con IA sin equipo técnico.",
          reviews_quote_1_name: "Dueño de Agencia",
          reviews_quote_2: "Mejoramos margen y reducimos el caos operativo en semanas.",
          reviews_quote_2_name: "Responsable de Growth",
          reviews_quote_3: "Nuestros clientes reciben reporting claro y resultados cada mes.",
          reviews_quote_3_name: "Directora de Operaciones",

          // Idem en /investors: las claves estaban solo comentadas, así que la página
          // mostraba "investors_page_commercial_dossier_title" y compañía en crudo.
          investors_page_commercial_dossier_title: "Dossier Comercial",
          investors_page_commercial_dossier_description:
            "Qué es InvokeApp, a quién sirve y cómo genera ingresos recurrentes para las agencias que llevan la atención al cliente, las citas y el seguimiento comercial de sus clientes.",
          investors_page_commercial_dossier_download: "Descargar Dossier",
          investors_page_investor_deck_title: "Investor Deck",
          investors_page_investor_deck_description:
            "La presentación para inversores: mercado, producto, modelo de negocio, tracción y plan de crecimiento.",
          investors_page_investor_deck_download: "Descargar Deck",

          cookies_text:
            "Usamos cookies para mejorar tu experiencia y entender cómo las agencias utilizan nuestro sitio. Las cookies nos ayudan a personalizar contenido, medir rendimiento y mantener la plataforma estable. Al hacer clic en 'Aceptar todas', aceptas el uso de cookies. Puedes saber más en nuestra Política de Cookies y ajustar preferencias cuando quieras.",
          cookies_text_short:
            "Usamos cookies de análisis solo si las aceptas.",
          cookies_button: "Aceptar",

          page_title_about_us: "Hecho para agencias",
          about_video_kicker: "Nuestro compromiso",
          about_video_title: "¿Te impulsamos?",
          about_video_description:
            "Nuestras automatizaciones con inteligencia artificial son simples de usar, diseñadas estratégicamente para ayudarte, organizadas por proyectos, clientes y 100% trazadas con analítica para que veas el impacto en tiempo real.",
          about_video_bullet_1: "Workflows simples",
          about_video_bullet_2: "Orquestación organizada",
          about_video_bullet_3: "Trazabilidad y analítica",
          about_video2_kicker: "Más allá del marketing: atención y ventas para tus clientes",
          about_video2_title: "Organiza por proyectos y activa flujos por cliente",
          about_video2_description:
            "Estructura cada cuenta, activa automatizaciones y asócialas al cliente correcto. Fácil de explicar, escalable y bajo el control de tu agencia. Reserva una demo o contacta.",
          about_video2_bullet_1: "Rápida de vender",
          about_video2_bullet_2: "Crece con tu cartera de clientes",
          about_video2_bullet_3: "Procesos accionables",
          about_video3_kicker: "Impacto en la agencia",
          about_video3_title: "Una nueva línea de servicio recurrente para tu agencia",
          about_video3_description:
            "Automatizaciones gestionadas y seguras que amplían el margen sin añadir complejidad operativa.",
          about_video3_bullet_1: "Atención al cliente, citas y CRM",
          about_video3_bullet_2: "Ingresos recurrentes",
          about_video3_bullet_3: "Gestión escalable y segura",
          about_meet_team_cta: "Conoce al equipo",
          page_title_services: "Sistemas que escalan",
          page_title_portfolio: "Prueba y resultados",
          page_title_resources: "Toolkit para agencias",
          page_title_blog: "Notas de operador",
          page_title_blog_details: "Detalle del insight",
          page_title_policies: "Políticas",
          page_title_contact_us: "Hablemos",
          page_title_documentation: "Centro de ayuda",
          docs_page_title: "Centro de ayuda",
          docs_page_subtitle: "Explora el manual de Invokeapp por secciones",
          docs_empty: "No hay documentación disponible en este momento.",
          page_title_partnerships: "Partners",
          page_title_features: "Playbooks",
          features_page_title: "Playbooks",
          features_page_subtitle: "Una visión clara de lo que entrega Invokeapp",
          features_intro_title: "Capacidades clave",
          features_intro_subtitle: "Todo lo que necesitas para vender entrega con IA desde tu agencia.",
          features_item_1: "Automatizaciones y workflows de IA en marca blanca",
          features_item_2: "Reporting e insights listos para cliente",
          features_item_3: "Sistemas de cualificación y routing de leads",
          features_item_4: "Motores de contenido y distribución",
          features_item_5: "Monitorización, alertas y control operativo",
          features_playbook_1_title: "Captación y cualificación de leads",
          features_playbook_2_title: "Motor de contenido y distribución",
          features_playbook_3_title: "Reporting de cliente y QBR",
          features_playbook_4_title: "Operación de entrega y renovaciones",
          features_playbook1_card1_title: "Pipeline de captación",
          features_playbook1_card1_desc: "Captura leads y estandariza datos en segundos.",
          features_playbook1_card2_title: "Alertas speed-to-lead",
          features_playbook1_card2_desc: "Notifica al equipo en cuanto entra un formulario.",
          features_playbook1_card3_title: "Snapshot de cualificación",
          features_playbook1_card3_desc: "Resume intención y encaje con IA.",
          features_playbook2_card1_title: "Briefs de contenido con IA",
          features_playbook2_card1_desc: "Genera outlines y briefs listos para publicar.",
          features_playbook2_card2_title: "Publicación multicanal",
          features_playbook2_card2_desc: "Distribuye contenido en social y mensajería.",
          features_playbook2_card3_title: "Recap de performance",
          features_playbook2_card3_desc: "Informe automático de clics y conversiones.",
          features_playbook3_card1_title: "Dashboard de KPIs cliente",
          features_playbook3_card1_desc: "Centraliza métricas en una sola vista.",
          features_playbook3_card2_title: "Resumen ejecutivo semanal",
          features_playbook3_card2_desc: "Envía un recap limpio cada semana.",
          features_playbook3_card3_title: "Storyboard de QBR",
          features_playbook3_card3_desc: "Compila resultados para revisiones trimestrales.",
          features_playbook4_card1_title: "Automatización de kickoff",
          features_playbook4_card1_desc: "Automatiza onboarding y creación de tareas.",
          features_playbook4_card2_title: "Checklist de QA",
          features_playbook4_card2_desc: "Asegura entregables con tu estándar.",
          features_playbook4_card3_title: "Señales de renovación",
          features_playbook4_card3_desc: "Detecta riesgo y actúa antes del churn.",
          features_card_price_label: "Precio de venta",
          calc_roi_btn: "ROI",
          calc_roi_card: "esta automatización",
          calc_roi_section: "este playbook",
          features_playbook_total_label: "Total del paquete",
          features_playbook_roi_label: "ROI",
          eco_infra_badge: "INFRAESTRUCTURA",
          eco_infra_title: "Plataforma de Automatizaci\u00F3n con IA Invokeapp",
          eco_infra_desc: "Construimos y mantenemos los playbooks, workflows y agentes de IA. Piensa en nosotros como el sistema operativo para la automatizaci\u00F3n de agencias.",
          eco_ops_badge: "OPERADORES",
          eco_ops_title: "Agencias de Implementaci\u00F3n Certificadas",
          eco_ops_desc: "Estas agencias est\u00E1n entrenadas y certificadas para implementar nuestros playbooks en clientes finales. Cada nivel refleja experiencia comprobada.",
          eco_tier_elite: "Operador Elite",
          eco_tier_advanced: "Operador Avanzado",
          eco_tier_certified: "Operador Certificado",
          eco_clients_badge: "CLIENTES FINALES",
          eco_clients_title: "Negocios que Necesitan Automatizaci\u00F3n",
          eco_clients_desc: "Desde cl\u00EDnicas dentales hasta talleres mec\u00E1nicos \u2014 cualquier negocio que quiera atender mejor a sus clientes, tener sus citas en orden y no perder ning\u00FAn seguimiento. En cl\u00EDnicas, por WhatsApp solo se gestiona la log\u00EDstica de la cita (fecha, hora, confirmaci\u00F3n y recordatorio), nunca diagn\u00F3sticos, tratamientos ni datos de salud.",
          eco_cta_agency: "Soy agencia \u2014 hazte operador",
          eco_cta_business: "Necesito automatizaci\u00F3n \u2014 encontrar operador",
          features_playbook_pricing_note:
            "Los precios son una estimación de venta para agencias, no lo que cobra Invokeapp. Puedes vender procesos por separado, pero los playbooks están diseñados para aumentar el lifetime value de tus clientes.",
          playbooks_banner_kicker: "Playbooks",
          playbooks_banner_title: "Activa playbooks que elevan el LTV del cliente",
          playbooks_banner_description:
            "Descubre workflows paquetizados que tu agencia puede vender rápido manteniendo una entrega consistente y medible.",
          playbooks_banner_cta: "Ver playbooks",

          webinar_live_label: "Webinar en directo",
          webinar_cta: "Apúntate en Meetup",
          webinar_note: "Gratis · Plazas limitadas",
          webinar_platform: "Online vía Meetup",
          webinar_dismiss: "Cerrar aviso",
          webinar_aria_label: "Aviso de webinar",
          roi_calc_hero_kicker: "Calculadora de ROI",
          roi_calc_hero_title: "Estima el ROI de tu SaaS",
          roi_calc_hero_subtitle: "Descubre cuánto revenue y apalancamiento operativo puedes generar vendiendo sistemas de automatización con IA.",
          roi_calc_scenario_conservative: "Conservador",
          roi_calc_scenario_growth: "Crecimiento",
          roi_calc_scenario_scale: "Escalar",
          roi_calc_mode_agency: "Agencia / Implementador",
          roi_calc_mode_internal: "Negocio Interno",
          roi_calc_currency_eur: "\u20AC EUR",
          roi_calc_currency_usd: "$ USD",
          roi_calc_currency_gbp: "\u00A3 GBP",
          roi_calc_inputs_title_agency: "Parámetros de Agencia",
          roi_calc_inputs_title_internal: "Parámetros de Negocio",
          roi_calc_inputs_subtitle: "Ajusta los valores según tu modelo de negocio.",
          roi_calc_label_clients: "Número de Clientes",
          roi_calc_label_impl_fee: "Honorarios de Implementación",
          roi_calc_label_retainer: "Retainer Mensual/Cliente",
          roi_calc_label_automations: "Automatizaciones Entregadas/Mes",
          roi_calc_label_token_cost: "Costo Mensual de Tokens IA",
          roi_calc_label_platform_cost: "Costo Mensual de Plataforma",
          roi_calc_label_setup_fee: "Costo de Configuración Inicial",
          roi_calc_label_employees: "Empleados",
          roi_calc_label_salary: "Salario Anual Promedio",
          roi_calc_label_hours_lost: "Horas Perdidas/Semana en Tareas Manuales",
          roi_calc_label_hours_saved_week: "Horas Ahorradas/Semana vía IA",
          roi_calc_label_processes: "Procesos de IA Implementados",
          roi_calc_tooltip_clients: "Número de cuentas de clientes activas que gestionas.",
          roi_calc_tooltip_impl_fee: "Costo único por implementación de automatización.",
          roi_calc_tooltip_retainer: "Tarifa recurrente mensual por cliente.",
          roi_calc_tooltip_automations: "Número de proyectos de automatización entregados por mes.",
          roi_calc_tooltip_hours_saved_internal: "Horas semanales recuperadas mediante automatización con IA.",
          roi_calc_tooltip_token_cost: "Costo mensual del uso de tokens IA en todas las automatizaciones.",
          roi_calc_tooltip_platform_cost: "Costo mensual de la suscripción a Invokeapp.",
          roi_calc_tooltip_setup_fee: "Costo único de onboarding o integración.",
          roi_calc_tooltip_employees: "Total de empleados en tu organización.",
          roi_calc_tooltip_salary: "Salario anual promedio por empleado.",
          roi_calc_tooltip_hours_lost: "Horas semanales perdidas en tareas manuales repetitivas.",
          roi_calc_tooltip_processes: "Procesos de automatización con IA implementados.",
          roi_calc_results_title: "Resumen de tu ROI",
          roi_calc_results_subtitle: "Cálculo en tiempo real basado en tus datos",
          roi_calc_metric_monthly_revenue: "Ingreso Mensual",
          roi_calc_metric_annual_revenue: "Ingreso Anual",
          roi_calc_metric_token_cost: "Costo Mensual de Tokens",
          roi_calc_metric_net_profit: "Ganancia Neta Mensual",
          roi_calc_metric_annual_profit: "Ganancia Anual (sin setup)",
          roi_calc_metric_setup_fee: "Costo de Setup",
          roi_calc_metric_time_savings: "Ahorro de Tiempo Mensual",
          roi_calc_metric_cost_reduction: "Reducción de Costos Mensual",
          roi_calc_metric_productivity_gain: "Ganancia de Productividad",
          roi_calc_metric_annual_savings: "Ahorro Anual",
          roi_calc_metric_roi_multiple: "Múltiplo de ROI",
          roi_calc_metric_platform_cost: "Costo de Plataforma/Mes",
          roi_calc_chart_revenue_growth: "Proyección de Crecimiento Anual de Ingresos",
          roi_calc_chart_monthly_comparison: "Comparativa Mensual",
          roi_calc_chart_cost_impact: "Impacto en Costos",
          roi_calc_chart_monthly_savings_year: "Ahorros Mensuales Durante el Año",
          roi_calc_chart_roi_multiplier: "Múltiplo de ROI",
          roi_calc_comparison_without: "Sin Automatización",
          roi_calc_comparison_with: "Con Automatización",
          roi_calc_comparison_cost_lost: "Costo del Tiempo Perdido",
          roi_calc_comparison_savings_ai: "Ahorros con IA",
          roi_calc_gauge_platform_roi: "ROI de Plataforma",
          roi_calc_gauge_platform_roi_desc: "Cuántas veces el costo de la plataforma es cubierto por la ganancia neta cada mes.",
          roi_calc_gauge_efficiency_roi: "ROI de Eficiencia",
          roi_calc_gauge_efficiency_roi_desc: "Ahorros mensuales relativos a la inversión en plataforma.",
          roi_calc_payback_title: "Tiempo para recuperar el costo de la plataforma",
          roi_calc_payback_immediate: "Inmediato",
          roi_calc_payback_month: "Mes",
          roi_calc_payback_months: "Meses",
          roi_calc_footer_msg_strong: "Esta plataforma no es un gasto — es una infraestructura de ingresos.",
          roi_calc_footer_msg_prefix: "Con solo",
          roi_calc_footer_msg_one_client: "1 cliente",
          roi_calc_footer_msg_employees: "empleados",
          roi_calc_footer_msg_suffix: "cubres el costo de la plataforma. Todo lo demás es margen.",
          roi_calc_playbook_selected: "Workflow seleccionado:",
          roi_calc_playbook_selected_section: "Playbook seleccionado:",
          roi_calc_btn_share: "Compartir",
          roi_calc_btn_book_demo: "Reservar Demo",
          page_title_demo: "Demo en vivo",
          demo_page_title: "Demo en vivo",
          demo_page_subtitle: "Ve la plataforma en acción y diseña tu primer flujo de IA",
          demo_video_kicker: "Recorrido de la plataforma",
          demo_video_title: "Mira Invokeapp en acción y elige tu hueco para hablar. ¿Te hace?",
          demo_video_description:
            "Desde el intake hasta el reporting, verás cómo las agencias despliegan automatización, asistentes IA y KPIs sin sumar operaciones.",
          demo_video_bullet_1: "Workflows listos para cliente",
          demo_video_bullet_2: "Reporting automatizado",
          demo_video_bullet_3: "Onboarding rápido",
          demo_calendar_kicker: "Reserva tu slot",
          demo_calendar_title: "Elige fecha y hora para tu demo",
          demo_calendar_subtitle:
            "Selecciona un día y adaptamos la demo a tu agencia.",
          demo_intro_title: "¿Quieres verlo aplicado a tu caso?",
          demo_intro_subtitle:
            "Cuéntanos tu objetivo y te mostramos el flujo exacto que puedes lanzar.",
          demo_cta: "Reservar demo",
          demo_calendar_cta: "Abrir calendario",
          page_title_platform: "Plataforma",
          page_title_changelog: "Changelog",
          page_title_guidelines: "Guidelines",
          feature_vote_page_title: "Roadmap de funcionalidades",
          feature_vote_page_subtitle: "Vota por lo que construimos después",
          feature_vote_section_mini: "Participa",
          feature_vote_section_title: "¿Qué deberíamos construir después?",
          feature_vote_section_desc: "Vota por las próximas funcionalidades y ayuda a definir nuestro roadmap. Las más votadas se priorizan.",
          feature_vote_total_votes: "votos totales",
          feature_vote_votes: "votos",
          feature_vote_voted: "Votado",
          feature_vote_button: "Votar",
          feature_vote_sort_default: "Orden por defecto",
          feature_vote_sort_votes: "Más votados",
          feature_vote_title_1: "Dashboard avanzado de analíticas",
          feature_vote_desc_1: "KPIs en tiempo real con gráficos, rangos de fecha personalizables e informes exportables para presentaciones.",
          feature_vote_title_2: "Automatización inteligente de flujos",
          feature_vote_desc_2: "Disparadores con IA que aprenden patrones de tu equipo y sugieren optimizaciones para tareas recurrentes.",
          feature_vote_title_3: "Centro de integraciones externas",
          feature_vote_desc_3: "Conecta con 100+ herramientas incluyendo Slack, Notion, HubSpot y QuickBooks desde un gestor unificado.",
          feature_vote_title_4: "Generador de contenido con IA",
          feature_vote_desc_4: "Genera propuestas, informes y secuencias de email usando la voz de tu agencia y entregables pasados.",
          feature_vote_title_5: "Portal de cliente 2.0",
          feature_vote_desc_5: "Panel del cliente con el logo de tu agencia donde los clientes ven progreso, descargan informes y aprueban entregables en tiempo real.",
          feature_vote_title_6: "QA automatizado",
          feature_vote_desc_6: "Ejecuta tests de regresión tras cada actualización y recibe alertas antes de que un cliente detecte un error.",
          faq_page_title: "Preguntas frecuentes",
          faq_page_subtitle: "Respuestas para agencias que usan InvokeApp",
          faq_section_title: "Preguntas frecuentes",
          faq_section_subtitle: "Respuestas claras para lanzar y escalar rápido.",
          faq_schema_title: "2. FAQ Schema (Dominar las búsquedas de \"Cómo...\")",
          faq_schema_text:
            "Si en tu página de Features o Home tienes una sección de Preguntas Frecuentes, no las pongas solo como texto. Si usas el FAQ Schema, Google mostrará tus preguntas directamente en los resultados de búsqueda, ocupando más espacio y robando clics a la competencia.",
          guidelines_page_title: "Guidelines",
          guidelines_page_subtitle: "Estándares para agencias que operan Invokeapp",
          guidelines_intro_title: "Guías operativas",
          guidelines_intro_subtitle: "Buenas prácticas para proteger la calidad y los resultados.",
          guidelines_item_1: "Define el resultado y los KPIs antes de activar.",
          guidelines_item_2: "Revisa automatizaciones semanalmente para evitar deriva.",
          guidelines_item_3: "Reporta resultados de forma consistente para renovar.",
          changelog_page_title: "Changelog",
          changelog_page_subtitle: "Actualizaciones del producto para agencias que usan Invokeapp",
          changelog_intro_title: "Últimas actualizaciones",
          changelog_intro_subtitle: "Notas de versión y mejoras operativas",
          changelog_item_1: "Nuevas plantillas de automatización y workflows de IA",
          changelog_item_2: "Mejoras en reporting e insights de KPIs",
          changelog_item_3: "Actualizaciones de estabilidad y rendimiento de la plataforma",
          changelog_empty: "No hay actualizaciones disponibles ahora mismo.",
          platform_page_title: "Plataforma Invokeapp",
          platform_page_subtitle: "La capa operativa para agencias que entregan Automatización e IA",
          platform_hero_kicker: "Modo Agencia",
          platform_hero_title: "Atención al cliente, citas y ventas para tus clientes, sin equipo técnico",
          platform_hero_subtitle:
            "Invokeapp es la plataforma con la que tu agencia lleva la atención al cliente, las citas, el CRM y el seguimiento comercial de sus clientes, con la IA como apoyo en cada proceso. Tú mantienes la relación con el cliente y el recurrente mientras nosotros operamos la tecnología.",
          platform_hero_bullet_1: "Entrega bajo el control de tu agencia y reporting listo para cliente",
          platform_hero_bullet_2: "Automatizaciones, asistentes IA e integraciones ya conectadas",
          platform_hero_bullet_3: "Monitoreo operativo, alertas y control de calidad",
          platform_hero_bullet_4: "Capa de datos que convierte resultados en renovación",
          platform_cta_primary: "Ir a la plataforma",
          platform_cta_secondary: "Hablar con el equipo",
          platform_form_title: "Modo Agencia",
          platform_form_subtitle: "Conecta. Escala. Automatiza.",
          platform_form_section_company: "Datos de la empresa",
          platform_form_company_name: "Nombre de la empresa",
          platform_form_section_language: "Idioma",
          platform_form_language_en: "Inglés",
          platform_form_language_es: "Español",
          platform_form_section_contact: "Contacto administrador",
          platform_form_first_name: "Nombre",
          platform_form_last_name: "Apellido",
          platform_form_email: "Correo electrónico",
          platform_form_section_security: "Seguridad",
          platform_form_password: "Contraseña",
          platform_form_password_confirm: "Repetir contraseña",
          platform_form_password_toggle: "Mostrar u ocultar contraseña",
          platform_form_section_business: "Tipo de negocio",
          platform_form_business_entrepreneur_title: "Emprendedor",
          platform_form_business_entrepreneur_desc:
            "Ideal para freelancers y solopreneurs. Empieza con automatizaciones simples.",
          platform_form_business_studio_title: "Estudio",
          platform_form_business_studio_desc:
            "Diseñado para estudios creativos y equipos pequeños.",
          platform_form_business_agency_title: "Agencia",
          platform_form_business_agency_desc:
            "Perfecto para agencias en crecimiento. Desbloquea workflows avanzados y automatización multicanal.",
          platform_form_business_corporate_title: "Corporativo",
          platform_form_business_corporate_desc:
            "Para corporaciones que gestionan múltiples equipos y departamentos.",
          platform_form_business_enterprise_title: "Enterprise",
          platform_form_business_enterprise_desc:
            "Exclusivo para grandes empresas y builders tecnológicos.",
          platform_form_terms_prefix: "Acepto los",
          platform_form_terms_link: "Términos y Condiciones",
          platform_form_error_password: "Las contraseñas no coinciden.",
          platform_form_error_terms: "Debes aceptar los Términos y Condiciones.",
          platform_form_error_email: "Introduce un correo electrónico válido.",
          platform_form_error_required: "Completa todos los campos obligatorios.",
          platform_form_error_generic: "No pudimos crear la cuenta. Intenta de nuevo.",
          platform_form_success: "Cuenta creada. Revisa tu correo para continuar.",
          platform_form_submit: "Continuar",
          platform_form_submit_loading: "Creando cuenta...",
          platform_form_signin: "¿Ya tienes cuenta?",
          platform_form_signin_link: "Iniciar sesión",
          platform_capabilities_title: "Capacidades que puedes monetizar",
          caps_split_title: "Vende el sistema entero o solo la pieza",
          caps_split_subtitle:
            "Los mismos procesos, empaquetados de dos maneras: un playbook es el servicio entero, ya ordenado por etapas; el catálogo es cada proceso por separado.",
          shop_tab_playbooks: "Playbooks",
          shop_tab_catalog: "Catálogo",
          caps_tabs_aria: "Playbooks o catálogo de procesos",
          caps_playbooks_intro:
            "Un playbook es el servicio ya montado: uno o varios procesos encadenados por etapas, en el orden en que se activan. Está pensado para contratarse entero porque las etapas se sostienen entre ellas —una cita que nadie recuerda ni recupera cuando se cae no llega a facturarse— y cada una está pensada para relevar trabajo que hoy se hace a mano. Por eso se cobra al mes y no una sola vez.",
          caps_catalog_intro:
            "El catálogo es ese mismo trabajo en piezas: cada proceso por separado y, cuando su ficha comercial ya está publicada, con su precio. Úsalo cuando sabes qué le falta a un cliente concreto o cuando prefieras armar tu propia escalera. Los procesos que componen un playbook salen de este mismo catálogo.",
          caps_playbooks_cta: "Ver la escalera completa, etapa a etapa",
          platform_capabilities_subtitle:
            "Sistemas preconfigurados que tu agencia vende como retainer mensual.",
          faq_q1: "¿Cómo ayuda InvokeApp a una agencia con la atención al cliente, las citas y las ventas de sus clientes?",
          faq_a1:
            "InvokeApp te da playbooks, integraciones y flujos de activación de cliente ya preparados para la atención al cliente, las citas, el CRM y el seguimiento comercial, para entregar resultados sin construir desde cero.",
          faq_q2: "¿Cómo doy de alta a un cliente sin ver sus credenciales?",
          faq_a2:
            "Usa Secure Client Activation (SCA): el cliente conecta sus herramientas en una página dedicada y las credenciales permanecen privadas.",
          faq_q3: "¿Cómo se entregan los workflows y playbooks?",
          faq_a3:
            "Elige una integración, define el contexto del proyecto y el workflow se ejecuta con monitorización, alertas y analítica.",
          faq_q4: "¿Qué tan rápido puedo activar a un nuevo cliente?",
          faq_a4:
            "La mayoría de agencias activan en horas; stacks complejos suelen requerir unos días según aprobaciones.",
          faq_q5: "¿Cómo mido resultados y ROI?",
          faq_a5:
            "InvokeApp registra KPIs, conversiones y pasos de ejecución para reportar impacto y defender renovaciones.",
          faq_q6: "¿Quién gestiona la relación con mis clientes?",
          faq_a6:
            "Tu agencia: tú defines la oferta y el proceso y hablas con tus clientes, e InvokeApp pone la plataforma como tu partner tecnológico.",
          platform_capability_1_title: "Estrategia de Contenido Infinito",
          platform_capability_1_desc:
            "De una idea a piezas para LinkedIn, X e Instagram en horas.",
          platform_capability_2_title: "Cualificación de Leads por WhatsApp",
          platform_capability_2_desc:
            "Asistente IA que filtra y envía solo los calientes al CRM.",
          platform_capability_3_title: "Informes de Rendimiento Inteligentes",
          platform_capability_3_desc:
            "Resúmenes ejecutivos que traducen GA4 y Ads en decisiones.",
          platform_capability_4_title: "Ghostwriting para Directivos",
          platform_capability_4_desc:
            "Marca personal automatizada con radar de noticias del sector.",
          platform_outcomes_title: "Qué cambia en tu agencia",
          platform_outcomes_subtitle:
            "Tú vendes el resultado; Invokeapp ejecuta la entrega.",
          platform_outcomes_bullet_1: "Lanzas nuevos retainers en semanas.",
          platform_outcomes_bullet_2: "Aumentas margen con delivery estandarizado.",
          platform_outcomes_bullet_3: "Reduces churn con reporting claro.",
          platform_outcomes_bullet_4: "Escalas sin contratar programadores.",
          platform_outcomes_bullet_5:
            "Mantienes la relación comercial y el cobro.",
          platform_outcomes_panel_title: "Qué incluye la plataforma",
          platform_outcomes_panel_subtitle:
            "Módulos listos para operar en clientes finales.",
          platform_outcomes_panel_item_1: "Orquestador de workflows e integraciones",
          platform_outcomes_panel_item_2: "Asistentes IA y plantillas probadas",
          platform_outcomes_panel_item_3: "Base de KPIs y reporting ejecutivo",
          platform_outcomes_panel_item_4: "Portal de entregables y seguimiento",
          platform_pillars_title: "Infraestructura operativa para agencias",
          platform_pillars_subtitle:
            "Entrega consistente sin construir un equipo técnico.",
          platform_pillar_1_title: "Motor de Entrega",
          platform_pillar_1_desc:
            "Workflows, integraciones y modelos IA preconfigurados.",
          platform_pillar_2_title: "Calidad y Monitoreo",
          platform_pillar_2_desc:
            "Alertas, chequeos y QA automatizados.",
          platform_pillar_3_title: "Reporting para Cliente",
          platform_pillar_3_desc:
            "Dashboards y resúmenes que justifican el retainer.",
          platform_pillar_4_title: "Capa de Conocimiento",
          platform_pillar_4_desc:
            "Playbooks y contexto que aceleran la entrega.",
          platform_steps_title: "Cómo escalan las agencias con Invokeapp",
          platform_steps_subtitle:
            "Un loop simple para convertir entrega en ingresos recurrentes.",
          platform_step_1_title: "Empaqueta el resultado",
          platform_step_1_desc:
            "Define el outcome que vendes y el KPI que prometes.",
          platform_step_2_title: "Despliega en nuestra infraestructura",
          platform_step_2_desc:
            "Activamos automatizaciones, asistentes IA e integraciones.",
          platform_step_3_title: "Monitorea, reporta, renueva",
          platform_step_3_desc:
            "El cliente ve resultados y tú proteges margen.",
          partner_page_title: "Programa de Partners",
          partner_page_subtitle: "Hazte partner tecnológico de Invokeapp",
          partner_hero_kicker: "Programa de Partners",
          partner_hero_title: "Implanta InvokeApp con tus clientes",
          partner_hero_subtitle: "Ofrece atención al cliente, citas, CRM y seguimiento comercial a tus clientes con ingresos recurrentes, mientras nosotros operamos la plataforma.",
          partner_hero_cta_primary: "Solicitar Partnership",
          partner_hero_cta_secondary: "Saber más",
          partner_program_title: "Qué incluye el Programa de Partners Tecnológicos",
          partner_program_subtitle: "Una plataforma lista para agencias que implantan atención al cliente, citas y seguimiento comercial a sus clientes.",
          partner_program_col_1_title: "Propiedad Comercial",
          partner_program_col_1_desc: "Tú controlas pricing, posicionamiento y la relación con el cliente. Nosotros ponemos y mantenemos la plataforma con la que entregas.",
          partner_program_col_1_bullet_1: "Demos, implantación y soporte de primer nivel a cargo de tu agencia",
          partner_program_col_1_bullet_2: "El cobro recurrente se queda en tu agencia",
          partner_program_col_1_bullet_3: "Reporting y resultados orientados a cliente",
          partner_program_col_2_title: "Infraestructura Operativa",
          partner_program_col_2_desc: "Aportamos sistemas, automatización y workflows con IA para entregar a escala.",
          partner_program_col_2_bullet_1: "Playbooks e implementaciones probadas",
          partner_program_col_2_bullet_2: "Monitoring, alertas y control de calidad",
          partner_program_col_2_bullet_3: "Soporte para despliegue y optimización",
          partner_benefits_title: "Por Qué Funciona",
          partner_benefits_subtitle: "Un modelo simple que mejora tu oferta sin añadir equipo.",
          partner_benefits_paragraph: "El programa está diseñado para agencias que quieren escalar la entrega con IA sin contratar ingeniería. Tú mantienes el margen y nosotros garantizamos la ejecución. Además, ofrecemos un programa de incentivos para partners que expanden cuentas, mantienen la retención y crecen MRR mes a mes.",
          partner_benefit_1: "Sin ingenieros ni equipo de IA",
          partner_benefit_2: "Retainers justificados con reporting claro",
          partner_benefit_3: "Operación basada en sistemas repetibles",
          partner_benefit_4: "Tú mantienes la relación comercial",
          page_title_operators: "Operadores",
          page_title_reviews: "Opiniones",
          page_title_home: "Atención al cliente, citas y CRM para agencias",
          page_meta_home: "La plataforma para agencias y sus clientes: atención al cliente, citas, CRM y seguimiento comercial en un solo sitio, con la IA como apoyo en cada proceso. Sin ingenieros.",
          page_meta_about: "InvokeApp da a las agencias la plataforma de atención al cliente, citas, CRM y seguimiento comercial para entregar más a sus clientes sin ampliar el equipo técnico.",
          page_meta_services: "Servicios para agencias y sus clientes: captación, atención al cliente, citas, seguimiento comercial y retención, con la automatización y la IA como apoyo.",
          page_meta_platform: "La plataforma InvokeApp: atención al cliente, citas, CRM, seguimiento comercial e integraciones para agencias y sus clientes, con la IA como apoyo en cada proceso.",
          page_meta_pricing: "Precios simples y escalables para agencias: atención al cliente, citas, CRM y seguimiento comercial para tus clientes, sin contratar más personal.",
          page_meta_operators: "Descubre los operadores certificados de InvokeApp: agencias que entregan IA y automatización con rendimiento probado. Explora niveles certified, advanced y elite.",
          page_meta_reviews: "Lo que dicen las agencias de InvokeApp: opiniones reales sobre gestionar la atención al cliente, las citas y el seguimiento comercial de sus clientes.",
          page_meta_contact: "Habla con el equipo de InvokeApp. Agenda una llamada para ver cómo llevar la atención al cliente, las citas, el CRM y el seguimiento comercial de los clientes de tu agencia.",
          page_title_team: "Equipo",
          team_hero_title: "Nuestro equipo",
          team_breadcrumb: "Equipo",
          team_section_kicker: "Nuestro equipo",
          team_section_title: "Ayudamos a crear las grandes agencias del futuro.",
          team_role_ceo: "CEO, CTO y Fundador",
          team_role_cfo: "CFO, Cofundadora",
          team_role_cmo: "CMO, Cofundadora",
          page_title_privacy: "Política de Privacidad",
          page_title_terms: "Términos del Servicio",
          page_title_cookies: "Política de Cookies",
          page_title_legal_notice: "Aviso Legal",
          page_title_data_deletion: "Eliminación de Datos",
          page_title_subprocessors: "Subencargados",
          page_title_dpa: "Acuerdo de Encargo del Tratamiento",
          legal_header_subtitle: "Información legal",
          footer_privacy: "Privacidad",
          footer_terms: "Términos",
          footer_cookies: "Cookies",
          footer_legal_notice: "Aviso legal",
          footer_data_deletion: "Eliminación de datos",
          footer_subprocessors: "Subencargados",
          footer_dpa: "Encargo del tratamiento",
          cookies_decline: "Rechazar",
          cookies_policy_link: "Política de cookies",
          cookies_meta: "Política de cookies de InvokeApp: qué cookies usa la web y cómo aceptarlas o rechazarlas.",
          legal_notice_meta: "Aviso legal de InvokeApp: titular de invokeapp.io, MARTÍNEZ CAMPOY CONSULTING, S.L.",
          data_deletion_meta: "Cómo desconectar tus cuentas de Google, WhatsApp, Instagram o Facebook de InvokeApp y pedir el borrado de tus datos.",
          subprocessors_meta: "Proveedores que tratan datos personales por cuenta de InvokeApp, con su ubicación y garantías.",
          dpa_meta: "Acuerdo de encargo del tratamiento de InvokeApp (artículo 28 del RGPD) para agencias y empresas que usan la plataforma.",
          // Versiones de los textos legales: /legal/history y /legal/history/:doc/:version
          legal_previous_versions: "Versiones anteriores",
          legal_history_title: "Versiones de los textos legales",
          legal_history_meta: "La versión vigente y las anteriores de los textos legales de InvokeApp, con su fecha y su huella.",
          legal_history_intro: "Cada versión de nuestros textos legales se identifica con un número y una fecha. Aquí puedes leer, tal cual se publicaron, la versión vigente y las versiones anteriores archivadas de cada texto, o descargar el fichero original en castellano o en inglés.",
          legal_history_intro_hash: "Junto a cada fichero va el principio de su huella sha256: si descargas el fichero y calculas su sha256, coincide con la que publicamos. Así se comprueba que el texto no ha cambiado desde que se publicó.",
          legal_history_index: "Documentos",
          legal_history_live: "Ver la versión vigente",
          legal_history_col_version: "Versión",
          legal_history_col_date: "Fecha",
          legal_history_col_status: "Estado",
          legal_history_col_files: "Ficheros y huella sha256",
          legal_history_current: "Vigente",
          legal_history_previous: "Anterior",
          legal_history_version: "Versión",
          legal_history_version_meta: "{{doc}}, versión {{version}} de {{date}}, archivada tal cual se publicó.",
          legal_history_current_notice: "Esta es la versión vigente, archivada tal cual se publicó.",
          legal_history_archived_notice: "Versión histórica, no vigente.",
          legal_history_see_current: "Ver la versión vigente ({{version}})",
          legal_history_download: "Descargar el fichero original",
          legal_history_all_versions: "Todas las versiones",
          legal_history_loading: "Cargando el texto archivado…",
          legal_history_error: "No se ha podido cargar el texto archivado. Puedes abrir el fichero original aquí:",
          legal_history_doc_terms: "Condiciones de servicio",
          legal_history_doc_dpa: "Acuerdo de encargo del tratamiento (DPA)",
          legal_history_doc_privacy: "Política de privacidad",
          legal_history_doc_subprocessors: "Subencargados del tratamiento",
          legal_history_doc_cookies: "Política de cookies",
          legal_history_doc_data_deletion: "Eliminación de datos",
          legal_history_doc_legal_notice: "Aviso legal",
          footer_cursor_off: "Usar cursor normal",
          footer_cursor_on: "Usar cursor InvokeApp",
          home_footer_resources_hub: "Recursos",
          home_footer_company_jobs: "Trabajos",
          home_footer_company_press: "Prensa",
          resources_page_title: "Recursos",
          resources_page_description: "Kits, webinars y artículos de InvokeApp para crear y vender servicios de IA.",
          resources_page_intro: "Todo lo que publicamos para ayudarte a crear y vender servicios de IA: kits, webinars y artículos.",
          resources_aikit_text: "Plantillas y guías para definir, poner precio y entregar tu primer servicio de IA.",
          resources_open: "Abrir",
          resources_webinars_title: "Webinars y comunidad",
          resources_webinars_text: "Sesiones en directo y la comunidad de Meetup para agencias, freelancers y consultores que trabajan con IA.",
          resources_webinars_cta: "Ir a Meetup",
          resources_blog_title: "Blog",
          resources_blog_text: "Artículos sobre cómo las agencias crean y venden servicios de IA.",
          jobs_page_title: "Trabajos",
          jobs_page_description: "Trabaja en InvokeApp.",
          jobs_page_intro: "Aquí publicaremos los puestos que abramos.",
          jobs_none_title: "Ahora mismo no hay vacantes abiertas",
          jobs_none_text: "Si aun así quieres trabajar con nosotros, envíanos tu CV y cuéntanos qué aportarías.",
          jobs_mail_subject: "Candidatura - InvokeApp",
          jobs_apply_cta: "Enviar candidatura espontánea",
          press_page_title: "Prensa",
          press_page_description: "Recursos de marca de InvokeApp: logos, colores y contacto de prensa.",
          press_page_intro: "Recursos de marca para prensa, partners y eventos. Usa los logos tal cual, sin cambiar sus colores ni sus proporciones.",
          press_logo_color: "Logo",
          press_logo_white: "Logo sobre fondo oscuro",
          press_logo_negative: "Logo en negativo",
          press_logo_cyan: "Logo cian",
          press_icon_title: "Icono",
          press_icon_text: "Para avatares y espacios pequeños.",
          press_colors_title: "Colores de marca",
          press_color_cyan: "Cian",
          press_color_violet: "Violeta",
          press_contact_title: "Contacto de prensa",
          press_contact_text: "Entrevistas, información u otros formatos de la marca.",
          press_mail_subject: "Prensa - InvokeApp",
          bvb_kicker: "Build vs Buy",
          bvb_title: "¿Construirlo tú o empezar a vender este mes?",
          bvb_subtitle: "Montar tu propia plataforma de servicios de IA parece más barato hasta que sumas el tiempo, el equipo y todo lo que tiene que seguir funcionando. Esto es lo que cambia al comprar.",
          bvb_build: "Construirlo tú",
          bvb_buy: "Con InvokeApp",
          bvb_race_kicker: "Tiempo hasta facturar",
          bvb_race_title: "Mientras construyes, otros ya están vendiendo",
          bvb_race_text: "El mismo tiempo, dos caminos. Construyendo, todo va antes de tu primera venta. Con InvokeApp la puesta en marcha es corta y el resto del tiempo es para vender.",
          bvb_race_build_1: "Elegir modelos",
          bvb_race_build_2: "Infraestructura",
          bvb_race_build_3: "Integraciones",
          bvb_race_build_4: "Pruebas",
          bvb_race_build_5: "Seguridad",
          bvb_race_build_6: "Interfaz",
          bvb_race_buy_1: "Activar",
          bvb_race_buy_2: "Configurar",
          bvb_race_buy_3: "Tu marca",
          bvb_race_selling: "Vendiendo a tus clientes",
          bvb_race_build_finish: "Por fin, primera venta",
          bvb_race_buy_finish: "Primera venta",
          bvb_race_axis_start: "Hoy",
          bvb_race_axis_time: "Tiempo",
          bvb_ice_kicker: "Lo que no se ve",
          bvb_ice_title: "Tu cliente ve la punta. Alguien tiene que cargar con el resto",
          bvb_ice_text: "Un servicio de IA es la parte visible. Debajo está todo lo que lo mantiene funcionando cada día.",
          bvb_ice_tip: "Tu servicio de IA",
          bvb_ice_l1: "Modelos y prompts",
          bvb_ice_l2: "Integraciones: CRM, WhatsApp, correo",
          bvb_ice_l3: "Servidores y escalado",
          bvb_ice_l4: "Monitorización y fallos",
          bvb_ice_l5: "Actualizaciones de modelos",
          bvb_ice_l6: "Soporte y mantenimiento",
          bvb_ice_yours: "Cosa tuya",
          bvb_ice_included: "Incluido",
          bvb_cost_kicker: "Coste en el tiempo",
          bvb_cost_title: "Construir cuesta al principio, y después sigue costando",
          bvb_cost_text: "Construir empieza con una inversión fuerte y sigue creciendo con el mantenimiento y los cambios. Comprar es una cuota previsible desde el primer día.",
          bvb_cost_aria: "Coste acumulado en el tiempo: construir crece más rápido que comprar",
          bvb_cost_gap: "Lo que no gastas",
          bvb_cost_axis_x: "Tiempo",
          bvb_cost_axis_y: "Coste acumulado",
          bvb_cost_note_upfront: "Inversión inicial",
          bvb_verdict_title: "Por qué sale a cuenta comprar",
          bvb_verdict_1_title: "Vendes antes",
          bvb_verdict_1_text: "Dedicas el tiempo a vender servicios de IA, no a construir la plataforma que hay detrás.",
          bvb_verdict_2_title: "Foco en tus clientes",
          bvb_verdict_2_text: "Tu equipo sigue en la estrategia y las cuentas, no en servidores e integraciones.",
          bvb_verdict_3_title: "Creces sin rehacer",
          bvb_verdict_3_text: "Nuevos procesos y clientes sobre la misma plataforma, con tu agencia al frente de la relación.",
          bvb_verdict_cta: "Reservar una demo",
          privacy_meta: "Política de privacidad de InvokeApp: cómo trata MARTÍNEZ CAMPOY CONSULTING, S.L. los datos personales, incluidos los de Google, Meta y la IA.",
          terms_meta: "Términos del Servicio de InvokeApp — las reglas de uso de nuestro sitio web, plataforma e integraciones.",
          operators_page_title: "Operadores",
          operators_page_subtitle: "Agencias premiadas por rendimiento",
          operators_intro_title: "Niveles de performance",
          operators_intro_subtitle: "Operadores son agencias con entrega consistente y resultados destacados.",
          operators_level_1: "Nivel 1: Operador Certificado",
          operators_level_2: "Nivel 2: Operador Avanzado",
          operators_level_3: "Nivel 3: Operador Elite",
          operators_directory_title: "Nuestros operadores",
          operators_directory_subtitle: "Agencias certificadas que entregan con Invokeapp.",
          operators_visit_site: "Visitar web",
          operators_empty: "Todavía no hay operadores que mostrar.",
          operators_error: "No pudimos cargar los operadores. Inténtalo de nuevo más tarde.",
          home_footer_resources_operators: "Operadores",
          home_footer_resources_reviews: "Opiniones",
          home_footer_resources_guidelines: "Guías",
          home_footer_platform_features: "Playbooks",
          home_footer_platform_demo: "Demo",
          home_footer_sales_followup: "Seguimiento comercial con IA",
          home_footer_sales_followup_to: "/ai-sales-follow-up",
          home_footer_consulting: "Consultoría con IA",
          home_footer_consulting_to: "/ai-consulting",
          home_footer_contact_affiliates: "Afiliados",
          home_footer_contact_agencies: "Agencias",
          home_footer_contact_partners: "Partners",
          home_footer_contact_product: "Producto",
          home_footer_contact_scale: "Escala",
          home_footer_contact_explore: "Explorar",
          google_for_startups_label: "Google for Startups",
          google_for_startups_tooltip:
            "Seleccionados por Google for Startups para escalar nuestra infraestructura con tecnología cloud de alto rendimiento.",
          partner_final_kicker: "Listo para partner",
          partner_final_title: "Convierte la entrega con IA en ingresos recurrentes",
          partner_final_cta: "Solicitar Partnership",

          home_slider_title_superior_one: "Vende tecnología sin equipo técnico.",
          home_slider_title_superior_two: "Infraestructura para agencias que escalan márgenes",
          home_slider_title_main_copy_one1: "Convierte tu agencia en",
          home_slider_title_main_copy_one2: "una máquina de facturar con IA operativa",
          home_slider_title_main_copy_two1: "Delega en nuestra infraestructura",
          home_slider_title_main_copy_two2: "tu nueva fuente de ingresos.",

          home_two_features_title_superior_mini: "Capacidades operativas para agencias",
          home_two_features_title_one: "Activa",
          home_two_features_title_two: "ingresos recurrentes",
          home_two_features_subtitle:
            "Pon sin fricción en el mercado procesos para tus clientes y cobra por ellos. Invokeapp te da sistemas de Automatización e IA listos para operar, sin contratar programadores.",
          home_two_features_button_text: "Ver capacidades",
          
          home_techgrid_kicker: "Suscríbete. Activa. Atiende a tus clientes.",
          // home_techgrid_title: "Infraestructura lista para aumentar tus ingresos",
          home_techgrid_title: "Atención al cliente, citas y seguimiento comercial para agencias y sus clientes",
          home_techgrid_text: "La plataforma que activas por suscripción: procesos ya construidos de atención al cliente, citas, CRM y seguimiento comercial que configuras para cada cliente, con la IA como apoyo. Sin contratar perfiles técnicos.",
          home_techgrid_cta_secondary: "Ver precios",

          // Banner de la auditoría gratuita (home): habla de VENDER IA a los
          // clientes de la agencia, en linea con el hero, no de automatizar por dentro.
          ai_audit_kicker: "Auditoría gratuita para agencias",
          ai_audit_title: "Revisamos tu agencia y te decimos qué procesos puedes ofrecer a tus clientes",
          ai_audit_text:
            "Una sesión de 30 minutos en la que repasamos tu cartera de clientes y sales con una lista concreta: qué procesos de atención al cliente, citas, CRM y seguimiento comercial puedes ofrecer a tus clientes, a qué precio y cuánto margen te queda. Sin coste y sin compromiso.",
          ai_audit_cta: "Reservar mi auditoría",
          wa_fab_title: "Habla con nuestro recepcionista virtual",
          wa_fab_text: "Es el mismo que tus clientes pueden usar para su propia atención al cliente. Pruébalo por WhatsApp.",
          wa_fab_aria: "Abrir WhatsApp",
          wa_fab_close: "Cerrar el mensaje",

          dvm_headline: "Ofrece atención al cliente, citas y seguimiento comercial. Nosotros te damos el sistema completo.",
          dvm_prefix: "Con",
          dvm_all_solved: "Todo ello, ya resuelto.",
          dvm_lead: "Activa Playbooks completos para resolver una necesidad de principio a fin o selecciona procesos individuales desde el Catálogo.",
          dvm_cta_playbooks: "Explorar Playbooks",
          dvm_cta_catalog: "Ver Catálogo",

          pbs_kicker: "Así funciona un Playbook",
          pbs_title: "De elegir qué vender a demostrar el retorno",
          pbs_subtitle: "El mismo sistema, activándose por etapas. Baja para recorrerlo.",
          pbs_stage_of: "Etapa {{current}} de {{total}}",
          pbs_recommended: "Recomendado",
          pbs_see: "Ver",
          pbs_no_passwords: "Tú no recibes ni guardas contraseñas.",
          pbs_roadmap: "En desarrollo",
          pbs_live: "Disponible",
          pbs_problem: "Qué problema resuelve",
          pbs_result: "Qué resultado genera",
          pbs_automates: "Qué automatiza",
          pbs_price: "Precio de venta sugerido",
          pbs_month: "mes",
          pbs_impact: "Impacto estimado",

          demo_modal_new_tab: "Abrir en una pestaña nueva",
          demo_modal_close: "Cerrar la demo",

          discovery_kicker: "Sesión en directo",
          discovery_title: "Prueba la sesión de descubrimiento",
          discovery_subtitle: "Una conversación guiada que convierte lo que hace hoy tu agencia en un plan de negocio: qué procesos automatizar primero, qué vender y dónde está el margen.",
          discovery_facade_title: "Empieza la sesión de descubrimiento",
          discovery_facade_text: "Se abre aquí mismo. Son unos minutos y sales con un plan concreto.",
          discovery_facade_cta: "Empezar",
          discovery_iframe_title: "Sesión de descubrimiento de InvokeApp",
          discovery_open_tab: "Abrir en una pestaña nueva",

          home_sell_faq_title: "Preguntas frecuentes",
          home_sell_faq_q1: "¿Por qué no hacerlo con Lovable o n8n?",
          home_sell_faq_a1: "Con esas plataformas tienes que construirlo, probarlo y mantenerlo tú. Con InvokeApp ya lo tienes preparado para ofrecerlo directamente a tus clientes.",
          home_sell_faq_q2: "¿Necesito conocimientos técnicos?",
          home_sell_faq_a2: "No. Configura los servicios, adáptalos a cada cliente y empieza a venderlos.",
          home_sell_faq_q3: "¿Quién lleva la relación con mis clientes?",
          home_sell_faq_a3: "Tu agencia. Tú mantienes la relación y la propuesta comercial con tus clientes; InvokeApp es tu partner tecnológico.",
          home_sell_faq_q4: "¿Puedo personalizarlo para cada cliente?",
          home_sell_faq_a4: "Sí. Cada cliente dispone de sus propios proyectos, agentes, datos, integraciones y procesos.",
          home_sell_faq_q5: "¿Se conecta con mis herramientas actuales?",
          home_sell_faq_a5: "Sí. InvokeApp se integra con las plataformas que tu agencia y tus clientes ya utilizan.",
          home_sell_faq_q6: "¿Qué servicios puedo vender?",
          home_sell_faq_a6: "Servicios de captación, seguimiento comercial, atención al cliente, contenido, automatización, datos y reporting.",
          home_sell_faq_q7: "¿Quién se encarga del mantenimiento?",
          home_sell_faq_a7: "Nosotros mantenemos la plataforma y sus funcionalidades para que tú puedas centrarte en vender y atender a tus clientes.",
          home_sell_faq_q8: "¿Cuánto se tarda en empezar?",
          home_sell_faq_a8: "Puedes comenzar con los servicios disponibles sin desarrollar una solución desde cero.",
          home_techgrid_step_1_title: "Te suscribes",
          home_techgrid_step_1_text: "Eliges plan y entras en la plataforma. Sin instalar nada ni desarrollar.",
          home_techgrid_step_2_title: "Activas el proceso",
          home_techgrid_step_2_text: "Lo eliges del catálogo y lo configuras para cada cliente.",
          home_techgrid_step_3_title: "Lo ofreces como servicio de tu agencia",
          home_techgrid_step_3_text: "Tú mantienes la relación con el cliente, pones el precio de tu servicio y te quedas el margen.",
          home_techgrid_chip_one: "Procesos listos para vender",
          home_techgrid_chip_two: "Tus clientes en un panel",
          home_techgrid_chip_three: "Desde 149 €/mes",

          home_two_features_card_title_one: "Margen inmediato",
          home_two_features_card_description_one:
            "Sustituye horas manuales por workflows que tu equipo opera en minutos.",
          home_two_features_card_title_two: "Control operativo",
          home_two_features_card_description_two:
            "Monitoriza ejecuciones, costes y fallos antes de que el cliente los vea.",
          home_two_features_card_title_three: "Retención por resultados",
          home_two_features_card_description_three:
            "Reporting claro que justifica el retainer mes a mes.",
          home_two_features_card_title_four: "Ventas 24/7",
          home_two_features_card_description_four:
            "Cualificación automática que convierte leads sin depender del inbox.",

          home_about_title_mini: "Tu modelo de negocio",
          home_about_title_big: "Vendes resultados, nosotros ejecutamos",
          home_about_subtitle:
            "Invokeapp no es otra herramienta para el cliente. Es infraestructura para que tu agencia entregue Automatización e IA como servicio: procesos estandarizados, ejecución fiable y reporting listo para vender.",
          home_about_caption_one: "Sistemas listos para monetizar",
          home_about_caption_two: "Operación sin fricción",
          home_about_caption_three: "Conocimiento que acumula margen",
          home_about_discover_services: "Ver cómo funciona",

          home_capabilities_title_mini: "Cómo escalas",
          home_capabilities_title_big: "De servicio a sistema vendible",
          home_capabilities_subtitle:
            "Diseñamos contigo ofertas operativas, las desplegamos en nuestra infraestructura y las dejamos monitorizadas para que cobres recurrente sin sumar equipo técnico.",
          home_capabilities_caption_one: "- Definir el resultado que vendes",
          home_capabilities_caption_two: "- Operarlo en Invokeapp",
          home_capabilities_caption_three: "- Medir, optimizar y renovar",

          home_services_title_mini: "Soluciones listas para monetizar",
          home_services_title_big: "Lo que tu agencia puede vender hoy",
          home_services_title_mobileapps: "Estrategia de Contenido Infinito",
          home_services_subtitle_mobileapps:
            "De una idea a piezas listas para LinkedIn, X e Instagram.",
          home_services_title_backend: "Cualificación de Leads vía WhatsApp",
          home_services_subtitle_backend:
            "Asistente 24/7 que filtra y envía solo los calientes al CRM.",
          home_services_title_consulting: "Informes de Rendimiento Inteligentes",
          home_services_subtitle_consulting:
            "GA4 y Ads traducidos a decisiones de negocio.",
          home_services_title_database: "Posicionamiento de Directivos (Ghostwriting)",
          home_services_subtitle_database:
            "Marca personal automatizada con radar de noticias del sector.",
          home_services_title_analytics: "Monitor de Operaciones y Costes",
          home_services_subtitle_analytics:
            "Visibilidad de ejecuciones, fallos y consumo para proteger margen.",
          home_services_title_uiuxdesign: "Hub de Entregables al Cliente",
          home_services_subtitle_uiuxdesign:
            "Resultados, reportes y próximos pasos en una sola vista.",
          home_services_title_webapps: "Calendario de Automatizaciones",
          home_services_subtitle_webapps:
            "Programación segura de workflows sin recordatorios manuales.",
          home_services_title_saas: "Company Brain para la Agencia",
          home_services_subtitle_saas:
            "Decisiones, playbooks y contexto que no se pierden.",

          home_contact_area_title_mini: "Activa tu nueva línea de ingresos",
          home_contact_area_title_big: "Convierte la IA en margen sin contratar a nadie",

          home_brands_customers_title_mini: "Para agencias con ambición de margen",
          home_brands_customers_title_big: "Más facturación, menos fricción operativa",
          home_brands_customers_subtitle:
            "Invokeapp te permite vender capacidades avanzadas y mantener el cobro recurrente mientras nosotros ejecutamos.",

          core_coreprelaunch_title_mini: "Infraestructura Invokeapp",
          core_coreprelaunch_title_slogan:
            "La capa operativa que transforma servicios en ingresos recurrentes",
          core_coreprelaunch_description:
            "Tu agencia mantiene la relación comercial y el cobro. Invokeapp opera la Automatización y la IA detrás de cada entrega.",
          core_coreprelaunch_button_text: "Quiero acceso",
          core_coreprelaunch_title_more_info: "Qué ganas al operar con Invokeapp",
          core_coreprelaunch_description1_more_info:
            "Estandarizas soluciones, proteges márgenes y escalas sin contratar programadores, ingenieros de IA ni expertos en integraciones.",
          core_coreprelaunch_description2_more_info:
            "Delega en nuestra infraestructura tu nueva fuente de ingresos. Vende el resultado, delega la ejecución y renueva mes a mes con reporting que el cliente entiende.",
          core_coreprelaunch_button_more_information: "Hablemos",
          home_core_start_cta: "Empieza en cuatro pasos",

          home_faqs_questions_title_superior_1: "No es otra herramienta.",
          home_faqs_questions_title_superior_2: "Es tu motor de ingresos.",
          home_faqs_questions_title_inferior_2:
            "Resolvemos la parte técnica para que tú vendas el resultado.",
          home_faqs_questions_button: "Ver cómo funciona",
          home_faqs_questions_tileline_title_1:
            "¿Qué vende exactamente mi agencia con Invokeapp?",
          home_faqs_questions_tileline_subtitle_1:
            "Vendes resultados operativos empaquetados: automatización, IA y reporting. Nosotros ejecutamos la infraestructura.",
          home_faqs_questions_tileline_title_2: "¿Necesito programadores o equipo de IA?",
          home_faqs_questions_tileline_subtitle_2:
            "No. Todo está preparado para operar sin código y con soporte experto.",
          home_faqs_questions_tileline_title_3: "¿Cómo genero ingresos recurrentes?",
          home_faqs_questions_tileline_subtitle_3:
            "Con ofertas mensuales basadas en procesos que entregan valor continuo al cliente.",
          home_faqs_questions_tileline_title_4: "¿Cuánto tarda en estar listo?",
          home_faqs_questions_tileline_subtitle_4:
            "En semanas, no meses. Usamos sistemas probados y los adaptamos a tu oferta.",

          home_integrations_title_mini: "Soluciones listas para monetizar",
          home_integrations_title_big: "Capacidades operativas que puedes vender",
          home_integrations_item_1_title: "Estrategia de Contenido Infinito",
          home_integrations_item_1_desc:
            "De una idea a contenido para LinkedIn, X e Instagram.",
          home_integrations_item_2_title: "Leads por WhatsApp 24/7",
          home_integrations_item_2_desc:
            "Filtra, cualifica y envía solo los calientes al CRM.",
          home_integrations_item_3_title: "Informes de Rendimiento Inteligentes",
          home_integrations_item_3_desc:
            "GA4 y Ads en lenguaje de negocio, listos para el cliente.",
          home_integrations_item_4_title: "Ghostwriting para Directivos",
          home_integrations_item_4_desc:
            "Posicionamiento de CEOs con radar de noticias del sector.",
          home_integrations_item_5_title: "Onboarding y Briefing Automático",
          home_integrations_item_5_desc:
            "Recolecta datos y assets sin correos eternos.",
          home_integrations_item_6_title: "Seguimiento y Reactivación de Leads",
          home_integrations_item_6_desc:
            "Secuencias que recuperan oportunidades perdidas.",
          home_integrations_item_7_title: "Alertas de Campaña y Anomalías",
          home_integrations_item_7_desc:
            "Avisos cuando el rendimiento cae para actuar a tiempo.",
          home_integrations_item_8_title: "Señales de Retención y Upsell",
          home_integrations_item_8_desc:
            "Insights para renovar cuentas y ampliar servicios.",

          home_two_expert_tab_integrations: "Vende servicios",
          home_two_expert_tab_learning: "Operación",
          home_two_expert_tab_gamification: "Margen",
          home_two_expert_integration_title_line1: "Vende servicios",
          home_two_expert_integration_title_line2: "sin tener que construirlos",
          home_two_expert_integration_description:
            "Lanza ofertas de automatización que tus clientes entienden y compran. Procesos ya estructurados para que empieces a cerrar proyectos sin depender de perfiles técnicos ni semanas de desarrollo.",
          home_two_expert_learning_title_line1: "Entrega proyectos",
          home_two_expert_learning_title_line2: "sin caos operativo",
          home_two_expert_learning_description:
            "Centraliza clientes, datos y ejecución en un solo sistema. Evita errores, herramientas desconectadas y horas perdidas gestionando cada proyecto.",
          home_two_expert_gamification_title_line1: "Convierte cada proyecto",
          home_two_expert_gamification_title_line2: "en margen",
          home_two_expert_gamification_description:
            "Estandariza la entrega para que cada venta sea rentable desde el inicio. Menos improvisación, más control y más beneficio por cliente.",

          home_two_blogs_title_mini: "Últimas noticias",
          home_two_blogs_title_big:
            "Mantente al día con novedades sobre automatización, IA y agencias.",
          home_two_blogs_button: "Ver más noticias",

          home_contact_title: "Contacto",
          home_contact_address: "Invokeapp",
          home_contact_email: "Escríbenos",

          home_footer_title_company: "Empresa",
          home_footer_company_about_us: "Por qué InvokeApp",
          home_footer_company_services: "Sistemas",
          home_footer_company_consulting: "Estrategia",
          home_footer_company_blog: "Insights",
          home_footer_company_policies: "Políticas",
          home_footer_company_contactus: "Contacto",
          home_footer_title_resources: "Recursos",
          home_footer_resources_customers: "Casos de éxito",
          home_footer_resources_pricing: "Planes",
          home_footer_resources_news: "Novedades",
          home_footer_resources_support: "Soporte",
          home_footer_resources_faqs: "FAQs",
          home_footer_title_usecases: "Sistemas",
          home_footer_usecases_uiuxdesign: "Entregables cliente",
          home_footer_usecases_mobileapp: "Motor de contenido",
          home_footer_usecases_apiintegration: "Integraciones",
          home_footer_usecases_database: "Monitor operativo",
          home_footer_usecases_software: "Librería de workflows",
          home_footer_usecases_analytics: "KPIs y profit",
          home_footer_title_information: "Aprender",
          home_footer_title_contact: "Contacto",
          home_footer_platform_core: "Plataforma",
          home_footer_platform_pricing: "Pricing",
          home_footer_platform_plans: "Planes",
          home_footer_platform_partnerships: "Partnerships",
          home_footer_platform_docs: "Centro de ayuda",
          home_footer_platform_changelog: "Changelog",
          home_footer_platform_playbook_demo: "Demo de Playbook",

          about_us_two_faq_title_mini: "Por qué funciona",
          about_us_two_faq_title_big_one: "Sistemas para agencias",
          about_us_two_faq_title_big_two: "confiables de verdad",
          about_us_two_faq_function_one_title: "Simple por fuera",
          about_us_two_faq_function_one_content:
            "Workflows complejos, operación simple—para que tu equipo despliegue sin convertirse en ingeniería.",
          about_us_two_faq_function_two_title: "Consistencia por diseño",
          about_us_two_faq_function_two_content:
            "Monitorización, logs y salvaguardas para que la entrega no dependa de suerte ni de heroísmo.",
          about_us_two_faq_function_three_title: "Resultados vendibles",
          about_us_two_faq_function_three_content:
            "Sistemas paquetizados alrededor de outcomes: reporting, rendimiento y valor medible.",

          about_us_two_achievement_title_mini: "Resultados",
          about_us_two_achievement_title_big: "Apalancamiento que se acumula",
          about_us_two_achievement_subtitle:
            "Estandariza entrega, protege márgenes y escala sin contratar. Los sistemas crean capacidad y confianza.",
          about_us_two_achievement_function_one: "Entrega repetible",
          about_us_two_achievement_function_two: "Automatización monitorizada",
          about_us_two_achievement_discover_more: "Ver ejemplos",

          services_three_second_services_title: "Librería de sistemas",
          services_three_second_services_subtitle:
            "Elige lo que necesitas hoy. Expande a medida que tu agencia escala.",

          services_three_second_services_section_one_title_superior: "Motor de contenido",
          services_three_second_services_section_one_title: "Motor de contenido",
          services_three_second_services_section_one_subtitle:
            "Construye una máquina de contenido consistente: planifica, crea, reutiliza y distribuye en canales con mínimo esfuerzo.",
          services_three_second_services_section_one_power_phrase: "Consistencia a escala",

          services_three_second_services_section_two_title_superior: "Leads & CRM",
          services_three_second_services_section_two_title: "Leads & CRM",
          services_three_second_services_section_two_subtitle:
            "Captura y cualifica leads, enruta al instante y activa follow-ups para que ninguna oportunidad se congele.",
          services_three_second_services_section_two_power_phrase: "La velocidad cierra",

          services_three_second_services_section_three_title_superior: "Reporting & KPIs",
          services_three_second_services_section_three_title: "Reporting & KPIs",
          services_three_second_services_section_three_subtitle:
            "Reporting automático e insights que reducen churn y justifican retainer con claridad.",
          services_three_second_services_section_three_power_phrase: "Retención por confianza",

          services_three_second_services_section_four_title_superior: "Monitor operativo",
          services_three_second_services_section_four_title: "Monitor operativo",
          services_three_second_services_section_four_subtitle:
            "Logs, alertas, scheduling y health checks para que los workflows sean fiables a escala cliente.",
          services_three_second_services_section_four_power_phrase: "Control sin micromanagement",

          services_three_second_services_get_started_button: "Comenzar",

          resources_download_ebook_section_title_mini: "Playbook gratuito",
          resources_download_ebook_section_title: "Descarga el Playbook de Sistemas para Agencias",
          resources_download_ebook_section_title_story_one:
            "Una guía práctica para paquetizar sistemas, estandarizar entrega y proteger márgenes—sin añadir plantilla.",
          resources_download_ebook_section_title_story_one_author: "Equipo InvokeApp",
          resources_download_ebook_section_title_story_one_position: "Operadores de sistemas para agencias",
          resources_download_ebook_section_title_story_two:
            "Úsalo para construir ofertas repetibles, reducir churn y convertir operaciones en ventaja competitiva.",
          resources_download_ebook_section_title_story_two_author: "Workflow Library",
          resources_download_ebook_section_title_story_two_position: "Tu catálogo de sistemas desplegables",
          resources_download_ebook_section_download_history:
            "Introduce tu email y recibe el playbook gratuito y plantillas para desplegar sistemas vendibles.",
          resources_download_ebook_section_language_ebook: "Idioma del playbook",
          resources_download_ebook_section_boton_download: "Descargar",

          blog_newsletter_title: "Newsletter",
          blog_newsletter_subtitle:
            "Notas semanales para escalar agencias con sistemas: workflows, reporting, posicionamiento y delivery.",
          blog_newsletter_newsletter_language: "Idioma de la Newsletter",
          blog_newsletter_policy_one: "Acepto la ",
          blog_newsletter_policy_two: "Política de Privacidad",
          blog_newsletter_email_adress_input: "Dirección de Email",
          blog_newsletter_subscribe_button: "Suscribirse",

          blog_recent_news_title: "Último",
          blog_categories_title: "Temas",
          blog_recent_comments_title: "Comentarios recientes",
          blog_recent_comments_empty_title: "Aún no hay comentarios",
          blog_recent_comments_empty_subtitle: "¡Sé el primero en dejar uno!",
          blog_read_more_card: "Leer más",
          blog_comments_card: "Comentarios",

          blog_comments_reply: "Deja un comentario",
          blog_comments_email_not_published: "Tu email no será publicado",
          blog_comments_consent:
            "Al aceptar la política doy mi consentimiento para que mi nombre y email sean almacenados y usados para enviarme updates y noticias.",

          blog_details_article_category: "Tema:",
          blog_details_article_share: "Compartir:",
          blog_details_article_author: "Autor",
          blog_details_article_last_comments: "Últimos comentarios:",
          blog_details_no_content: "Este artículo aún no está disponible en {{lang}}.",

          generic_your_message: "Tu mensaje...",
          generic_your_name: "Tu nombre",
          generic_your_email: "Tu email",
          generic_send_message: "Enviar mensaje",
          pricing_kicker: "Planes y acceso",
          pricing_title: "Elige tu plan",
          pricing_subtitle: "Empieza gratis y escala con el plan adecuado para tu delivery.",
          pricing_free_label: "Gratis",
          pricing_free_period: "Sin compromiso",
          pricing_free_days: "Prueba gratis {{days}} días",
          pricing_per_month: "/mes",
          pricing_cta: "Hablar con ventas",
          // Etiqueta de cada plan según sus asientos (limits.team.seats): 1 = para usarlo tú; más = para venderlo.
          pricing_badge_use: "Úsalo",
          pricing_badge_use_hint: "Para tu propio negocio",
          pricing_badge_sell: "Véndelo",
          pricing_badge_sell_hint: "Para tu equipo y tus clientes",
          pricing_per_year: "/año",
          pricing_buy_now: "Comprar ahora",
          pricing_finance_klarna: "Financiar anual con Klarna",
          pricing_annual_note: "facturación anual no disponible en este plan",
          pricing_free_cta: "Empieza gratis en la app",
          pricing_email_title: "Comprar {{plan}}",
          pricing_email_body: "Introduce tu email para continuar al pago seguro. Crearemos tu cuenta con este email tras el pago.",
          pricing_email_placeholder: "tu@empresa.com",
          pricing_email_invalid: "Introduce un email válido.",
          pricing_continue: "Continuar al pago",
          pricing_cancel: "Cancelar",
          pricing_checkout_error: "No pudimos iniciar el pago. Inténtalo de nuevo.",
          pricing_checkout_ok: "¡Pago completado! Revisa tu email: te hemos enviado los pasos para acceder a tu nueva cuenta.",
          pricing_checkout_ko: "El pago se canceló. Puedes intentarlo de nuevo cuando quieras.",
          pricing_default_desc: "Contáctanos para adaptar este plan a tu agencia.",
          pricing_error: "No pudimos cargar los planes. Inténtalo de nuevo.",
          pricing_badge_popular: "Más Popular",
          pricing_badge_save: "Ahorra {{pct}}%",
          pricing_toggle_monthly: "Mensual",
          pricing_toggle_annual: "Anual",
          pricing_plan_starter: "Starter",
          pricing_plan_professional: "Professional",
          pricing_plan_enterprise: "Enterprise",
          pricing_plan_starter_desc: "Para equipos pequeños que empiezan con InvokeApp.",
          pricing_plan_professional_desc: "Para agencias en crecimiento listas para escalar.",
          pricing_plan_enterprise_desc: "Para organizaciones grandes con necesidades personalizadas.",
          pricing_feat_users: "Miembros del equipo",
          pricing_feat_users_starter: "Hasta 3",
          pricing_feat_users_pro: "Hasta 15",
          pricing_feat_users_enterprise: "Ilimitado",
          pricing_feat_integrations: "Integraciones",
          pricing_feat_integrations_starter: "5 conectores",
          pricing_feat_integrations_pro: "Todos los conectores",
          pricing_feat_integrations_enterprise: "Todos + personalizados",
          pricing_feat_automations: "Automatizaciones",
          pricing_feat_automations_starter: "100 / mes",
          pricing_feat_automations_pro: "5,000 / mes",
          pricing_feat_automations_enterprise: "Ilimitadas",
          pricing_feat_support: "Soporte",
          pricing_feat_support_starter: "Email",
          pricing_feat_support_pro: "Chat prioritario y email",
          pricing_feat_support_enterprise: "Dedicado 24/7",
          pricing_feat_analytics: "Analíticas",
          pricing_feat_analytics_starter: "Dashboard básico",
          pricing_feat_analytics_pro: "Reportes avanzados",
          pricing_feat_analytics_enterprise: "Herramientas BI personalizadas",
          pricing_feat_whitelabel: "Logo de tu agencia",
          pricing_feat_whitelabel_starter: "—",
          pricing_feat_whitelabel_pro: "Portal con marca",
          pricing_feat_whitelabel_enterprise: "En el portal y los informes",
          pricing_feat_api: "Acceso API",
          pricing_feat_api_starter: "Básico",
          pricing_feat_api_pro: "Completo",
          pricing_feat_api_enterprise: "Completo + SLA",
          pricing_feat_onboarding: "Onboarding",
          pricing_feat_onboarding_starter: "Autoguiado",
          pricing_feat_onboarding_pro: "Configuración guiada",
          pricing_feat_onboarding_enterprise: "Manager dedicado",
          pricing_annual_savings: "Ahorra {{amount}}/año con facturación anual",
          pricing_cta_starter: "Empezar gratis",
          pricing_cta_pro: "Comenzar",
          pricing_cta_enterprise: "Contactar",
          how_it_works_page_title: "Cómo Funciona",
          how_it_works_page_subtitle: "De cero a operativo en pocos pasos — descubre cómo funciona InvokeApp",
          how_it_works_step_1_title: "Descubre",
          how_it_works_step_1_desc: "Cuéntanos sobre tu agencia y tus objetivos. Mapeamos tu flujo actual e identificamos dónde InvokeApp puede generar más impacto.",
          how_it_works_step_2_title: "Conecta",
          how_it_works_step_2_desc: "Integra tus herramientas actuales — CRMs, pasarelas de pago, plataformas de comunicación — en minutos con nuestros conectores.",
          how_it_works_step_3_title: "Configura",
          how_it_works_step_3_desc: "Personaliza automatizaciones, añade el logo de tu agencia y define tus playbooks de delivery para que se ajusten a tus procesos.",
          how_it_works_step_4_title: "Lanza",
          how_it_works_step_4_desc: "Sal a producción con tu primer cliente. Tu portal con marca está listo, tu equipo está onboarded y tus automatizaciones funcionando.",
          how_it_works_step_5_title: "Escala",
          how_it_works_step_5_desc: "Crece con confianza. Añade más clientes, desbloquea analíticas avanzadas y expande tus capacidades a medida que tu agencia evoluciona.",
          how_it_works_cta_title: "¿Listo para verlo en acción?",
          how_it_works_cta_desc: "Reserva una demo personalizada y te guiaremos por todo el proceso.",
          how_it_works_cta_button: "Reservar Demo",
          product_tour_page_title: "Tour del Producto",
          product_tour_page_subtitle: "Explora cada rincón de InvokeApp — un tour guiado de la plataforma",
          product_tour_section_1_title: "Dashboard",
          product_tour_section_1_desc: "Tu centro de mando. Obtén una vista en tiempo real de clientes activos, tareas pendientes, métricas de ingresos y salud del sistema.",
          product_tour_section_2_title: "Portal del Cliente",
          product_tour_section_2_desc: "Un portal con el logo de tu agencia para cada cliente. Pueden seguir el progreso, comunicarse y aprobar entregables sin salir de tu ecosistema.",
          product_tour_section_3_title: "Motor de Automatización",
          product_tour_section_3_desc: "Diseña flujos de trabajo complejos sin código. Dispara acciones según el comportamiento del cliente, programa tareas recurrentes y encadena automatizaciones.",
          product_tour_section_4_title: "Playbooks y ROI",
          product_tour_section_4_desc: "Playbooks de delivery preconstruidos que codifican tus mejores prácticas. Usa la calculadora ROI integrada para mostrar a los clientes el valor tangible que entregas.",
          product_tour_section_5_title: "Analíticas e Informes",
          product_tour_section_5_desc: "Ve más allá de las métricas básicas. Monitoriza CAC, LTV, velocidad de delivery y utilización del equipo con dashboards personalizables.",
          product_tour_section_6_title: "Centro de Integraciones",
          product_tour_section_6_desc: "Conecta con más de 50 herramientas populares — CRMs, contabilidad, comunicación y pagos — todo gestionado desde una única interfaz.",
          product_tour_cta_title: "Empieza tu viaje",
          product_tour_cta_desc: "Prueba InvokeApp gratis o programa un recorrido con nuestro equipo.",
          product_tour_cta_demo: "Reservar Demo",
          product_tour_cta_try: "Probar Gratis",
          customer_portal_page_title: "Portal del Cliente",
          customer_portal_page_subtitle: "Accede a tu panel de InvokeApp, facturas y soporte.",
          customer_portal_login_title: "Iniciar Sesión",
          customer_portal_login_subtitle: "Ingresa tus credenciales para acceder al portal.",
          customer_portal_email_label: "Email",
          customer_portal_email_placeholder: "tu@agencia.com",
          customer_portal_password_label: "Contraseña",
          customer_portal_password_placeholder: "Ingresa tu contraseña",
          customer_portal_remember: "Recordarme",
          customer_portal_forgot: "¿Olvidaste tu contraseña?",
          customer_portal_button: "Iniciar Sesión",
          customer_portal_button_loading: "Iniciando sesión...",
          customer_portal_no_account: "¿No tienes cuenta?",
          customer_portal_signup: "Solicitar acceso",
          customer_portal_error_required: "Completa todos los campos.",
          customer_portal_error_invalid: "Email o contraseña inválidos.",
          customer_portal_divider: "o continúa con",

          portal_dash_page_title: "Dashboard — Portal del Cliente",
          portal_hero_kicker: "Tu viaje empieza aquí",
          portal_hero_welcome_name: "Bienvenido, {{name}}",
          portal_hero_welcome: "Bienvenido a bordo",
          portal_hero_subtitle: "Tu cuenta está activa. Vamos a dejarlo todo configurado para que veas resultados desde la primera semana.",
          portal_hero_subtitle_done: "Puesta en marcha completada: tu plataforma está totalmente operativa. Disfruta del viaje.",
          portal_journey_progress: "{{done}} de {{total}} pasos completados",
          portal_journey_kicker: "Onboarding",
          portal_journey_title: "Tu viaje de puesta en marcha",
          portal_journey_subtitle: "Sigue estos pasos para sacar el máximo partido a InvokeApp desde el primer día.",
          portal_journey_current: "Paso actual",
          portal_journey_done: "Completado",
          portal_journey_pending: "Pendiente",
          portal_dash_panel_onboarding: "Onboarding",
          portal_journey_mark_done: "Marcar como completado",
          portal_journey_mark_undone: "Marcar como pendiente",
          portal_intro_skip: "Haz clic para saltar",
          portal_journey_completed_title: "¡Onboarding completado!",
          portal_journey_step_welcome_video_title: "Un agradecimiento del equipo",
          portal_journey_step_welcome_video_desc: "Hemos grabado este vídeo corto para agradecerte la confianza y contarte lo que viene por delante.",
          portal_journey_step_welcome_video_cta: "Ver el vídeo",
          portal_journey_step_methodology_title: "La metodología InvokeApp",
          portal_journey_step_methodology_desc:
            "Nuestro compromiso es que tu agencia abra una nueva línea de ingresos vendiendo servicios paquetizados. Lo de detrás lo ponemos nosotros: la definición de los procesos, el mantenimiento, la escalabilidad, la parte legal y el cumplimiento normativo. Tú te quedas con lo que ya sabes hacer: ponerlo en mercado, fijar tu precio y dar la cara ante tu cliente.",
          portal_journey_step_certification_title: "Certificación de operador",
          portal_journey_step_certification_desc:
            "Pronto habrá certificaciones de operador. Cuando se abran, tu agencia aparecerá listada dentro de la plataforma y con un enlace hacia tu web, para que quien entre buscando una automatización de su sector pueda encontrarte y contratarte a ti. Te avisamos en cuanto estén disponibles.",
          portal_journey_step_community_title: "Únete a la comunidad",
          portal_journey_step_community_desc:
            "Ahí contamos primero lo que sale: procesos nuevos en el catálogo, cambios en los planes y cuándo se abren las certificaciones de operador. También es donde preguntar sin abrir un ticket y donde ver qué están vendiendo otras agencias. El grupo de WhatsApp es el día a día; en Meetup anunciamos los encuentros y las sesiones en directo.",
          portal_journey_step_community_cta_whatsapp: "Entrar al grupo de WhatsApp",
          portal_journey_step_community_cta_meetup: "Seguirnos en Meetup",
          portal_company_logo_alt: "Logo de tu empresa",
          portal_journey_step_setup_config_title: "Primeros pasos de configuración",
          portal_journey_step_setup_config_desc:
            "Completa aquí los datos de tu empresa y sube tu logo. Con eso, los portales y los informes que reciban tus clientes salen con tu marca desde el primer día.",
          portal_journey_step_team_title: "Da de alta a tu equipo",
          portal_journey_step_team_desc:
            "Crea las cuentas de las personas que van a trabajar en la plataforma. Cuántas puedes crear depende de tu plan. Los correos que des de alta aquí son los que llevaremos a la llamada de setup, para que nadie se entere de las cosas por terceros.",
          portal_journey_step_setup_config_cta: "Subir mi información y mi logo",
          portal_journey_step_team_cta: "Gestionar mi equipo",
          portal_journey_step_client_demos_title: "Demos para tus clientes y para tu web",
          portal_journey_step_client_demos_desc:
            "Cada playbook tiene una demo animada que enseña, paso a paso, cómo va a funcionar el proceso para tu cliente. Sale con la marca de tu agencia (el logo que acabas de subir o, si la tienes configurada en la plataforma, tu marca para portales externos) y con datos ficticios, así que puedes enseñarla sin riesgo. Tienes dos formas de usarla: mandar el enlace de la demo por WhatsApp o por correo, o insertar los componentes en tu propia web con un iframe.",
          portal_journey_step_client_demos_howto:
            "Entra en «Componentes para tu web» y crea una clave de inserción (solo puede hacerlo el administrador de la cuenta). Puedes tener hasta 10 activas, una por web, y revocarlas cuando quieras.\nElige el playbook y copia el snippet: un iframe con todas las etapas, o uno por proceso si prefieres repartirlos por tu página.\nPégalo en tu web como bloque de HTML (en WordPress, Webflow o Wix, el bloque «HTML» o «Embed») y, una sola vez por página, el script de alto automático que encontrarás debajo de los snippets. Se ve mientras tu suscripción esté activa.",
          portal_journey_step_client_demos_example_key: "pek_TU_CLAVE",
          portal_journey_step_client_demos_example_pb: "ID_DEL_PLAYBOOK",
          portal_journey_step_client_demos_example_title: "Demo de tu playbook",
          portal_journey_step_client_demos_example: "Así es un snippet (el tuyo, con tu clave, se copia en «Componentes para tu web»):",
          portal_journey_step_client_demos_cta_demos: "Ver mis demos",
          portal_journey_step_client_demos_cta_embeds: "Insertar en mi web",
          portal_company_title: "Información de tu empresa",
          portal_company_subtitle:
            "Lo que rellenes aquí es lo que verán tus clientes en los portales y en los informes que reciban con tu marca.",
          portal_company_group_private: "Datos fiscales",
          portal_company_group_public: "Datos de contacto y perfil",
          portal_company_group_logo: "Tu logo",
          portal_company_loading: "Cargando la ficha de tu empresa…",
          portal_company_load_error:
            "No hemos podido cargar la ficha de tu empresa. Prueba a recargar la página.",
          portal_company_save: "Guardar cambios",
          portal_company_saving: "Guardando…",
          portal_company_saved: "Guardado. Tu ficha ya está actualizada.",
          portal_company_save_error: "No se ha podido guardar.",
          portal_company_not_admin:
            "Solo el administrador de la cuenta puede cambiar la ficha de la empresa. Pide a quien la creó que lo haga.",
          portal_company_logo_cta: "Elegir imagen",
          portal_company_logo_ok: "Logo subido.",
          portal_company_logo_error: "No se ha podido subir el logo.",
          portal_company_logo_too_big:
            "La imagen pesa demasiado (máximo 5 MB). Prueba con una más ligera.",
          portal_company_logo_bad_type:
            "Ese formato de imagen no vale. Usa PNG, JPG, WEBP o GIF (las fotos del iPhone suelen ser HEIC: expórtala como JPG antes).",
          portal_company_logo_current: "Ya tienes un logo subido",
          portal_company_logo_none: "Todavía no has subido ninguno",
          portal_company_field_name: "Nombre comercial",
          portal_company_field_legal_name: "Razón social",
          portal_company_field_tax_id: "CIF / NIF",
          portal_company_field_industry: "Sector",
          portal_company_field_slogan: "Eslogan",
          portal_company_field_description: "Descripción",
          portal_company_field_website: "Web",
          portal_company_field_email: "Email de contacto",
          portal_company_field_phone_number: "Teléfono",
          portal_company_field_address: "Dirección",
          portal_company_field_city: "Ciudad",
          portal_company_field_state: "Provincia",
          portal_company_field_country: "País",
          portal_company_field_postal_code: "Código postal",
          portal_gate_title: "Tu suscripción todavía no está activa",
          portal_gate_desc:
            "Tienes la cuenta creada, pero no encontramos una suscripción vigente. En cuanto se confirme el pago, el portal se abre solo y aquí te espera tu puesta en marcha.",
          portal_gate_cta: "Elegir mi plan",
          portal_gate_note:
            "¿Acabas de pagar? El aviso de la pasarela puede tardar un minuto en llegarnos. Recarga la página.",
          portal_gate_logout: "Salir de la cuenta",
          portal_journey_step_contract_review_title: "Tu contrato de servicio",
          portal_journey_step_contract_review_desc: "Revisa tu contrato con calma: alcance, niveles de servicio y condiciones. Cualquier duda, estamos a un email.",
          portal_journey_step_contract_review_cta: "Solicitar el contrato",
          portal_journey_step_setup_call_title: "Llamada de setup y auditoría",
          portal_journey_step_setup_call_desc:
            "Reservamos una sesión con tu equipo: auditamos tu caso y configuramos la plataforma contigo. Va casi al final a propósito, para que la llamada arranque de tus datos reales y no de una hoja en blanco.",
          portal_journey_step_setup_call_cta: "Reservar la llamada",
          portal_journey_step_platform_access_title: "Entra en la plataforma",
          portal_journey_step_platform_access_desc:
            "Último paso, y para el que era todo lo demás. Abre la plataforma con la misma cuenta con la que has entrado aquí y empieza a activar procesos.",
          portal_journey_step_platform_access_cta: "Ir a la plataforma",
          portal_journey_step_contract_sign_title: "Firma del contrato",
          portal_journey_step_contract_sign_desc: "El último paso: firma el contrato y todo queda oficialmente en marcha.",
          portal_journey_step_contract_sign_cta: "Solicitar la firma",
          portal_journey_step_contract_sign_note: "La firma electrónica estará disponible pronto; mientras tanto la gestionamos por email.",
          portal_dash_stat_clients: "Clientes activos",
          portal_dash_stat_automations: "Automatizaciones ejecutadas",
          portal_dash_stat_revenue: "Ingresos mensuales",
          portal_dash_stat_delivery: "Tiempo medio de entrega",
          portal_dash_panel_activity: "Actividad reciente",
          portal_dash_panel_reports: "Informes",
          portal_dash_panel_settings: "Ajustes del portal",
          portal_dash_panel_team: "Gestionar equipo",
          portal_dash_panel_billing: "Facturación",
          portal_dash_quick_actions: "Accesos rápidos",
          portal_dash_signout: "Cerrar sesión",
          portal_dash_role_admin: "Admin",
          portal_dash_role_editor: "Editor",
          portal_dash_role_user: "Usuario",
          portal_dash_setting_1_label: "Notificaciones por email",
          portal_dash_setting_1_desc: "Recibe avisos cuando se completen automatizaciones",
          portal_dash_setting_2_label: "Autenticación en dos pasos",
          portal_dash_setting_2_desc: "Añade una capa extra de seguridad",
          portal_dash_setting_3_label: "Acceso API",
          portal_dash_setting_3_desc: "Gestiona tus claves API y webhooks",
          portal_dash_badge_active: "Activo",
          portal_dash_wip: "En implementación",
          portal_dash_wip_title: "Estamos implementando esta sección",
          portal_dash_wip_activity:
            "Aquí verás la actividad real de tus clientes y de tus procesos en cuanto esté conectada.",
          portal_dash_wip_reports:
            "Aquí podrás consultar y descargar los informes de tus clientes en cuanto estén disponibles.",
          portal_dash_wip_invoices:
            "El historial de facturas se está implementando. Si necesitas una factura ahora, escríbenos a letstalk@invokeapp.io.",
          portal_dash_plan_label: "Plan {{name}}",
          portal_dash_billing_trial: "Periodo de prueba",
          portal_dash_billing_inactive: "Inactivo",
          portal_dash_billing_renews: "Periodo actual hasta el {{date}}",
          portal_dash_billing_no_plan: "Sin plan asignado",
          portal_dash_team_loading: "Cargando miembros del equipo...",
          portal_dash_team_empty: "No hay miembros en el equipo.",
          portal_dash_invite_button: "Invitar miembro",
          portal_dash_invite_cancel: "Cancelar",
          portal_dash_invite_email: "Email",
          portal_dash_invite_first_name: "Nombre",
          portal_dash_invite_last_name: "Apellidos",
          portal_dash_invite_sending: "Enviando...",
          portal_dash_invite_send: "Enviar invitación",
          portal_dash_invite_error_required: "Todos los campos son obligatorios.",
          portal_dash_invite_error_failed: "No se pudo invitar al miembro.",
          portal_dash_invite_error_network: "Error de red. Inténtalo de nuevo.",
          portal_dash_billing_current: "Plan actual",

          gsw_step_account: "Cuenta",
          gsw_step_session: "Sesión",
          gsw_step_plan: "Plan",
          gsw_step_onboarding: "Onboarding",
          gsw_account_title: "Crea tu cuenta",
          gsw_account_subtitle: "Solo lo imprescindible. Al terminar te dejamos la sesión iniciada automáticamente.",
          gsw_account_cta: "Crear cuenta",
          gsw_company: "Empresa",
          gsw_legal_name: "Razón social",
          gsw_tax_id: "CIF / NIF",
          gsw_optional: "Opcional",
          gsw_first_name: "Nombre",
          gsw_last_name: "Apellidos",
          gsw_email: "Email de trabajo",
          gsw_password: "Contraseña",
          gsw_password_hint: "Mínimo 8 caracteres.",
          gsw_toggle_password: "Mostrar u ocultar la contraseña",
          gsw_legal: "Al crear la cuenta aceptas nuestras",
          gsw_session_title: "Inicia sesión",
          gsw_session_subtitle: "Tu cuenta ya está creada. Confirma tu contraseña para seguir sin salir de esta página.",
          gsw_session_cta: "Entrar",
          gsw_login_manual: "Hemos creado tu cuenta. Confirma tu contraseña para continuar.",
          gsw_plan_title: "Elige tu plan",
          gsw_plan_subtitle: "Escoge el plan que encaje contigo. El pago lo gestiona Stripe y vuelves aquí directamente.",
          gsw_plan_cta: "Pagar y continuar",
          gsw_plan_free_cta: "Continuar con el plan gratuito",
          gsw_plan_note: "Sin permanencia: puedes darte de baja avisando con treinta (30) días naturales de antelación a la renovación.",
          gsw_plan_needs_account: "Crea tu cuenta en el primer paso para poder pagar: el plan se asocia a tu email.",
          gsw_done_title: "¡Todo listo!",
          gsw_done_subtitle: "Tu cuenta está activa. El último paso es el onboarding guiado en tu Customer Portal.",
          gsw_done_cta: "Ir a mi Customer Portal",
          gsw_done_cta_login: "Entrar a tu Customer Portal",
          gsw_checkout_cancelled: "El pago no se completó. Puedes volver a elegir plan cuando quieras.",
          gsw_working: "Un momento...",
          gsw_error_required: "Completa todos los campos.",
          gsw_error_email: "Ese email no parece válido.",
          gsw_error_password: "La contraseña necesita al menos 8 caracteres.",
          gsw_error_exists: "No hemos podido crear la cuenta. Puede que ese email ya esté registrado.",
          gsw_error_credentials: "El email o la contraseña no son correctos.",
          gsw_error_generic: "Algo ha fallado. Inténtalo de nuevo.",
          gsw_error_network: "Error de red. Revisa tu conexión e inténtalo de nuevo.",
          // Casilla obligatoria de condiciones (/get-started y compra en /pricing)
          legal_accept_prefix: "Acepto las",
          legal_accept_terms: "Condiciones de servicio",
          legal_accept_and: "y el",
          legal_accept_dpa: "Acuerdo de encargo del tratamiento",
          legal_accept_on_behalf: "de InvokeApp en nombre de la empresa que represento.",
          legal_accept_privacy_prefix: "He leído la",
          legal_accept_privacy: "Política de privacidad",
          legal_accept_required: "Para continuar, acepta las Condiciones de servicio y el Acuerdo de encargo del tratamiento.",

          roi2_kicker: "Calculadora de ROI",
          roi2_title: "¿Cuánto puedes facturar con esto?",
          roi2_subtitle: "Elige los procesos que venderías, di cuántos clientes tienes y qué margen te quedas. Todas las cifras salen de la ficha comercial del catálogo.",
          roi2_pick_processes: "Procesos que venderías",
          roi2_selected_count: "{{n}} seleccionados",
          roi2_clients: "Clientes",
          roi2_margin: "Tu margen",
          roi2_pick_to_start: "Elige al menos un proceso para ver los números.",
          roi2_no_data: "El catálogo todavía no tiene datos comerciales publicados. En cuanto los tenga, esta calculadora se rellena sola.",
          roi2_without_profile: "Hay {{n}} procesos más en el catálogo que aún no tienen ficha comercial publicada, así que quedan fuera del cálculo.",
          roi2_metric_revenue: "Facturación recurrente",
          roi2_metric_margin: "Tu margen",
          roi2_metric_annual: "Margen al año",
          roi2_metric_hours: "Horas manuales ahorradas",
          roi2_metric_value: "Valor entregado a tus clientes",
          roi2_metric_value_hint: "por ejecución, sumando todos los clientes",
          roi2_per_month: "al mes",
          roi2_per_year: "al año",
          roi2_breakdown: "De dónde salen los números",
          roi2_no_price: "Sin precio publicado",
          roi2_per_use_note: "{{n}} de los procesos elegidos se cobran por uso, no al mes: no se suman a la cifra recurrente.",
          roi2_disclaimer: "Estimaciones orientativas del catálogo, no una medición. El precio final siempre lo pones tú.",
          playbook_bundle_price: "Precio del pack",
          playbook_month: "mes",
          playbook_time_saved: "Tiempo ahorrado",
          playbook_simulate: "Simular este playbook",
          playbook_simulate_one: "Simular",
          playbook_no_commercial: "Ficha comercial pendiente",
          playbook_no_commercial_card: "Este proceso todavía no tiene ficha comercial publicada.",

          commercial_title: "Ficha comercial",
          commercial_flip_open: "Ficha comercial",
          commercial_flip_close: "Volver",
          commercial_see_detail: "Ver detalle completo",
          commercial_pvp: "Precio recomendado",
          commercial_value: "Valor generado",
          commercial_time_saved: "Tiempo manual ahorrado",
          commercial_runtime: "Tiempo de ejecución",
          commercial_tokens: "Tokens de IA por ejecución",
          commercial_observed_title: "Medición real",
          commercial_observed_tokens: "Tokens",
          commercial_observed_runtime: "Ejecución",
          commercial_estimate_note: "Estimaciones orientativas del catálogo, no una medición.",

          terms_index_title: "Índice",
          gs_page_title: "Cómo empezar",
          gs_page_subtitle: "Del registro al onboarding, paso a paso",
          gs_meta: "Guía paso a paso para empezar con InvokeApp: crea tu cuenta, entra en la plataforma, activa tu plan y completa el onboarding en el Customer Portal.",
          gs_hero_kicker: "Paso a paso",
          gs_hero_title: "De cero a operativo en cuatro pasos",
          gs_hero_subtitle: "Te contamos exactamente qué ocurre desde que creas tu cuenta hasta que tienes la plataforma funcionando con tu primer proceso activo. Sin sorpresas.",
          gs_hero_cta_primary: "Crear mi cuenta",
          gs_hero_cta_secondary: "Ver planes y precios",
          gs_step_label: "Paso {{n}}",
          gs_step_1_title: "Crea tu cuenta",
          gs_step_1_desc: "Rellena el formulario de alta con los datos de tu empresa. Tarda menos de dos minutos y no necesitas tarjeta para empezar.",
          gs_step_1_b1: "Datos de empresa, tu nombre y un email de contacto",
          gs_step_1_b2: "Eliges el idioma de la plataforma y tu tipo de negocio",
          gs_step_1_b3: "Recibes un correo de confirmación con tus accesos",
          gs_step_1_cta: "Crear mi cuenta",
          gs_step_2_title: "Entra en la plataforma",
          gs_step_2_desc: "Con tus credenciales accedes al Core: el espacio donde vives el día a día, con proyectos, clientes, procesos y analítica.",
          gs_step_2_b1: "Acceso web en core.invokeapp.io, sin instalar nada",
          gs_step_2_b2: "Configura tu empresa e invita a tu equipo",
          gs_step_2_b3: "Explora el catálogo de procesos y agentes disponibles",
          gs_step_2_cta: "Ir a la plataforma",
          gs_step_3_title: "Elige tu plan y activa la suscripción",
          gs_step_3_desc: "Compara los planes, elige el que encaja con tu volumen y completa el pago. La suscripción se activa al instante.",
          gs_step_3_b1: "Facturación mensual o anual (el anual admite financiación con Klarna)",
          gs_step_3_b2: "Pago seguro con Stripe y sin permanencia",
          gs_step_3_b3: "Factura automática y gestión de la suscripción desde tu portal",
          gs_step_3_cta: "Ver planes y precios",
          gs_step_4_title: "Completa el onboarding en el Customer Portal",
          gs_step_4_desc: "Una vez confirmado el pago recibes acceso al Customer Portal, donde te guiamos paso a paso hasta dejarlo todo operativo.",
          gs_step_4_b1: "Un viaje guiado con tu progreso siempre a la vista",
          gs_step_4_b2: "Materiales, contrato y llamada de setup en un único sitio",
          gs_step_4_b3: "Al terminar, tu plataforma queda lista para vender",
          gs_step_4_cta: "Entrar al Customer Portal",
          gs_journey_title: "Qué incluye el onboarding",
          gs_journey_1: "Vídeo de agradecimiento del equipo",
          gs_journey_2: "La metodología InvokeApp",
          gs_journey_3: "Certificación de operador",
          gs_journey_4: "Primeros pasos de configuración",
          gs_journey_5: "Revisión del contrato de servicio",
          gs_journey_6: "Llamada de setup y auditoría personalizada",
          gs_journey_7: "Firma del contrato",
          gs_ready_title: "Qué necesitas tener a mano",
          gs_ready_subtitle: "Nada complicado: con esto preparado, el alta completa se resuelve en una tarde.",
          gs_ready_bullet_1: "Los datos fiscales de tu empresa para la facturación",
          gs_ready_bullet_2: "Un método de pago válido (tarjeta)",
          gs_ready_bullet_3: "Las cuentas que quieras conectar (calendario, WhatsApp, redes sociales...)",
          gs_ready_bullet_4: "Media hora para la llamada de setup con nuestro equipo",
          gs_timeline_title: "Cuánto se tarda",
          gs_timeline_subtitle: "Tiempos reales de cada fase, de principio a fin.",
          gs_timeline_item_1: "Registro: menos de 2 minutos",
          gs_timeline_item_2: "Primer acceso y configuración básica: 15-20 minutos",
          gs_timeline_item_3: "Alta del plan y pago: 3 minutos",
          gs_timeline_item_4: "Onboarding completo: a tu ritmo, normalmente en la primera semana",
          gs_faq_title: "Dudas frecuentes del alta",
          gs_faq_subtitle: "Lo que más nos preguntan antes de empezar.",
          gs_faq_1_q: "¿Necesito tarjeta para crear la cuenta?",
          gs_faq_1_a: "No. Puedes registrarte y explorar la plataforma antes de elegir plan. La tarjeta solo se pide al activar una suscripción de pago.",
          gs_faq_2_q: "¿Hay permanencia?",
          gs_faq_2_a: "No. La suscripción se estructura en periodos mensuales con renovación automática y puedes darte de baja avisando con treinta (30) días naturales de antelación a la fecha de renovación.",
          gs_faq_3_q: "¿Puedo cambiar de plan más adelante?",
          gs_faq_3_a: "Sí. Escríbenos a letstalk@invokeapp.io y ajustamos tu plan al volumen de proyectos, clientes o consumo de IA que necesites.",
          gs_faq_4_q: "¿El onboarding tiene coste?",
          gs_faq_4_a: "El onboarding guiado del Customer Portal está incluido. Los servicios de implementación a medida, si los necesitas, se presupuestan aparte.",
          gs_cta_title: "¿Prefieres que lo veamos juntos?",
          gs_cta_subtitle: "Si quieres que te acompañemos en el alta, reserva una llamada y lo hacemos contigo en directo.",
          sca_activation_page_title: "Activación SCA",
          sca_activation_page_subtitle: "Configura tu flujo de activación con branding",
          sca_activation_section_brand: "Branding",
          sca_activation_section_copy: "Textos",
          sca_activation_section_links: "Políticas",
          sca_activation_field_agency: "Nombre de la agencia",
          sca_activation_field_primary: "Color principal",
          sca_activation_field_title: "Título",
          sca_activation_field_subtitle: "Subtítulo",
          sca_activation_field_cta: "Texto del botón",
          sca_activation_field_security: "Nota de seguridad",
          sca_activation_field_privacy: "URL de privacidad",
          sca_activation_field_terms: "URL de términos",
          sca_activation_default_agency: "Agencia Invokeapp",
          sca_activation_default_title: "Activa tu workflow",
          sca_activation_default_subtitle: "Conecta tus cuentas para empezar a entregar resultados.",
          sca_activation_default_cta: "Conectar ahora",
          sca_activation_default_security: "Tu agencia no verá tus credenciales.",
          sca_activation_preview_badge: "Vista en vivo",
          sca_activation_terms: "Términos",
          sca_activation_privacy: "Privacidad",
          sca_activation_launch: "Abrir formulario",
          sca_activation_unknown: "Sin datos",
          sca_activation_preview_difficulty: "Dificultad:",
          sca_activation_preview_category: "Categoría:",
          sca_activation_preview_status: "Estado:",
          sca_video_kicker: "Activación de cliente",
          sca_video_title: "Un flujo SCA limpio y de confianza",
          sca_video_description:
            "Muestra a tus clientes una página de activación con tu marca donde conectan sus cuentas en minutos. Tú controlas la entrega sin ver sus credenciales.",
          sca_video_bullet_1: "Experiencia con el logo de tu agencia",
          sca_video_bullet_2: "Onboarding guiado y rápido",
          sca_video_bullet_3: "Seguridad en el manejo de credenciales",
          generic_error_message: "No pudimos cargar las integraciones. Inténtalo de nuevo.",
          // --- Componentes embebibles (/embed) y su apartado del Customer Portal ---
          pba_meta_title: "Asistentes por departamento — avance",
          pba_kicker: "Próximo lanzamiento",
          pba_title: "Asistentes por departamento",
          pba_lead: "Una app con el chat de tu empresa por delante: un Manager recibe cada petición y la pasa al asistente del departamento que toca. Cada uno tiene su color, consulta solo lo que tiene permitido y te pide confirmación antes de actuar.",
          pba_all_title: "Todos los asistentes",
          pba_all_caption: "El Manager recibe cada petición (también por nota de voz) y la deriva al asistente del departamento que toca.",
          pba_comercial_title: "Comercial",
          pba_comercial_caption: "Oportunidades sin seguimiento, altas en el CRM con tu confirmación y propuestas listas para revisar.",
          pba_finanzas_title: "Finanzas",
          pba_finanzas_caption: "Facturación del trimestre, cobros pendientes y facturas vencidas, con recordatorios de cobro que tú apruebas.",
          pba_marketing_title: "Marketing",
          pba_marketing_caption: "Correos de seguimiento y campañas: los redacta, mide qué ha funcionado y nada sale sin tu revisión.",
          pba_atencion_title: "Atención al cliente",
          pba_atencion_caption: "Lo que más preguntan tus clientes y respuestas preparadas con la información del negocio para que solo tengas que confirmar.",
          portal_upcoming_title: "Próximos lanzamientos",
          portal_upcoming_badge: "Avance",
          portal_upcoming_desc: "Lo que estamos a punto de lanzar. Aún no es público, pero ya puedes verlo y enseñárselo a tus clientes con tu marca.",
          portal_upcoming_open: "Abrir avance",
          upcoming_assistants_title: "Asistentes por departamento",
          upcoming_assistants_desc: "La app de chat de tu empresa: un Manager y un asistente por departamento (Comercial, Finanzas, Marketing, Atención al cliente), cada uno con su color, notas de voz y confirmación antes de actuar.",
          portal_demo_desc: "Genera el enlace de la demo de cada playbook con la marca de tu agencia: una página con todas sus etapas animadas, lista para mandársela a tu cliente por WhatsApp o por correo. Es el mismo enlace que el botón «Demo para tu cliente» de la Tienda de la app.",
          portal_demo_brand_hint: "La demo usa el logo y el color de la ficha de tu empresa (Ajustes). Si no tienes logo, sale la inicial de tu agencia.",
          portal_demo_lang_label: "Idioma de la demo",
          portal_demo_open: "Abrir demo",
          portal_demo_copy_link: "Copiar enlace",
          portal_demo_step: "Escalón {{n}}",
          portal_demo_processes: "{{n}} procesos",
          portal_demo_company_loading: "Cargando los datos de tu empresa…",
          portal_demo_company_error: "No se han podido cargar los datos de tu empresa, así que no podemos generar los enlaces con tu marca.",
          portal_upcoming_wait: "El enlace aparece cuando se cargan los datos de tu empresa, para que salga con tu marca.",
          portal_embed_no_company: "Tu usuario no está vinculado a ninguna empresa, así que no puede tener claves de inserción. Escríbenos a soporte para resolverlo.",
          portal_embed_keys_forbidden: "Tu usuario no tiene acceso a las claves de inserción de esta cuenta.",
          pbe_loading: "Cargando…",
          pbe_scene_pending: "Vista ilustrada próximamente.",
          pbe_simulation: "Demostración con datos ficticios: los nombres y las cifras son ilustrativos. En el servicio real, los agentes de IA siempre se identifican como tales.",
          pbe_stage: "Etapa {{n}}",
          portal_dash_panel_embeds: "Componentes para tu web",
          portal_dash_panel_demos: "Demos para tus clientes",
          portal_embed_access_inactive: "Tu suscripción no está activa, así que ahora mismo tus componentes insertados muestran «Content not available». Volverán a verse en cuanto la reactives.",
          portal_embed_component_unavailable: "Este proceso todavía no se puede insertar suelto; va incluido en el playbook completo.",
          portal_embed_components_desc: "Un iframe por proceso, en el orden del playbook. Pega cada uno en la sección de tu web donde encaje; puedes apilar varios, uno detrás de otro.",
          portal_embed_components_empty: "Este playbook todavía no tiene procesos.",
          portal_embed_components_error: "No se han podido cargar los procesos de este playbook.",
          portal_embed_components_loading: "Cargando los procesos del playbook…",
          portal_embed_components_title: "Componentes sueltos",
          portal_embed_copied: "Copiado",
          portal_embed_copy: "Copiar",
          portal_embed_copy_failed: "No se ha podido copiar",
          portal_embed_full_desc: "Un único iframe con todas las etapas del playbook, en orden. Es la opción recomendada para una landing.",
          portal_embed_intro: "Inserta en tu propia web los componentes animados de cada playbook con un <iframe>. Salen con la marca de tu agencia (el logo y el color de la ficha de tu empresa), son simulaciones con datos ficticios y llevan un pequeño «Powered by InvokeApp».",
          portal_embed_intro_availability: "Solo funcionan mientras tu suscripción a InvokeApp esté activa. Si termina, tus visitantes verán el aviso «Content not available» en su lugar.",
          portal_embed_key_admin_required: "Solo el administrador de la cuenta puede crear o revocar claves de inserción.",
          portal_embed_key_create: "Crear clave",
          portal_embed_key_create_error: "No se ha podido crear la clave. Inténtalo de nuevo.",
          portal_embed_key_created_ok: "Clave creada. Ya puedes copiar los snippets de abajo.",
          portal_embed_key_created_on: "Creada el {{date}}",
          portal_embed_key_creating: "Creando…",
          portal_embed_key_label: "Nombre de la nueva clave (opcional)",
          portal_embed_key_label_placeholder: "Web principal",
          portal_embed_key_last_seen: "Último uso: {{date}}",
          portal_embed_key_limit: "Has llegado al máximo de {{max}} claves activas. Revoca alguna que ya no uses para crear otra.",
          portal_embed_key_never_seen: "Aún sin usar",
          portal_embed_key_no_label: "Clave sin nombre",
          portal_embed_key_not_found: "Esa clave ya no existe; se ha recargado la lista.",
          portal_embed_key_revoke: "Revocar",
          portal_embed_key_revoke_confirm: "¿Revocar la clave {{label}}?\n\nTodas las webs que la usen mostrarán «Content not available» en lugar de los componentes. No se puede deshacer.",
          portal_embed_key_revoke_error: "No se ha podido revocar la clave. Inténtalo de nuevo.",
          portal_embed_key_revoked_ok: "Clave revocada.",
          portal_embed_key_revoked_on: "Revocada el {{date}}",
          portal_embed_key_revoking: "Revocando…",
          portal_embed_key_select: "Clave de los snippets",
          portal_embed_keys_desc: "Cada snippet lleva una clave que identifica a tu agencia. Puedes crear una por web y revocarla cuando quieras sin afectar a las demás.",
          portal_embed_keys_empty: "Todavía no tienes ninguna clave activa.",
          portal_embed_keys_error: "No se han podido cargar las claves de inserción.",
          portal_embed_keys_loading: "Cargando claves…",
          portal_embed_keys_readonly: "Solo el administrador de la cuenta puede crear o revocar claves. Puedes copiar los snippets con las claves que ya existen.",
          portal_embed_keys_revoked_more: "y {{n}} más",
          portal_embed_keys_revoked_toggle: "Claves revocadas ({{n}})",
          portal_embed_keys_title: "Claves de inserción",
          portal_embed_lang_en: "Inglés",
          portal_embed_lang_es: "Español",
          portal_embed_lang_label: "Idioma del componente",
          portal_embed_mode_full_desc: "un solo iframe con todas las etapas en orden. Recomendado para una landing.",
          portal_embed_mode_full_title: "Playbook completo",
          portal_embed_mode_single_desc: "un iframe por proceso, para colocar cada uno en la sección de tu web donde encaje. Puedes poner varios uno detrás de otro.",
          portal_embed_mode_single_title: "Componente suelto",
          portal_embed_modes_title: "Dos formas de insertarlos",
          portal_embed_need_key: "Crea primero una clave de inserción: los snippets la necesitan para funcionar.",
          portal_embed_playbook_label: "Playbook",
          portal_embed_playbooks_empty: "Todavía no hay playbooks publicados.",
          portal_embed_playbooks_error: "No se han podido cargar los playbooks.",
          portal_embed_playbooks_loading: "Cargando playbooks…",
          portal_embed_preview_hide: "Ocultar vista previa",
          portal_embed_preview_note: "Vista previa real con la clave seleccionada: es exactamente lo que verán tus visitantes.",
          portal_embed_preview_show: "Vista previa",
          portal_embed_processes_count: "Procesos: {{n}}",
          portal_embed_retry: "Reintentar",
          portal_embed_script_desc: "Pega este script una sola vez en la página (no uno por iframe) para que el alto de los componentes se ajuste solo. Sin él, cada iframe mantiene el alto fijo de su snippet.",
          portal_embed_script_title: "Opcional: alto automático",
          portal_embed_session_expired: "Tu sesión ha caducado. Vuelve a iniciar sesión para gestionar tus componentes.",
          portal_embed_snippet_aria: "Código para pegar en tu web",
          portal_embed_snippets_title: "Insertar en tu web",
          cmp_sdr_title: "Agente comercial por email",
          cmp_sdr_desc: "Escribe por email a los leads de tu CRM, sigue la conversación y la lleva hasta una reunión en la agenda.",
          portal_embed_dev_title: "Componentes en desarrollo",
          portal_embed_dev_desc: "Componentes nuevos que ya puedes insertar en tu web aunque todavía no forman parte de ningún playbook publicado.",
          portal_embed_dev_badge: "En desarrollo",
          portal_embed_dev_note: "Cuando pase a formar parte de un playbook, también aparecerá dentro de ese playbook, y este snippet seguirá funcionando sin cambios.",
          portal_embed_dev_error: "No se ha podido comprobar qué componentes siguen en desarrollo.",
          pbc_unavailable: "Este componente no está disponible.",
          portal_embed_stage: "Etapa {{n}}",
          // --- Demo de playbook con la marca de la agencia (/playbook-demo) ---
          pbd_meta_title: "{{playbook}} — demostración",
          pbd_lab_title: "Laboratorio (no público).",
          pbd_lab_note: "Escenas en pruebas. Solo aparecen con &lab=1 en la dirección y no forman parte de las demos que las agencias mandan a sus clientes.",
          pbd_lab_assistants_title: "Los asistentes de tu empresa",
          pbd_lab_assistants_caption: "Una conversación sencilla por delante y toda la empresa funcionando por detrás: el Manager deriva cada petición al asistente del departamento que toca, cada uno con su color.",
          pbd_loading: "Cargando la demostración…",
          pbd_error: "No se ha podido cargar la demostración. Vuelve a intentarlo en unos segundos.",
          pbd_not_found: "Esta demostración no existe o ya no está publicada.",
          pbd_simulation_title: "Demostración con datos ficticios.",
          pbd_simulation_body: "Los nombres y las cifras son ejemplos ilustrativos, no resultados medidos.",
          pbd_ai_notice: "Algunas escenas muestran agentes de IA trabajando; en el servicio real siempre se identifican como tales.",
          pbd_brand_missing: "No se ha encontrado la marca de la agencia: se muestra la versión neutra.",
          pba_brand_error: "Ahora mismo no se ha podido cargar la marca de la agencia: se muestra la versión neutra. Vuelve a cargar la página en unos segundos.",
          pbd_stage: "Etapa {{n}}",
          pbd_processes: "{{n}} procesos",
          pbd_scene_pending: "Escena aún no ilustrada: se muestra la ficha del proceso.",
          pbd_economics_title: "Cuánto cuesta este sistema",
          pbd_economics_monthly: "Cuota mensual estimada",
          pbd_economics_one_off: "Puesta en marcha",
          pbd_economics_per_use: "Por uso",
          pbd_economics_partial: "Algunos procesos aún no tienen precio publicado, así que el total es un suelo.",
          pbd_economics_note: "Importes orientativos; la propuesta final la prepara la agencia.",
          pbd_cta_title: "¿Quieres verlo funcionando en tu negocio?",
          pbd_cta_body: "Habla con {{agency}} y te lo enseñan con tus propios datos.",
          pbd_cta_button: "Visitar {{agency}}",
          pbd_privacy: "Privacidad",
          pbd_terms: "Términos",
          pbd_powered: "Demostración con datos ficticios · Tecnología de InvokeApp",
          pbl_title: "La escalera de valor, escalón a escalón",
          pbl_subtitle:
            "Un playbook es un sistema completo, no un proceso suelto: uno o varios procesos que entran por etapas y suman una única cuota mensual que cobras a tu cliente como servicio de tu agencia.",
          pbl_chart_title: "Cuánto suma cada playbook",
          pbl_chart_subtitle: "PVP recurrente al mes, sumando los procesos de cada playbook.",
          pbl_chart_foot:
            "El PVP sale de la ficha comercial de cada proceso; tu margen depende de tu plan mayorista.",
          pbl_chart_partial: "Las barras con + incluyen procesos aún sin precio publicado, así que la cifra real es mayor.",
          pbl_per_month: "al mes",
          pbl_step: "Escalón {{n}}",
          pbl_stage: "Etapa {{n}}",
          pbl_monthly: "Recurrente / mes",
          pbl_one_off: "Puesta en marcha",
          pbl_processes_one: "{{count}} proceso incluido",
          pbl_processes_other: "{{count}} procesos incluidos",
          pbl_per_unit: "Por {{unit}}",
          pbl_use_in_calculator: "Usar en la calculadora",
          pbl_notice_estimate:
            "Las cifras salen de la ficha comercial de cada proceso: son una referencia, no un presupuesto.",
          pbl_notice_partial_one: "{{count}} proceso todavía no tiene precio publicado, así que el total es un suelo.",
          pbl_notice_partial_other: "{{count}} procesos todavía no tienen precio publicado, así que el total es un suelo.",
          pbl_notice_mixed: "Este playbook mezcla divisas: los importes nunca se suman entre ellas.",
          pbl_empty:
            "Todavía no hay playbooks publicados. Mientras tanto puedes ver el catálogo completo de procesos y montar tu propia escalera.",
          pbl_empty_cta: "Ver el catálogo de procesos",
          pbl_see_catalog: "Ver todos los procesos del catálogo",
          category: "Categoría",
          integration: "Integración",
          maintenance: "Mantenimiento",
          agentic: "Agéntico",
          pay_per_use: "Pago por uso",
          platform: "Plataforma",
          integration_details_title: "Detalle de Integración",
          integration_details_subtitle: "Resumen de la Integración",
          integration_details_meta: "Estado del sistema",
          integration_details_category: "Categoría",
          integration_details_platforms: "Plataformas",
          integration_details_overview: "Cómo funciona",
          integration_details_activation: "Activaciones",
          integration_details_pay_per_use: "Pago por uso",
          integration_details_yes: "Sí",
          integration_details_no: "No",
          integration_details_unknown: "Sin datos",
          integration_details_back: "Volver a integraciones",
          integration_details_all: "Todos los sistemas",
          integration_details_empty_platforms: "No hay plataformas disponibles todavía.",
          integration_details_empty_desc: "Descripción de la integración no disponible.",

          generic_newsletter_toast_error_politics: "Debes aceptar la política de privacidad para suscribirte.",
          generic_newsletter_toast_error_select_language: "Por favor, selecciona un idioma.",
          generic_toast_success_send_message: "Mensaje enviado con éxito",
          generic_toast_success_send_message_moderation:
            "Tu mensaje ha sido enviado con éxito. Será revisado por nuestros moderadores antes de ser publicado. ¡Gracias por tu contribución!",
          generic_toast_error_notsend_message: "No se pudo enviar el mensaje",

          // POLICIES
          newsletter_policies_title_footer: "Políticas de la Newsletter",
          policies_title_mini: "Términos y condiciones",
          // Faltaba en `es` (solo existía en `en`): /privacy publicaba la clave en crudo.
          policies_title_mini_newsletter: "Términos y condiciones",
          policies_newsletter_title: "Políticas del Boletín",
          policies_newsletter_title_one: "Política de Suscripción al Boletín",
          policies_newsletter_description_one:
            "Al suscribirte, aceptas recibir comunicaciones de MARTÍNEZ CAMPOY CONSULTING, S.L. (InvokeApp) centradas en sistemas para agencias, workflows, reporting y actualizaciones del producto. Tratamos tus datos según nuestra Política de Privacidad.",
          policies_newsletter_title_two: "Recopilación de Información",
          policies_newsletter_description_two:
            "Para suscribirte solo pedimos tu email. Cualquier información extra es opcional y solo se usa para personalizar contenido.",
          policies_newsletter_title_three: "Uso de la Información",
          policies_newsletter_description_three:
            "Usamos tu información para enviarte newsletters y comunicaciones relevantes. No vendemos tus datos y no los compartimos sin consentimiento, salvo para prestar el servicio o por obligación legal.",
          policies_newsletter_title_four: "Derecho de Baja",
          policies_newsletter_description_four:
            "Puedes darte de baja en cualquier momento usando el enlace `darse de baja` incluido en cada email.",
          policies_newsletter_title_five: "Actualizaciones de la Política",
          policies_newsletter_description_five:
            "Podemos actualizar estas políticas en cualquier momento. Los cambios se aplican inmediatamente tras publicarse.",
          policies_newsletter_title_six: "Contacto",
          policies_newsletter_description_six:"Si tienes dudas sobre estas políticas, contáctanos a través de",

          ebook_download_policies_title_footer: "Políticas de Descarga del Playbook",
          policies_title_mini_ebook: "Términos y condiciones",
          policies_ebook_download_title: "Políticas de Descarga del Playbook",
          policies_ebook_download_title_one: "Política de Descarga del Playbook",
          policies_ebook_download_description_one:"Al descargar el playbook, consientes en proporcionarnos tu email y aceptas recibir comunicaciones de MARTÍNEZ CAMPOY CONSULTING, S.L. (InvokeApp) sobre sistemas para agencias, plantillas y actualizaciones. Tratamos tus datos según la Política de Privacidad.",
          policies_ebook_download_title_two: "Recolección de Información",
          policies_ebook_download_description_two:"Requerimos tu email para enviarte la descarga. Cualquier dato adicional es opcional y solo se usa para personalizar el contenido.",
          policies_ebook_download_title_three: "Uso de la Información",
          policies_ebook_download_description_three:"Usamos la información para entregarte el playbook y enviarte comunicaciones relacionadas. No compartimos tus datos sin permiso salvo por necesidad del servicio o por ley.",
          policies_ebook_download_title_four: "Derecho de Cancelación",
          policies_ebook_download_description_four:"Puedes darte de baja en cualquier momento usando el enlace `cancelar suscripción`.",
          policies_ebook_download_title_five: "Modificaciones a la Política",
          policies_ebook_download_description_five:"Podemos modificar estas políticas en cualquier momento. Los cambios se aplican inmediatamente tras publicarse.",
          policies_ebook_download_title_six: "Consultas",
          policies_ebook_download_description_six:"Si tienes preguntas, puedes escribirnos a través de",

          contact_policies_title_footer: "Políticas de Contacto",
          policies_title_mini_contact: "Términos y Condiciones",
          policies_contact_title: "Políticas de Contacto",
          policies_contact_title_one: "Recolección de Información para Contacto",
          policies_contact_description_one:"Cuando nos contactas, recopilamos tu email y la información que compartas para poder responder y ayudarte con tu agencia.",
          policies_contact_title_two: "Uso de la Información de Contacto",
          policies_contact_description_two:"Usamos tus datos para responder a tu solicitud y, si das consentimiento, enviarte información relevante sobre sistemas para agencias e InvokeApp.",
          policies_contact_title_three: "Protección de Tu Información",
          policies_contact_description_three:"Guardamos tus datos de forma segura y no los compartimos sin consentimiento, salvo para prestar el servicio o por obligación legal.",
          policies_contact_title_four: "Opción de Exclusión",
          policies_contact_description_four:"Puedes pedir que eliminemos tus datos de contacto cuando quieras usando enlaces de baja o escribiéndonos directamente.",
          policies_contact_title_five: "Actualizaciones de la Política",
          policies_contact_description_five:"Podemos actualizar estas políticas en cualquier momento. Los cambios entran en vigor inmediatamente tras publicarse.",
          policies_contact_title_six: "Contáctanos",
          policies_contact_description_six:"Si tienes preguntas sobre estas políticas, contáctanos a través de",

          comment_policies_title_footer: "Políticas de Comentarios",
          policies_title_mini_comment: "Términos y Condiciones",
          policies_comment_title: "Políticas de Comentarios",
          policies_comment_title_one: "Reglas para Publicar Comentarios",
          policies_comment_description_one:"Bienvenidos comentarios que mejoren la conversación sobre operaciones y sistemas para agencias. Respeto siempre. Sin odio. Sin actividades ilegales. Podemos eliminar comentarios que incumplan estas normas.",
          policies_comment_title_two: "Uso de Información Personal",
          policies_comment_description_two:"Para comentar debes aportar tu email. Se usa para moderación y prevención de abuso. Tu email no se muestra públicamente.",
          policies_comment_title_three: "Moderación y Aprobación",
          policies_comment_description_three:"Los comentarios pueden pasar moderación antes de publicarse. Podemos editar o rechazar comentarios que no cumplan estándares.",
          policies_comment_title_four: "Derechos sobre los Comentarios",
          policies_comment_description_four:"Al publicar un comentario, nos autorizas a mostrarlo y distribuirlo en nuestras plataformas.",
          policies_comment_title_five: "Actualizaciones de la Política",
          policies_comment_description_five:"Podemos actualizar estas políticas en cualquier momento. Entran en vigor inmediatamente tras publicarse.",
          policies_comment_title_six: "Contacto",
          policies_comment_description_six:"Si tienes dudas sobre estas políticas, contáctanos a través de",


          cookies_policies_title_footer: "Política de cookies",
          cookies_policies_title_mini: "Términos y condiciones",

          cookies_policies_title: "Política de cookies",
          cookies_policies_subtitle: "Última actualización: 4 febrero 2026",

          cookies_policy_description_one:"Esta política de cookies forma parte integrante del <strong>Aviso legal</strong> y la <strong>Política de privacidad</strong> del sitio web <a href='https://invokeapp.io' target='_blank' rel='noopener'>https://invokeapp.io</a> (en adelante, «Sitio web»).",

          cookies_policy_description_two:"Puede gestionar la configuración de las cookies en cualquier momento. Puede aceptar expresamente la instalación y el uso de cookies haciendo clic en <strong>«Permitir todo»</strong> o <strong>«Permitir selección»</strong> en el banner de cookies, o bien desactivar o denegar la instalación y el uso de cookies.",

          cookies_policy_description_three:"En caso de que rechace el uso de cookies, su experiencia de navegación en el Sitio web puede verse afectada negativamente y algunas funciones del Sitio web pueden no funcionar correctamente.",

          cookies_policy_description_four:"Con el fin de facilitar la navegación por el sitio web, el propietario del sitio web <strong>MARTÍNEZ CAMPOY CONSULTING, S.L.</strong> (en adelante, «invokeapp») le informa de que utiliza cookies y otras tecnologías similares (en adelante, «cookies»).",

          cookies_policy_title_one: "1. ¿Qué son las cookies?",

          cookies_policy_description_five:"Las cookies son pequeños archivos de datos (archivos de texto) que un sitio web, cuando es visitado por un usuario, solicita al navegador que almacene información en su dispositivo.",

          cookies_policy_description_six:"La información contenida en estos archivos nos permite <strong>optimizar y personalizar</strong> nuestro sitio web, analizar su uso y mostrarle publicidad relevante.",

          cookies_policy_description_seven:"Existen diferentes tipos de cookies según la entidad que las gestione o según su finalidad. Algunas cookies son esenciales para el funcionamiento de Internet y otras pueden utilizarse con fines publicitarios o analíticos.",

          cookies_policy_description_eight:"Utilizamos cookies propias para recordar información como el idioma o el inicio de sesión, y cookies de terceros para nuestros estudios analíticos.",

          cookies_policy_title_two: "2. Consentimiento del usuario y uso de cookies",

          cookies_policy_description_nine:"La ley establece que podemos procesar cookies si son estrictamente necesarias para el funcionamiento de este sitio, pero para otros tipos de cookies necesitamos su consentimiento.",

          cookies_policy_description_ten:"Puede permitir o denegar el procesamiento de cookies mediante su consentimiento explícito. Este consentimiento es libre y, si no lo permite, puede seguir utilizando este sitio web.",

          cookies_policy_subtitle_one: "Consentimiento",

          cookies_policy_description_eleven:"Al hacer clic en <strong>«Permitir todo»</strong> o <strong>«Permitir selección»</strong> en el banner de cookies, usted da su consentimiento para la instalación y el uso de todas las cookies en su dispositivo.",

          cookies_policy_subtitle_two: "Retirada del consentimiento",

          cookies_policy_description_twelve:"Al hacer clic en el botón <strong>«Denegar»</strong> de la Plataforma de gestión de cookies, podrá rechazar directamente el uso de las cookies.",

          cookies_policy_description_thirteen:"Si rechaza las cookies, no instalaremos ninguna cookie adicional salvo las <strong>cookies necesarias</strong>.",

          cookies_policy_subtitle_three: "Herramienta de configuración",

          cookies_policy_description_fourteen:"Cuando accede al sitio web por primera vez, puede aceptar, configurar o rechazar las cookies a través de la Plataforma de gestión de cookies.",

          cookies_policy_description_fifteen:"Puede modificar o retirar su consentimiento en cualquier momento accediendo nuevamente a dicha plataforma.",

          cookies_policy_title_three:"3. Tipos de cookies utilizadas en el sitio web y para qué finalidad",

          cookies_policy_subtitle_four:"<strong>Cookies propias</strong>",

          cookies_policy_description_sixteen:"Cookies enviadas al dispositivo del usuario desde un dominio gestionado por invokeapp.",

          cookies_policy_subtitle_five:"<strong>Cookies de terceros</strong>",

          cookies_policy_description_seventeen:"Cookies enviadas desde dominios no gestionados por invokeapp, sino por otras entidades.",

          cookies_policy_subtitle_six:"<strong>Cookies necesarias</strong>",

          cookies_policy_description_eighteen:"Son imprescindibles para el funcionamiento del sitio web y no requieren consentimiento.",

          cookies_policy_subtitle_seven:"<strong>Cookies de preferencias</strong>",

          cookies_policy_description_nineteen:"Permiten recordar información como idioma, apariencia o región. Su uso se basa en su consentimiento.",

          cookies_policy_subtitle_eight:"<strong>Cookies estadísticas</strong>",

          cookies_policy_description_twenty:"Permiten analizar el comportamiento de los usuarios con el fin de mejorar el rendimiento del sitio web.",

          cookies_policy_subtitle_nine:"<strong>Cookies de marketing</strong>",

          cookies_policy_description_twenty_one:"Permiten crear un perfil del usuario para mostrar publicidad personalizada.",

          cookies_policy_description_twenty_two:
          "Utilizamos estas cookies para prestar el servicio, mejorar nuestros productos, garantizar la seguridad y realizar acciones de marketing y publicidad.",

          cookies_policy_title_four:
          "4. ¿Cómo puede controlar las cookies?",

          cookies_policy_description_twenty_three:
          "Puede habilitar, deshabilitar o eliminar las cookies desde la configuración de su navegador en cualquier momento.",

          cookies_policy_title_five:
          "5. Modificaciones de la política de cookies",

          cookies_policy_description_twenty_four:
          "invokeapp se reserva el derecho de modificar esta Política de cookies en cualquier momento. Le recomendamos revisarla periódicamente.",

          cookies_policy_title_six:
          "6. Contacto",

          cookies_policy_description_twenty_five:
          "Para cualquier consulta relacionada con esta Política de cookies, puede contactar con nosotros en <a href='mailto:letstalk@invokeapp.io'>letstalk@invokeapp.io</a>.",

          cookies_policy_description_twenty_six:
          "Puede encontrar más información sobre el tratamiento de sus datos en la <strong>Política de privacidad</strong> del sitio web.",

          landing_nav_cta: "Empezar ahora",
          landing_nav_agencies: "Agencias",
          landing_nav_partners: "Partners",
          landing_nav_product: "Producto",
          landing_nav_scale: "Escala",
          landing_nav_explore: "Explora",
          landing_nav_affiliates: "Afiliados",

          // Partners Landing
          partners_badge: "Abriendo Puertas a Nuevos Socios Q4 2026",
          partners_h1_prefix: "Haz crecer tu agencia",
          partners_h1_middle: "con nuestra",
          partners_h1_gradient: "Infraestructura",
          partners_subtitle: "El programa de Partnership B2B para líderes en automatización. Nosotros proveemos la base tecnológica; tú aportas la estrategia y la implementación.",
          partners_cta_primary: "Conviértete en Socio",
          partners_cta_secondary: "Ver Documentación",
          partners_roadmap_badge: "El Viaje del Socio Explorador",
          partners_roadmap_title: "Tu Hoja de Ruta hacia el Éxito en IA",
          partners_roadmap_desc: "Te guiaremos paso a paso, desde la comprensión de nuestro ecosistema hasta la implementación exitosa y el crecimiento continuo.",
          partners_step_1_label: "Paso 1",
          partners_step_1_title: "Descubre el Valor de ser Socio",
          partners_step_1_desc: "Creemos en la colaboración sobre la competencia. Un socio estratégico es una extensión de nuestro equipo, aportando su experiencia sectorial mientras nosotros proveemos la infraestructura tecnológica. No vendemos servicios; te capacitamos para que tú los vendas.",
          partners_step_2_label: "Paso 2",
          partners_step_2_title: "La Plataforma: Tu Backbone Tecnológico",
          partners_step_2_desc: "Accede a nuestras herramientas de vanguardia, diseñadas para potenciar tus servicios. Desde APIs completas hasta paneles de control personalizables para tus clientes.",
          partners_step_2_bullet_1: "Acceso completo a API y Webhooks",
          partners_step_2_bullet_2: "Panel de cliente con el logo de tu agencia",
          partners_step_2_bullet_3: "Soporte Técnico Nivel 1",
          partners_step_2_bullet_4: "Infraestructura Escalable",
          partners_step_3_label: "Paso 3",
          partners_step_3_title: "Tu Rol: Estrategia y Relación con el Cliente",
          partners_step_3_desc: "Eres la cara visible y el motor de la innovación para tus clientes. Aportas la visión estratégica y la cercanía que impulsan el éxito.",
          partners_step_3_bullet_1: "Experiencia Específica del Sector",
          partners_step_3_bullet_2: "Gestión de Relaciones con Clientes",
          partners_step_3_bullet_3: "Implementación en Sitio",
          partners_step_3_bullet_4: "Primera Línea de Soporte",
          partners_step_4_label: "Paso 4",
          partners_step_4_title: "Define tu Modelo de Colaboración",
          partners_step_4_desc: "Ofrecemos opciones flexibles para que elijas el nivel de implicación que mejor se adapte a tu estrategia de negocio y capacidad operativa.",
          partners_step_4_model_1: "Referral — Para Consultores",
          partners_step_4_model_2: "Partner tecnológico — Para Agencias",
          partners_step_4_model_3: "Integrator — Para Desarrolladores",
          partners_step_5_label: "Paso 5",
          partners_step_5_title: "Aplica y Comienza tu Crecimiento",
          partners_step_5_desc: "Si te alineas con nuestra visión de crecimiento y aportas valor, ¡queremos conocerte! El proceso de aplicación es sencillo y rápido.",
          partners_infra_badge: "Para Partners",
          partners_infra_title: "La capa de infraestructura que te permite vender automatización como producto.",
          partners_infra_desc: "No te damos scripts ni herramientas sueltas. Te damos una plataforma operable, escalable y controlable para que construyas tu propia oferta sobre ella.",
          partners_infra_1_title: "Plantillas reutilizables y clonables",
          partners_infra_1_desc: "Diseña una vez, despliega en decenas de clientes manteniendo control y coherencia.",
          partners_infra_2_title: "Ejecución por instancia y cliente",
          partners_infra_2_desc: "Cada cliente corre sus procesos de forma aislada, estable y auditable.",
          partners_infra_3_title: "Gestión centralizada de credenciales",
          partners_infra_3_desc: "Controla accesos, integraciones y permisos de todos tus clientes desde un solo lugar.",
          partners_infra_4_title: "Infraestructura pensada para vender",
          partners_infra_4_desc: "Versionado, control de cambios y rollback. Automatización como producto, no como experimento.",
          partners_audience_title: "¿Es esto para ti?",
          partners_audience_for_title: "Eres un candidato ideal si...",
          partners_audience_for_1: "Gestionas una agencia con más de 10 clientes B2B activos buscando automatización.",
          partners_audience_for_2: "Tienes capacidad técnica para implementar pequeños fragmentos de JS o llamadas API.",
          partners_audience_for_3: "Quieres pasar de 'ingresos por servicios' a 'ingresos recurrentes'.",
          partners_audience_not_title: "Esto NO es para ti si...",
          partners_audience_not_1: "Eres un freelancer en busca de un trabajo puntual.",
          partners_audience_not_2: "Buscas un esquema de 'hacerte rico rápido' sin aportar valor.",
          partners_audience_not_3: "No tienes conocimientos técnicos o interés en la IA.",
          partners_cta_title: "¿Listo para construir el futuro?",
          partners_cta_desc: "Únete a las agencias que aprovechan nuestra infraestructura para ofrecer automatización de IA de próxima generación a sus clientes.",
          partners_cta_button: "Aplicar al Portal de Socios",
          partners_cta_footnote: "No se requiere tarjeta de crédito para la aplicación • Revisiones en 48h",

          // Product Landing
          product_page_title: "InvokeApp - Infraestructura de Automatización e IA",
          product_badge: "Acceso Beta Pública",
          product_h1_prefix: "Automatización e IA",
          product_h1_gradient: "a escala",
          product_h1_suffix: "Constrúyelas como Infraestructura.",
          product_subtitle: "Una plataforma para equipos técnicos y agencias que diseñan, despliegan y gestionan automatización e IA reutilizables como infraestructura escalable.",
          product_cta_primary: "Solicitar Acceso",
          product_cta_secondary: "Contáctanos",
          product_problem_badge: "El Problema",
          product_problem_title: "Por qué el modelo actual falla",
          product_problem_1_title: "Workflows únicos",
          product_problem_1_desc: "Cada nuevo proyecto implica reconstruir, copiar y pegar scripts manualmente.",
          product_problem_2_title: "Credenciales dispersas",
          product_problem_2_desc: "Gestionar accesos entre múltiples herramientas se convierte en una pesadilla operativa y de seguridad.",
          product_problem_3_title: "Sin gobernanza",
          product_problem_3_desc: "Sin un enfoque sistemático, la consistencia y las mejores prácticas son imposibles.",
          product_problem_4_title: "IA añadida superficialmente",
          product_problem_4_desc: "Los modelos de IA suelen ser una ocurrencia tardía, no integrados profundamente en procesos escalables.",
          product_solution_badge: "La Solución",
          product_solution_title: "Proveemos la capa faltante para una automatización robusta y escalable.",
          product_solution_desc: "Trata la automatización como parte central de tu stack técnico, no como una serie de scripts.",
          product_solution_1_title: "Plantillas de workflow reutilizables",
          product_solution_1_desc: "Diseña una vez, despliega múltiples veces, adaptado para cada cliente o proyecto.",
          product_solution_2_title: "Ejecución por instancia",
          product_solution_2_desc: "Cada despliegue funciona independientemente, garantizando aislamiento y estabilidad.",
          product_solution_3_title: "Gestión centralizada de credenciales",
          product_solution_3_desc: "Gestiona de forma segura todas las integraciones y accesos en un solo lugar.",
          product_solution_4_title: "Enfoque de infraestructura primero",
          product_solution_4_desc: "Trata la automatización como código, con versionado y rollbacks.",
          product_intel_title: "Cómo es diferente",
          product_intel_subtitle: "De scripts frágiles a sistemas interconectados.",
          product_intel_1_title: "Sistemas Interconectados",
          product_intel_1_desc: "Ve más allá de herramientas aisladas. Construye arquitecturas duraderas que se comunican sin problemas.",
          product_intel_2_title: "Productos Escalables",
          product_intel_2_desc: "Convierte proyectos únicos en productos repetibles y vendibles.",
          product_intel_3_title: "Arquitectura Duradera",
          product_intel_3_desc: "Diseña sistemas que perduran. Infraestructura que evoluciona con tus necesidades.",
          product_intel_4_title: "Infraestructura Confiable",
          product_intel_4_desc: "Redundancia integrada, monitoreo y auto-recuperación para operaciones críticas.",
          product_future_title: "Hacia dónde vamos",
          product_future_desc: "Nuestra visión es evolucionar de procesos individuales a sistemas interconectados e inteligentes que se adapten y operen con mínima intervención humana.",
          product_phase_1_label: "Fase 1",
          product_phase_1_title: "Workflows",
          product_phase_1_desc: "Diseña y despliega workflows de automatización individuales.",
          product_phase_2_label: "Fase 2",
          product_phase_2_title: "Sistemas",
          product_phase_2_desc: "Conecta workflows en sistemas inteligentes y coordinados.",
          product_phase_3_label: "Fase 3",
          product_phase_3_title: "Autonomía",
          product_phase_3_desc: "Sistemas auto-operables que se adaptan y optimizan en tiempo real.",
          product_cta_bottom: "Solicita Acceso Anticipado",

          // Scale Landing
          scale_page_title: "InvokeApp - Escalado de Servicios de Automatización",
          scale_badge: "Infraestructura B2B",
          scale_h1_prefix: "Automatización e IA a escala:",
          scale_h1_gradient: "estandariza, controla, rentabiliza.",
          scale_subtitle: "Infraestructura para agencias y estudios avanzados que transforman proyectos aislados en sistemas replicables y rentables.",
          scale_cta_primary: "Solicita una demo",
          scale_cta_secondary: "Habla con el equipo",
          scale_problem_badge: "El Problema",
          scale_problem_title: "El caos de escalar sin infraestructura",
          scale_problem_1_title: "Cada cliente, un universo",
          scale_problem_1_desc: "La gestión de automatizaciones se vuelve inmanejable cuando cada proyecto es único.",
          scale_problem_2_title: "Automatizaciones ad-hoc",
          scale_problem_2_desc: "Falta de estandarización que dificulta la replicabilidad y aumenta costes de mantenimiento.",
          scale_problem_3_title: "Dependencia de personas clave",
          scale_problem_3_desc: "El conocimiento reside en individuos, no en el sistema, creando cuellos de botella.",
          scale_problem_4_title: "Control difuso",
          scale_problem_4_desc: "Dificultades críticas para monitorizar accesos, ejecuciones y rendimiento entre múltiples cuentas.",
          scale_control_badge: "La Solución",
          scale_control_title: "De la improvisación al control absoluto",
          scale_control_desc: "El cambio de paradigma que tu agencia necesita.",
          scale_control_1_title: "Workflows reutilizables",
          scale_control_1_desc: "Diseña una vez, despliega múltiples veces. Crea plantillas maestras y aplícalas a nuevos clientes con variaciones controladas.",
          scale_control_2_title: "Instancias por cliente",
          scale_control_2_desc: "Aísla entornos para cada cliente, garantizando seguridad absoluta y evitando contaminación de datos entre proyectos.",
          scale_control_3_title: "Gestión de credenciales separadas",
          scale_control_3_desc: "Control granular de accesos y credenciales API. Centralizado pero seguro, sin compartir llaves entre entornos.",
          scale_control_4_title: "Control centralizado y trazabilidad",
          scale_control_4_desc: "Monitoriza cada ejecución, audita cambios y gestiona permisos de equipo desde un único panel de mando.",
          scale_control_5_title: "Seguridad y gobernanza",
          scale_control_5_desc: "Cumplimiento normativo y control total sobre todas tus operaciones de automatización e IA.",
          scale_metric_1: "Crecimiento de ingresos",
          scale_metric_2: "Tiempo de actividad del sistema",
          scale_metric_3: "Velocidad de despliegue",
          scale_metric_4: "Reducción de costes operativos",
          scale_results_title: "Resultados que transforman tu negocio",
          scale_result_1_title: "Estandarización real",
          scale_result_1_desc: "Implementa metodologías consistentes en todos tus proyectos sin esfuerzo extra.",
          scale_result_2_title: "Menos errores operativos",
          scale_result_2_desc: "Reduce drásticamente el riesgo humano y mejora la calidad de entrega final.",
          scale_result_3_title: "Mayor margen y rentabilidad",
          scale_result_3_desc: "Optimiza recursos y escala servicios sin sacrificar beneficios por costes de mantenimiento.",
          scale_result_4_title: "Escalado sin fricción",
          scale_result_4_desc: "Añade nuevos clientes y servicios con la confianza de una base sólida que no se rompe.",
          scale_result_5_title: "Gobierno de automatización",
          scale_result_5_desc: "Asegura el cumplimiento y la coherencia en todas tus operaciones, algo vital para clientes corporativos.",
          scale_audience_for_title: "Esta infraestructura es para ti si",
          scale_audience_for_1: "Eres una agencia, estudio avanzado u organización de servicios que ya vende automatización o servicios digitales.",
          scale_audience_for_2: "Necesitas estandarizar, controlar y escalar sin caos.",
          scale_audience_for_3: "Quieres pasar de proyectos aislados a sistemas robustos y replicables.",
          scale_audience_not_title: "No es para ti si",
          scale_audience_not_1: "Buscas una herramienta de experimentación personal o una solución de prueba gratuita.",
          scale_audience_not_2: "Eres un usuario individual buscando una herramienta de un solo propósito.",
          scale_audience_not_3: "No estás listo para operar a escala con procesos estructurados.",
          scale_cta_title: "El siguiente paso hacia el control operativo",
          scale_cta_desc: "Diseñada para líderes que buscan orden y margen. Hablemos de cómo nuestra infraestructura puede transformar tu forma de operar.",
          scale_cta_button: "Solicita una demo estratégica",

          // Explore Landing
          explore_page_title: "InvokeApp - Plataforma de atención al cliente, citas y CRM para agencias",

          // ---- Landing del kit (/resources/ai-kit) ----
          aikit_page_title: "Kit para crear y vender servicios de IA",
          aikit_page_meta:
            "Plantillas, propuestas y modelos de contrato para pasar de una idea a una oferta de servicios de IA. Gratis, por email.",
          aikit_nav_label: "Kit de IA",
          aikit_nav_offer: "Oferta",
          aikit_skip_to_content: "Ir al contenido",
          aikit_motion_pause: "Pausar el movimiento",
          aikit_motion_play: "Reanudar el movimiento",
          aikit_footer_legal:
            "MARTÍNEZ CAMPOY CONSULTING, S.L. · C.I.F. B88657853 · Calle Roma, 15 · 30600 Archena (Murcia)",
          aikit_hero_kicker: "Para freelancers, consultores y agencias",
          aikit_hero_title: "Tu próximo servicio de IA empieza aquí.",
          aikit_hero_desc:
            "Plantillas, propuestas y modelos de contrato para pasar de una idea a una oferta.",
          aikit_cta_kit: "Recibir el kit gratis",
          aikit_hero_offer_link: "Ver oferta del webinar",
          aikit_hero_micro: "Gratis. Por email. Newsletter opcional.",
          aikit_res_title: "Define. Presupuesta. Entrega.",
          aikit_res_1_title: "Prepara tu propuesta (con la documentación)",
          aikit_res_2_title: "Organiza la entrega",
          aikit_res_preview_alt: "Vista previa de los documentos del kit",
          aikit_faq_1_q: "¿Necesito contratar InvokeApp?",
          aikit_faq_1_a:
            "No. Puedes recibir el kit sin contratar la plataforma ni suscribirte a la newsletter.",
          aikit_faq_2_q: "¿Cómo recibo los recursos?",
          aikit_faq_2_a: "Deja tu email y te enviaremos el acceso al kit.",
          aikit_plat_kicker: "La plataforma detrás del kit",
          aikit_plat_title: "Tus servicios de IA. Tus clientes. Una plataforma.",
          aikit_plat_desc:
            "Con InvokeApp puedes configurar agentes, conectar herramientas y gestionar la operación de cada cliente.",
          aikit_plat_1: "Procesos reutilizables",
          aikit_plat_2: "Gestión por cliente",
          aikit_plat_3: "Seguimiento de la actividad",
          aikit_offer_kicker: "Oferta exclusiva del webinar",
          aikit_offer_title: "Pon en marcha tu primer servicio con InvokeApp.",
          aikit_offer_desc:
            "Precios de siempre, descuentos que solo existen aquí y durante estas horas.",
          aikit_offer_cta: "Aprovechar la oferta",
          aikit_offer_renewal: "Después: {{price}}",
          aikit_offer_session: "Incluye una sesión de consultoría de {{duration}} para {{scope}}.",
          aikit_offer_deadline: "Disponible hasta el {{date}}, a las {{time}} (hora de Madrid).",
          aikit_offer_plain_kicker: "Empieza con InvokeApp",
          aikit_offer_plans_cta: "Ver planes",
          aikit_plan_first_month: "el primer mes",
          aikit_plan_then: "Después, {{price}}",
          aikit_plan_code: "Código de descuento",
          aikit_plan_code_hint: "Aplica el código en el pago para que se descuente.",
          aikit_plan_copied: "Copiado",
          aikit_plan_copy: "Copiar el código",
          aikit_plan_pending: "Código y enlace de pago, disponibles durante el webinar.",
          aikit_plan_bonus: "Bonus incluido",
          aikit_plan_per_month: "al mes",
          // ---- Landing AI Commercial System (/resources/ai-commercial-system) ----
          aics_nav_label: "AI Commercial System",
          aics_page_title: "AI Commercial System: el seguimiento comercial como servicio facturado",
          aics_page_meta:
            "Kit gratuito: siete pasos para convertir el seguimiento comercial de tus clientes en un servicio recurrente, con un tip por paso y un checklist. Por email.",
          aics_nav_plans: "Planes",
          aics_hero_kicker: "Kit gratuito · IA aplicada",
          aics_hero_title: "Convierte el seguimiento comercial en un servicio facturado.",
          aics_hero_desc:
            "Qué vender, qué riesgos revisar y qué exigir antes de activar: de la base de datos de tu cliente a la primera venta recuperada.",
          aics_cta: "Quiero el kit gratis",
          aics_hero_plans_link: "Ver planes",
          aics_res_title: "Siete pasos, un tip por paso y ningún envío sin permiso.",
          aics_res_1_title: "Los siete pasos, de la base de datos a la primera venta recuperada",
          aics_res_2_title: "Un tip por paso para evitar lo que cuesta clientes, reputación o sanciones",
          aics_res_3_title: "El checklist de ocho casillas para tu primer cliente",
          aics_res_preview_alt: "Vista previa del kit de seguimiento comercial con IA",
          aics_faq_1_q: "¿Tengo que suscribirme a InvokeApp?",
          aics_faq_1_a:
            "No. Puedes recibir el kit sin suscribirte a la plataforma ni a la newsletter.",
          aics_faq_2_q: "¿Cómo recibo el kit?",
          aics_faq_2_a: "Déjanos tu email y te enviamos el enlace para descargarlo en PDF.",
          aics_plat_kicker: "La plataforma detrás del sistema",
          aics_plat_title: "Tu seguimiento comercial, funcionando solo.",
          aics_plat_desc:
            "Con InvokeApp, agentes de IA redactan y envían el seguimiento desde el correo de cada proyecto y lo registran en el CRM.",
          aics_plat_1: "Preventa",
          aics_plat_2: "Postventa",
          aics_plat_3: "CRM integrado",
          aics_wheel_lead:
            "El kit te da el método. La plataforma, con qué ponerlo en marcha.",
          aics_demo_kicker: "Míralo funcionando",
          aics_demo_title: "Del lead del CRM a la reunión agendada.",
          aics_demo_desc:
            "El agente SDR prepara cada mensaje con lo que sabe del contacto, una persona lo revisa y sale desde el correo del proyecto.",
          aics_plans_kicker: "Empieza con InvokeApp",
          aics_plans_title: "Pon tu sistema comercial a trabajar.",
          aics_plans_desc: "Los planes de siempre, con todo lo que incluye cada uno.",
          aics_plans_cta: "Empezar",
          aics_plans_compare: "Comparar planes",
          aics_form_title: "Recibe el kit de seguimiento comercial",
          aics_form_desc: "Siete pasos, un tip por paso y un checklist para el primer cliente. Gratis, en PDF.",
          aics_form_submit: "Envíame el kit",
          aics_form_terms_error: "Tienes que aceptar los Términos y Condiciones para recibir el kit.",
          aics_form_ok: "Tu kit va de camino.",
          aics_form_ok_noemail: "Solicitud recibida.",
          aics_form_ok_open: "Abrir el kit",
          aics_done_text_noemail: "Queda registrada. Te haremos llegar el kit.",
          resources_aics_text: "Siete pasos para convertir el seguimiento comercial en un servicio facturado. Kit gratuito.",
          aikit_foot_home: "Inicio",
          aikit_foot_plans: "Planes",
          aikit_foot_playbooks: "Playbooks",
          aikit_foot_catalog: "Catálogo",
          aikit_foot_more: "Más de InvokeApp",
          aikit_done_text:
            "Te lo enviamos al email que nos has dejado. Si no aparece, revisa las carpetas de spam y promociones.",
          aikit_done_text_noemail: "Queda anotada. Te haremos llegar el acceso al kit.",
          aikit_done_next: "Y ya que estás: la oferta del webinar solo dura unas horas.",
          aikit_done_audit: "Reservar una auditoría gratuita",
          aikit_audit_kicker: "¿Aún tienes dudas?",
          aikit_cd_title: "La oferta se cierra en",
          aikit_cd_days: "días",
          aikit_cd_hours: "horas",
          aikit_cd_min: "min",
          aikit_cd_sec: "seg",
          aikit_cd_aria: "La oferta se cierra el {{date}} a las {{time}}, hora de Madrid.",
          aikit_offer_ended: "La oferta del webinar ha terminado.",
          aikit_offer_qr: "Escanea para contratar",
          aikit_wheel_lead: "El kit te da la oferta. La plataforma te da con qué entregarla.",
          aikit_form_terms: "He leído y acepto los Términos y Condiciones.",
          aikit_form_terms_link: "Términos y Condiciones",
          aikit_form_terms_error:
            "Tienes que aceptar los Términos y Condiciones para recibir el kit.",
          aikit_form_title: "Recibe tu kit gratis",
          aikit_form_desc: "Plantillas y recursos para crear y vender servicios de IA.",
          aikit_form_email: "Tu email",
          aikit_form_email_ph: "nombre@empresa.com",
          aikit_form_newsletter:
            "Quiero recibir por email ideas, novedades y ofertas de InvokeApp.",
          aikit_form_submit: "Enviarme el kit",
          aikit_form_support: "La newsletter es opcional. Puedes darte de baja cuando quieras.",
          aikit_form_sending: "Enviando…",
          aikit_form_error_email: "Introduce un email válido.",
          aikit_form_error: "No hemos podido completar la solicitud. Inténtalo de nuevo.",
          aikit_form_close: "Cerrar",
          aikit_form_ok: "Tu kit está en camino.",
          aikit_form_ok_noemail: "Solicitud recibida.",
          aikit_form_ok_open: "Abrir el kit ahora",
          aikit_form_ok_offer: "Ver oferta del webinar",
          newsletter_popup_title: "Suscríbete a la newsletter de InvokeApp",
          newsletter_popup_desc:
            "Ideas para vender servicios de IA, novedades de la plataforma y ofertas para agencias, en tu email.",
          newsletter_popup_consent:
            "Al suscribirte aceptas recibir por email ideas, novedades y ofertas de InvokeApp. Puedes darte de baja cuando quieras.",
          newsletter_popup_submit: "Suscribirme",
          newsletter_popup_terms_error:
            "Tienes que aceptar los Términos y Condiciones para suscribirte.",
          newsletter_popup_error: "No hemos podido completar la suscripción. Inténtalo de nuevo.",
          newsletter_popup_ok: "¡Listo! Ya estás en la newsletter.",
          newsletter_popup_ok_fallback: "Hemos recibido tu alta.",
          newsletter_popup_ok_text: "Te escribiremos con ideas, novedades y ofertas de InvokeApp.",
          newsletter_popup_ok_next:
            "Y si quieres ir más rápido: revisamos tu agencia y te decimos qué procesos puedes ofrecer a tus clientes.",



          explore_page_meta:
            "Agencias, freelances y consultores activan procesos ya construidos de atención al cliente, citas y seguimiento comercial para sus clientes, a su precio. Plataforma SaaS, no un curso.",
          explore_badge: "Plataforma SaaS para agencias, freelances y consultores",
          explore_h1_prefix: "No vienes a aprender otra herramienta.",
          explore_h1_gradient_1: "Vienes a dar mejor servicio a tus clientes.",
          explore_subtitle:
            "Activas procesos ya construidos de atención al cliente, citas y seguimiento comercial y se los entregas a tus clientes como servicio de tu agencia, al precio que tú pongas. Tú vendes; nosotros mantenemos la máquina.",
          explore_how_title: "Cómo funciona la plataforma",
          explore_how_desc:
            "El recorrido es el mismo para todos: da igual que lleves una agencia con veinte clientes, que trabajes por tu cuenta o que vivas de asesorar. Cuatro pasos, y en ninguno se escribe código.",
          explore_how_1_title: "Eliges qué vas a entregar",
          explore_how_1_desc:
            "Abres el catálogo y eliges: un proceso suelto, o un playbook entero, que es el servicio ya montado por etapas. Cada uno trae su ficha con lo que hace y lo que cuesta.",
          explore_how_2_title: "Lo activas para un cliente",
          explore_how_2_desc:
            "Lo configuras para ese negocio concreto. Tu cliente conecta sus cuentas desde una página de activación con tu marca, así que sus credenciales no pasan por tus manos en ningún momento.",
          explore_how_3_title: "Trabaja solo y tú lo vigilas",
          explore_how_3_desc:
            "El proceso corre sin que nadie lo empuje. En el panel ves qué ha hecho y cuándo, y lo que sale hacia el cliente final lo apruebas tú antes de que se envíe cuando el proceso lo pide.",
          explore_how_4_title: "Lo entregas como servicio de tu agencia",
          explore_how_4_desc:
            "La relación y la factura son tuyas: tu cliente te contrata a ti, no a nosotros. Los informes y el portal que ve tu cliente pueden llevar el logo de tu agencia —en Precios ves desde qué plan—.",
          explore_how_cta: "Ver el catálogo de procesos",
          explore_cta_primary: "Ver qué puedes vender",
          explore_cta_secondary: "Cómo funciona",
          explore_hero_note: "Para agencias, freelances y consultores. Sin registro para mirar.",
          explore_what_title: "Qué es esto exactamente",
          explore_what_desc:
            "Una plataforma SaaS. Entras, eliges un proceso del catálogo, lo configuras para un cliente concreto y lo activas: no programas nada. No es un curso, no es una consultoría y no es una herramienta que le pases para que la use él: es la máquina con la que entregas, seas agencia, freelance o consultor.",
          explore_areas_badge: "Qué vendes",
          explore_areas_title: "Qué vendes, con nombre y apellidos",
          explore_areas_desc:
            "Cinco ejemplos escritos como se los explicas a un cliente. El catálogo manda: lo que está publicado en Servicios es lo que puedes activar.",
          explore_tiers_badge: "Los tramos",
          explore_tiers_title: "Cada tramo lleva lo del anterior, y algo más",
          explore_tiers_desc:
            "No son tres productos distintos: es el mismo, con más cuerda. Lo tachado es lo que ese tramo NO incluye, para que veas dónde está el salto antes de elegir.",
          explore_tiers_not_included: "No incluido",
          explore_tiers_cta: "Ver los precios",
          explore_area_1_title: "Recepcionista de WhatsApp",
          explore_area_1_desc:
            "Atiende el WhatsApp del negocio a cualquier hora, resuelve las preguntas de siempre y reserva la cita. En clínicas, solo la logística de la cita: fecha, hora, confirmación y recordatorio, nunca datos de salud.",
          explore_area_2_title: "Recordatorios de cita",
          explore_area_2_desc:
            "Recuerdan la cita antes de que llegue y recogen la confirmación o el cambio, para que el hueco no se pierda en silencio.",
          explore_area_3_title: "Campañas de reactivación",
          explore_area_3_desc:
            "Vuelven a hablarle a la base de clientes que ya compró una vez, sin sacar la lista a mano.",
          explore_area_4_title: "Informes con tu marca",
          explore_area_4_desc:
            "El informe sale con tu logo y, si conectas el correo de tu empresa, desde tu propia dirección.",
          explore_area_5_title: "Seguimiento comercial 1:1",
          explore_area_5_desc:
            "Cada lead que entra recibe seguimiento en vez de enfriarse en una bandeja, y tú apruebas lo que se envía antes de que salga.",
          explore_area_6_title: "Y el resto del catálogo",
          explore_area_6_desc:
            "Estos son ejemplos. La lista viva, con la ficha de cada proceso, está en Servicios.",
          explore_area_6_cta: "Ver el catálogo completo",
          explore_buy_note:
            "Los procesos de un playbook salen de este mismo catálogo, así que las dos puertas llevan al mismo sitio: puedes empezar por una pieza suelta para un cliente y montar la escalera entera cuando esa funcione.",
          explore_margin_title: "De dónde sale tu dinero",
          explore_margin_step_1:
            "Tú pagas tu plan de plataforma y el consumo de IA de los procesos que tengas funcionando. Ese es tu coste, y está publicado: no hay que pedirlo por email.",
          explore_margin_step_2:
            "A tu cliente le pones el precio que tú decidas por el servicio que le entregas.",
          explore_margin_step_3:
            "Lo que queda entre esas dos cifras es tu margen, y se repite cada mes mientras el proceso siga trabajando, porque lo que vendes no es una entrega que se acaba.",
          explore_margin_note:
            "No ponemos números por ti: el precio del plan está en Precios y el PVP lo fijas tú. Tu cliente contrata contigo: la relación y la factura son tuyas.",
          explore_margin_cta: "Ver el precio del plan",
          explore_nohype_title: "Lo que no vas a encontrar aquí",
          explore_nohype_desc:
            "Ni un porcentaje, ni un logo de cliente, ni un testimonio, ni un «las agencias que usan esto facturan un X% más». No están porque no lo hemos medido, y preferimos que sepas exactamente qué compras: un mecanismo, no una promesa de resultado. Lo que sí puedes comprobar hoy mismo es el producto: abre el catálogo, mira los procesos uno a uno, mira lo que cuesta el plan y decide tú.",
          explore_cta_title: "Si solo tienes veinte segundos",
          explore_cta_desc:
            "Entra al grupo de WhatsApp: un toque, sin formulario, y mañana lo miras con calma. Si prefieres ver producto antes de hablar con nadie, la escalera entera está en Playbooks y los procesos sueltos en Servicios. Si lo tuyo es recomendar, mira la plataforma por dentro o pide una demo.",
          explore_cta_button: "Entrar al grupo de WhatsApp",
          explore_cta_catalog: "Ver el catálogo",
          explore_cta_playbooks: "Ver Playbooks",
          explore_cta_demo: "Pedir una demo",
          explore_cta_signup: "¿Ya lo tienes claro? Date de alta",

          // Agencies Landing
          agencies_page_title: "Atención al cliente, citas y CRM para tus clientes | InvokeApp",
          agencies_badge: "Nueva Plataforma V2.0 Disponible",
          agencies_h1_prefix: "Ofrece",
          agencies_h1_gradient: "atención al cliente, citas y CRM",
          agencies_h1_suffix: "a tus clientes.",
          agencies_subtitle: "Plataforma para agencias que quieren escalar sus servicios tecnológicos sin contratar un costoso equipo de desarrolladores.",
          agencies_cta_primary: "Solicita acceso como agencia",
          agencies_cta_secondary: "Ver Intro (30 seg)",
          agencies_trust_text: "Potenciando a las mejores agencias digitales",
          agencies_brand_1: "360",
          agencies_brand_2: "COMUNICACIÓN",
          agencies_brand_3: "MARKETING",
          agencies_brand_4: "PAID MEDIA",
          agencies_brand_5: "PUBLICIDAD",
          agencies_problem_badge: "El Problema",
          agencies_problem_title: "Las agencias tradicionales se están quedando obsoletas",
          agencies_problem_desc: "Intentar ofrecer servicios de tecnología avanzada sin la infraestructura adecuada es costoso, arriesgado y lento.",
          agencies_problem_1_title: "Márgenes Reducidos",
          agencies_problem_1_desc: "Contratar desarrolladores senior y mantener equipos de ingeniería devora tus beneficios. El costo técnico es insostenible para escalar.",
          agencies_problem_2_title: "Curva de Aprendizaje",
          agencies_problem_2_desc: "Dominar LangChain, APIs de OpenAI, vectores y servidores requiere dedicación exclusiva. Tu equipo de marketing no tiene tiempo.",
          agencies_problem_3_title: "Competencia Veloz",
          agencies_problem_3_desc: "Tus competidores ya están ofreciendo chatbots y automatizaciones. Si tú sigues vendiendo solo horas-hombre, perderás clientes.",
          agencies_paradigm_badge: "El Nuevo Paradigma",
          agencies_paradigm_title: "La atención y las ventas de tus clientes, en una sola plataforma",
          agencies_paradigm_desc: "Transforma tu modelo de negocio. Pasa de vender horas a ofrecer atención al cliente, citas y seguimiento comercial como un servicio recurrente.",
          agencies_paradigm_1_title: "Tu agencia, al frente del cliente",
          agencies_paradigm_1_desc: "Tú mantienes la relación con el cliente y la factura; InvokeApp es el partner tecnológico que hay detrás de tu servicio.",
          agencies_paradigm_2_title: "Sin código, solo configuración",
          agencies_paradigm_2_desc: "Interfaz visual drag-and-drop para crear flujos complejos en minutos.",
          agencies_paradigm_3_title: "Precios publicados",
          agencies_paradigm_3_desc: "El coste de la plataforma está publicado; tú pones el precio de tu servicio y te quedas el margen.",
          agencies_paradigm_4_title: "Despliegue Instantáneo",
          agencies_paradigm_4_desc: "Olvídate de servidores, Docker o configuraciones de entorno. Nuestra nube gestionada se encarga de todo el backend.",
          agencies_card_1: "Configurador de Chatbots",
          agencies_card_2: "Dashboard de Clientes",
          agencies_card_3: "Marketplace de Integraciones",
          agencies_card_4: "Constructor de Flujos",
          agencies_how_title: "Cómo funciona",
          agencies_how_desc: "Tres pasos simples para lanzar tu oferta de tecnología.",
          agencies_step_1_title: "Selecciona",
          agencies_step_1_desc: "Elige entre +50 plantillas pre-construidas de automatización (Lead gen, Soporte, Onboarding) desde nuestra librería.",
          agencies_step_2_title: "Personaliza",
          agencies_step_2_desc: "Añade el logo de tu agencia y adapta cada proceso a las necesidades de tu cliente.",
          agencies_step_3_title: "Monetiza",
          agencies_step_3_desc: "Entrega el acceso a tu cliente y cobra una suscripción mensual recurrente por el mantenimiento y uso del software.",
          agencies_cta_title: "¿Listo para ofrecer más a tus clientes?",
          agencies_cta_desc: "Únete a la lista de espera y obtén acceso anticipado a la plataforma que está cambiando las reglas del juego.",
          agencies_cta_primary_bottom: "Solicita acceso ahora",
          agencies_cta_secondary_bottom: "Hablar con ventas",
          agencies_cta_footnote: "Sin tarjeta de crédito requerida • Plazas limitadas este mes",

          affiliates_page_title: "Afiliados - InvokeApp",
          affiliates_badge: "Gana mientras recomiendas",
          affiliates_h1_prefix: "Gana ",
          affiliates_h1_gradient: "desde 25% por venta",
          affiliates_subtitle: "Únete a nuestro programa de afiliados y gana desde el 25% de comisión por cada cliente que refieras. Simple, transparente y por venta.",
          affiliates_cta_primary: "Hazte Afiliado",
          affiliates_cta_secondary: "Más Información",
          affiliates_benefits_badge: "Por qué unirte",
          affiliates_benefits_title: "El mejor programa de partners en automatización",
          affiliates_benefits_desc: "Gana dinero recomendando InvokeApp a tu red. Sin conocimientos técnicos.",
          affiliates_benefit_1_title: "Desde 25% por Venta",
          affiliates_benefit_1_desc: "Gana desde 25% de comisión por cada cliente que refieras. Pago único por venta realizada.",
          affiliates_benefit_2_title: "Sin Límites",
          affiliates_benefit_2_desc: "Sin topes de ganancia. Cuanto más refieras, más ganas. Escala tus ingresos sin restricciones.",
          affiliates_benefit_3_title: "Dashboard en Tiempo Real",
          affiliates_benefit_3_desc: "Sigue tus referidos, comisiones y pagos en tiempo real desde tu propio panel de afiliado.",
          affiliates_benefit_4_title: "Pagos Rápidos",
          affiliates_benefit_4_desc: "Recibe pagos mensuales sin mínimo requerido. Tus ganancias, tu calendario.",
          affiliates_commission_badge: "Estructura de Comisiones",
          affiliates_commission_title: "Simple, transparente, rentable",
          affiliates_commission_desc: "Sin niveles complicados. Sin condiciones ocultas. Desde 25% comisión en cada venta.",
          affiliates_commission_1: "Desde 25% en todos los planes",
          affiliates_commission_1_sub: "Ya sea Starter, Professional o Enterprise, tú ganas desde 25%.",
          affiliates_commission_2: "Por venta, no por mes",
          affiliates_commission_2_sub: "Ganas una comisión única por cada nuevo cliente que traigas. Sin esperar pagos recurrentes.",
          affiliates_commission_3: "Seguimiento transparente",
          affiliates_commission_3_sub: "Cada conversión se rastrea y atribuye a ti. Visibilidad total en tu dashboard.",
          affiliates_commission_rate: "Comisión por Venta",
          affiliates_commission_note: "Desde 25% en todos los planes, sin excepciones",
          affiliates_how_title: "Cómo funciona",
          affiliates_how_desc: "Tres pasos simples para empezar a ganar con InvokeApp.",
          affiliates_step_1_title: "Regístrate",
          affiliates_step_1_desc: "Crea tu cuenta de afiliado en minutos. Recibe tu enlace único y materiales de marketing.",
          affiliates_step_2_title: "Comparte",
          affiliates_step_2_desc: "Comparte tu enlace de afiliado con tu red, en redes sociales o en tu contenido.",
          affiliates_step_3_title: "Gana",
          affiliates_step_3_desc: "Gana desde 25% de comisión por cada cliente que se registre a través de tu enlace. Pago por venta.",
          affiliates_audience_for_title: "Perfecto para...",
          affiliates_audience_for_1: "Marketers digitales y creadores de contenido con audiencia en el espacio de agencias.",
          affiliates_audience_for_2: "Consultores que recomiendan herramientas de automatización a sus clientes.",
          affiliates_audience_for_3: "Cualquiera con una red de dueños de agencias o negocios.",
          affiliates_audience_not_title: "No es ideal si...",
          affiliates_audience_not_1: "No tienes audiencia o red en el espacio de agencias/marketing.",
          affiliates_audience_not_2: "Buscas un pago único en lugar de ingresos recurrentes.",
          affiliates_audience_not_3: "Prefieres no compartir enlaces o promover productos activamente.",
          affiliates_cta_title: "Hazte afiliado",
          affiliates_cta_desc: "Completa el formulario y te enviaremos todo lo necesario para empezar a ganar.",
          affiliates_cta_button: "Enviar Solicitud",
          affiliates_form_email: "Tu email",
          affiliates_form_name: "Nombre completo",
          affiliates_form_phone: "Teléfono",
          affiliates_form_country: "País",
          affiliates_form_platforms: "¿Dónde promocionarás?",
          affiliates_form_audience: "Tamaño aproximado de audiencia",
          affiliates_form_strategy: "¿Cómo planeas promocionar?",
          affiliates_form_submitting: "Enviando...",
          affiliates_form_success_title: "¡Solicitud enviada!",
          affiliates_form_success_desc: "Revisaremos tu solicitud y te responderemos en un plazo de 48 horas.",
          affiliates_form_policies: "Acepto la política de privacidad y términos de uso.",
          affiliates_form_note: "Sin tarjeta de crédito. Revisaremos y te responderemos.",
          affiliates_login_title: "¿Ya eres afiliado?",
          affiliates_login_desc: "Accede a tu dashboard para ver referidos, comisiones y pagos.",
          affiliates_login_pass: "Contraseña",
          affiliates_login_cta: "Acceder al Dashboard",
          affiliates_tier_badge: "Niveles de Crecimiento",
          affiliates_tier_title: "De afiliado a embajador a élite",
          affiliates_tier_desc: "Cuanto más vendes, mayor es tu comisión. Sube de nivel y gana hasta 35% por venta.",
          affiliates_tier_1: "Afiliado",
          affiliates_tier_1_desc: "Gana desde 25% de comisión por venta. Perfecto para empezar a ganar con tu red.",
          affiliates_tier_2: "Embajador",
          affiliates_tier_2_desc: "Alcanza 10+ conversiones y desbloquea 30% de comisión. Recursos exclusivos y acceso anticipado.",
          affiliates_tier_3: "Élite",
          affiliates_tier_3_desc: "Top performers con 25+ conversiones ganan 35% más oportunidades de co-marketing y soporte dedicado.",
          affiliates_guide_title: "Guía de Afiliado - InvokeApp",
          affiliates_guide_badge: "Recursos y Guía",
          affiliates_guide_h1: "Todo lo que necesitas para triunfar como afiliado",
          affiliates_guide_subtitle: "Aprende cómo promocionar InvokeApp, accede a recursos listos para usar y mantente al día con las últimas mejoras.",
          affiliates_guide_section1_title: "Cómo promocionar InvokeApp",
          affiliates_guide_1_title: "Comparte tu enlace de afiliado",
          affiliates_guide_1_desc: "Usa tu enlace único en emails, redes sociales, blog posts o descripciones de YouTube. Cada clic se rastrea y se te atribuye.",
          affiliates_guide_2_title: "Sigue tu rendimiento",
          affiliates_guide_2_desc: "Accede a tu dashboard para ver clics, conversiones y comisiones en tiempo real. Optimiza tu estrategia.",
          affiliates_guide_3_title: "Crea contenido que convierta",
          affiliates_guide_3_desc: "Usa nuestras guías y presentaciones para crear artículos, comparativas y contenido social que genere registros.",
          affiliates_guide_4_title: "Aprovecha los lead magnets",
          affiliates_guide_4_desc: "Ofrece recursos gratuitos como guías o plantillas para capturar leads y luego promociona InvokeApp como solución.",
          affiliates_guide_updates_title: "Actualizaciones y Novedades",
          affiliates_guide_updates_desc: "Mantente informado sobre nuevas funciones, mejoras y recursos disponibles para afiliados.",
          affiliates_update_1_title: "Nuevo dashboard de afiliado",
          affiliates_update_1_desc: "Estadísticas en tiempo real, mejor seguimiento de referidos e informes detallados de comisiones.",
          affiliates_update_2_title: "Pack de plantillas lead magnet",
          affiliates_update_2_desc: "Nuevo set de presentaciones, checklists y plantillas de email personalizables para generar leads.",
          affiliates_update_3_title: "Comisión desde el 25%",
          affiliates_update_3_desc: "Actualizamos la comisión de afiliados desde el 25% por venta en todos los planes. Sin niveles, sin excepciones.",
          affiliates_guide_resources_title: "Recursos y Lead Magnets",
          affiliates_guide_resources_desc: "Materiales listos para usar y promocionar InvokeApp y capturar leads en tu mercado.",
          affiliates_resource_1_title: "Presentación",
          affiliates_resource_1_desc: "Diapositivas personalizables para presentar InvokeApp a tu audiencia, clientes o red.",
          affiliates_resource_2_title: "Kit Redes Sociales",
          affiliates_resource_2_desc: "Banners, posts e historias listos para compartir en Instagram, LinkedIn, Twitter y Facebook.",
          affiliates_resource_3_title: "Plantillas de Email",
          affiliates_resource_3_desc: "Emails pre-escritos para outreach, seguimientos y promoción de InvokeApp en newsletters.",
          affiliates_resource_4_title: "Kit Lead Magnet",
          affiliates_resource_4_desc: "Guías, checklists y plantillas que puedes ofrecer como descargas gratuitas para construir tu lista de email.",
          dash_page_title: "Dashboard de Afiliado",
          dash_welcome: "Bienvenido de nuevo!",
          dash_earnings: "Ganancias",
          dash_pending: "Pendiente",
          dash_paid: "Pagado",
          dash_active_users: "Usuarios Activos",
          dash_conv_week: "Conversiones/Semana",
          dash_top_kit: "Kit Top",
          dash_top_kit_name: "Real Estate AI",
          dash_tier: "Nivel",
          dash_logout: "Cerrar sesi\u00f3n",
          dash_save: "Guardar",
          dash_ref_email: "Email",
          dash_next_payout: "Pr\u00f3ximo Pago",
          dash_payment_method: "M\u00e9todo de Pago",
          dash_view_demo: "Ver Demo",
          dash_nav_overview: "Resumen",
          dash_nav_kits: "Kits",
          dash_nav_links: "Enlaces",
          dash_nav_resources: "Recursos",
          dash_nav_referrals: "Referidos",
          dash_nav_payouts: "Pagos",
          dash_nav_settings: "Ajustes",
          dash_kits_title: "Kits Promocionables",
          dash_kits_desc: "Comparte estos sistemas IA con tu audiencia y gana comisi\u00f3n por cada venta.",
          dash_links_title: "Enlaces y Campa\u00f1as",
          dash_links_desc: "Genera enlaces de afiliado personalizados con par\u00e1metros UTM.",
          dash_links_generate: "Tu enlace de afiliado",
          dash_links_campaigns: "Campa\u00f1as guardadas",
          dash_resources_title: "Recursos Promocionales",
          dash_resources_desc: "Activos listos para promocionar InvokeApp en tus canales.",
          dash_payouts_title: "Pagos",
          dash_payouts_desc: "Sigue tus ganancias, historial de pagos y pr\u00f3xima fecha de cobro.",
          dash_settings_title: "Ajustes",
          dash_settings_desc: "Gestiona tu cuenta y preferencias de pago.",
          dash_referrals_title: "Referidos Recientes",
          dash_referrals_desc: "Usuarios que se registraron a trav\u00e9s de tu enlace de afiliado.",
          dash_partners: "Socios",
          dash_reseller: "Clientes de partners",
          dash_referrals: "Referidos",
          dash_margin_partner: "Margen",
          dash_partner_search: "Buscar socios...",
          dash_partner_revenue: "Ingresos de Socios",
          dash_partner_activity: "Actividad Reciente",
          dash_see_more: "Ver m\u00e1s",
          dash_part_act_1: "Nuevo socio incorporado",
          dash_part_act_2: "Ascenso de nivel — Plata a Oro",
          dash_part_act_3: "Comisi\u00f3n procesada",
          dash_part_act_4: "Nuevo enlace de referido generado",
          dash_pop_partners_title: "Resumen de Socios",
          dash_pop_partners_desc: "Visualiza todos los socios activos, su nivel y m\u00e9tricas de rendimiento en un solo lugar.",
          dash_pop_partners_detail: "Incluye 48 socios activos en 3 niveles con una retenci\u00f3n del 94%.",
          dash_pop_reseller_title: "Ingresos de clientes de partners",
          dash_pop_reseller_desc: "Seguimiento de los ingresos de los clientes que atienden tus partners, valor recurrente mensual y tendencias de crecimiento.",
          dash_pop_reseller_detail: "$340K total con un crecimiento del 22% mes a mes en todas las cuentas.",
          dash_pop_referrals_title: "Referidos",
          dash_pop_referrals_desc: "Monitorea el tr\u00e1fico de referidos, tasas de conversi\u00f3n y fuentes principales.",
          dash_pop_referrals_detail: "156 referidos este trimestre con una tasa de conversi\u00f3n del 18%.",
          dash_pop_marginp_title: "Margen de Socio",
          dash_pop_marginp_desc: "Analiza la distribuci\u00f3n del margen por niveles e identifica oportunidades de optimizaci\u00f3n.",
          dash_pop_marginp_detail: "Margen promedio del 42%, con socios top alcanzando hasta el 58%.",
          dash_pop_partchart_title: "Gr\u00e1fico de Ingresos",
          dash_pop_partchart_desc: "Visualiza las tendencias de ingresos de socios con proyecciones de crecimiento.",
          dash_pop_partchart_detail: "Proyectado a alcanzar $420K ARR para fin de trimestre.",
          dash_pop_partactivity_title: "Panel de Actividad",
          dash_pop_partactivity_desc: "Feed en tiempo real de acciones de socios, eventos del sistema y notificaciones.",
          dash_pop_partactivity_detail: "12 nuevas actividades en las \u00faltimas 24 horas, incluyendo 3 ascensos de nivel.",
          dash_clients: "Clientes",
          dash_workflows: "Flujos",
          dash_success: "Tasa de \u00c9xito",
          dash_margin: "Margen",
          dash_search: "Buscar...",
          dash_info_current: "Actual",
          dash_activity_title: "Actividad Reciente",
          dash_act_1: "Nueva automatizaci\u00f3n desplegada",
          dash_act_2: "Onboarding de cliente completado",
          dash_act_3: "Informe mensual generado",
          dash_act_4: "Integraci\u00f3n exitosa",
          dash_pop_clients_title: "Resumen de Clientes",
          dash_pop_clients_desc: "Visualiza todos los clientes activos, su estado de onboarding y m\u00e9tricas de participaci\u00f3n.",
          dash_pop_clients_detail: "128 clientes activos con una tasa de \u00e9xito del 97.8% y crecimiento del 12% mes a mes.",
          dash_pop_workflows_title: "Flujos de Trabajo",
          dash_pop_workflows_desc: "Monitorea flujos automatizados, estado de ejecuci\u00f3n y anal\u00edticas de rendimiento.",
          dash_pop_workflows_detail: "1.4K flujos ejecutados este mes con un tiempo promedio de 3.2 minutos.",
          dash_pop_success_title: "Tasa de \u00c9xito",
          dash_pop_success_desc: "Seguimiento de m\u00e9tricas de \u00e9xito del cliente, puntuaciones de satisfacci\u00f3n y logros.",
          dash_pop_success_detail: "97.8% de tasa de \u00e9xito general, con flujos top alcanzando el 99.2%.",
          dash_pop_margin_title: "An\u00e1lisis de Margen",
          dash_pop_margin_desc: "Analiza los m\u00e1rgenes por servicios, clientes y categor\u00edas de flujo.",
          dash_pop_margin_detail: "Margen promedio del 34%, con clientes de alto valor alcanzando hasta el 52%.",
          dash_pop_bar_title: "Gr\u00e1fico de Ingresos",
          dash_pop_bar_desc: "Visualiza tendencias de ingresos, comparativas mensuales y proyecciones de crecimiento.",
          dash_pop_bar_detail: "MRR actual de $8.8K con un aumento proyectado del 12% el pr\u00f3ximo trimestre.",
          dash_pop_activity_title: "Panel de Actividad",
          dash_pop_activity_desc: "Feed en tiempo real de eventos del sistema, acciones de clientes y notificaciones.",
          dash_pop_activity_detail: "8 nuevas actividades en la \u00faltima hora, incluyendo 2 flujos completados.",
        },
      },


    }



    // // language resources
    // resources: {
    //   en: {
    //     translation: {
    //       navbar_home: "Home",
    //       navbar_about_us: "About Us",
    //       navbar_services: "Solutions",
    //       navbar_portfolio: "Functionalities",
    //       navbar_resources: "Resources",
    //       navbar_blog: "Blog",
    //       contact_us: "Let's Talk",
    //       cookies_text: "We use cookies to enhance your experience on our website. By continuing to browse this site, you agree to our use of cookies. These cookies allow us to offer you a personalized experience, display relevant advertising, and obtain usage statistics of the site. For more information on the use of cookies and how to manage them, please see our Cookie Policy. By clicking 'Accept All', you consent to the use of all cookies.",
    //       cookies_button: "Accept All",
    
    //       page_title_about_us: "Empowering Creators",
    //       page_title_services: "Smart Solutions",
    //       page_title_portfolio: "Our Skills",
    //       page_title_resources: "Your Toolkit",
    //       page_title_blog: "Latest Insights",
    //       page_title_blog_details: "Insight Details",
    //       page_title_policies: "Policies",
    //       page_title_contact_us: "Reach Out",
    
    //       home_slider_title_superior_one: "Boost Your Efficiency",
    //       home_slider_title_superior_two: "Seamless Solutions for Infopreneurs",
    //       home_slider_title_main_copy_one1: "Harness the power of integration ",
    //       home_slider_title_main_copy_one2: "to streamline your digital world",
    //       home_slider_title_main_copy_two1: "Leverage automation for ",
    //       home_slider_title_main_copy_two2: "efficiency, speed, and scalability",


    //       core_coreprelaunch_title_mini: "core.invokeapp",
    //       core_coreprelaunch_title_slogan: "ERP for visionaries",
    //       core_coreprelaunch_description: "Sign up for the pre-launch and be one of the privileged to launch your business as an early adopter!",
    //       core_coreprelaunch_button_text: "Join up",
    //       core_coreprelaunch_title_more_info: "Information",
    //       core_coreprelaunch_description1_more_info: "Our ERP system revolutionizes enterprise management by integrating with key third-party platforms, allowing for seamless automation and data synchronization. It features robust modules for analytics, financial control, and company management, including employee onboarding and role assignment. A dedicated learning center supports entrepreneurial growth with essential resources. With powerful automation capabilities, the system significantly reduces manual work, enhancing efficiency and providing comprehensive insights for strategic decision-making. This all-encompassing tool offers businesses a powerful, tentacular solution to navigate and thrive in the competitive market landscape.",
    //       core_coreprelaunch_description2_more_info: "Join our team and elevate your project with our advanced ERP system. Harness the power of seamless integrations and strategic automation to transform your business operations and achieve new heights of success.",
    //       core_coreprelaunch_button_more_information: "More Information?",
          


    //       home_two_features_title_superior_mini: "Unique Solutions",
    //       home_two_features_title_one: "Transform ",
    //       home_two_features_title_two: "your business",
    //       home_two_features_subtitle: "Explore new horizons with automations that unleash your potential. Dive into a world where every second counts and every lead is a golden opportunity.",
    //       home_two_features_button_text: "Join the pre-launch",
    //       home_two_features_card_title_one: "Time Maximization",
    //       home_two_features_card_description_one: "Reinvent time management with automations that simplify tasks and give you back valuable hours.",
    //       home_two_features_card_title_two: "Operational Efficiency",
    //       home_two_features_card_description_two: "Optimize every process and reduce costs, transforming your operation into a model of efficiency and sustainability.",
    //       home_two_features_card_title_three: "Customer Retention",
    //       home_two_features_card_description_three: "Strengthen ties with your customers through meaningful and personalized interactions, powered by AI.",
    //       home_two_features_card_title_four: "Lead Conversion",
    //       home_two_features_card_description_four: "Maximize your sales funnel with automatic follow-up strategies that convert more leads into satisfied customers.",
        

    //       home_about_title_mini: "Our Essence",
    //       home_about_title_big: "Simplifying Your Success",
    //       home_about_subtitle: "Dive into a world where technology serves creativity. At Invoke App, we specialize in crafting seamless integrations and automations that empower your digital presence and optimize your workflow.",
    //       home_about_caption_one: "Effortless Integrations",
    //       home_about_caption_two: "Automation Mastery",
    //       home_about_caption_three: "Creative Freedom",
    //       home_about_discover_services: "Explore Possibilities",
    
    //       home_capabilities_title_mini: "Our Vision",
    //       home_capabilities_title_big: "Bridging Gaps with Tech",
    //       home_capabilities_subtitle: "From the spark of an idea to execution, we focus on delivering solutions that not only work but work wonders for you. Discover how our expertise in integration and automation can transform your business.",
    //       home_capabilities_caption_one: "- Idea to Execution",
    //       home_capabilities_caption_two: "- Design to Launch",
    //       home_capabilities_caption_three: "- Testing to Triumph",
    
    //       home_services_title_mini: "Transformations",
    //       home_services_title_big: "Elevate Your Workflow",
    //       home_services_title_mobileapps: "Integrated Platforms",
    //       home_services_subtitle_mobileapps: "Craft solutions that connect your content to your audience, with seamless app experiences.",
    //       home_services_title_backend: "Automated Systems",
    //       home_services_subtitle_backend: "Ensure your backend is as smart as your ideas, with systems that talk to each other and automate your processes.",
    //       home_services_title_consulting: "Strategic Insights",
    //       home_services_subtitle_consulting: "Get ahead with our consultancy, focusing on automation and integration strategies that scale.",
    //       home_services_title_database: "Data at Your Fingertips",
    //       home_services_subtitle_database: "Organize, access, and utilize your data with systems designed for efficiency.",
    //       home_services_title_analytics: "Insights into Action",
    //       home_services_subtitle_analytics: "Turn data into decisions with analytics that highlight opportunities for automation and efficiency.",
    //       home_services_title_uiuxdesign: "Engaging Experiences",
    //       home_services_subtitle_uiuxdesign: "Design that understands your user's journey, optimized for interaction and conversion.",
    //       home_services_title_webapps: "Seamless Web Apps",
    //       home_services_subtitle_webapps: "Web applications that are powerful yet intuitive, bridging your services with your audience.",
    //       home_services_title_saas: "SaaS Integration",
    //       home_services_subtitle_saas: "Extend your service's reach and capabilities with integrations that bring your tools together.",
    
    //       home_contact_area_title_mini: "Let's Innovate",
    //       home_contact_area_title_big: "Questions? Ideas? Collaborate with Us",
    
    //       home_brands_customers_title_mini: "Partners in Success",
    //       home_brands_customers_title_big: "Empowering 100+ platforms",
    //       home_brands_customers_subtitle: "Your vision, our technology. Together, we create digital experiences that make a difference.",
    
    //       home_contact_title: "Connect with Us",
    //       home_contact_address: "Where Ideas Meet Solutions",
    //       home_contact_email: "Talk to Us",
    
    //       home_footer_title_company: "Navigate",
    //       home_footer_company_about_us: "Discover",
    //       home_footer_company_services: "Solutions",
    //       home_footer_company_consulting: "Insights",
    //       home_footer_company_blog: "Blog",
    //       home_footer_company_policies:"Policies",
    //       home_footer_company_contactus: "Connect",
    //       home_footer_title_resources: "Toolkit",
    //       home_footer_resources_customers: "Case Studies",
    //       home_footer_resources_pricing: "Value",
    //       home_footer_resources_news: "Updates",
    //       home_footer_resources_support: "Support",
    //       home_footer_title_usecases: "How-To",
    //       home_footer_usecases_uiuxdesign: "Design Thinking",
    //       home_footer_usecases_mobileapp: "App Integration",
    //       home_footer_usecases_apiintegration: "API Magic",
    //       home_footer_usecases_database: "Data Dynamics",
    //       home_footer_usecases_software: "Software Synergy",
    //       home_footer_usecases_analytics: "Analytics Insights",
    //       home_footer_title_information: "Learn More",



    //       about_us_two_faq_title_mini: "Insights",
    //       about_us_two_faq_title_big_one: "Tech Expertise",
    //       about_us_two_faq_title_big_two: "for Seamless Integration",
    //       about_us_two_faq_function_one_title: "Simplifying Complex Concepts",
    //       about_us_two_faq_function_one_content: "Making intricate tech concepts accessible, because innovation thrives on simplicity.",
    //       about_us_two_faq_function_two_title: "Boosted Digital Performance",
    //       about_us_two_faq_function_two_content: "Optimizing digital platforms for peak performance, ensuring speed, efficiency, and satisfaction.",
    //       about_us_two_faq_function_three_title: "Integrated Solutions",
    //       about_us_two_faq_function_three_content: "Connecting systems and tools effortlessly to enhance efficiency and teamwork, propelling your projects forward.",
        
    //       about_us_two_achievement_title_mini: "Achievements",
    //       about_us_two_achievement_title_big: "Championing Technical Excellence",
    //       about_us_two_achievement_subtitle: "Drive innovation and excellence with us. Elevating projects and client satisfaction to new heights.",
    //       about_us_two_achievement_function_one: "Seamless Integrations",
    //       about_us_two_achievement_function_two: "Cutting-edge Mobile App Solutions",
    //       about_us_two_achievement_discover_more: "Explore More",
        
    //       services_three_second_services_title: "Our Expertise",
    //       services_three_second_services_subtitle: "Guiding you through today's challenges with our top-tier team.",
        
    //       services_three_second_services_section_one_title_superior: "Mobile Apps",
    //       services_three_second_services_section_one_title: "Mobile Apps",
    //       services_three_second_services_section_one_subtitle: "Turning ideas into engaging, user-focused mobile apps. Delivering standout experiences across iOS and Android, blending functionality with beauty.",
    //       services_three_second_services_section_one_power_phrase: "Crafting Immersive App Journeys",
        
    //       services_three_second_services_section_two_title_superior: "Backend & Integrations",
    //       services_three_second_services_section_two_title: "Backend & Integrations",
    //       services_three_second_services_section_two_subtitle: "Developing strong, scalable backends. Mastering data, user interactions, and smooth third-party service integrations for a comprehensive experience.",
    //       services_three_second_services_section_two_power_phrase: "Designing Unified Backend Ecosystems",
        
    //       services_three_second_services_section_three_title_superior: "Tech Consulting",
    //       services_three_second_services_section_three_title: "Tech Consulting",
    //       services_three_second_services_section_three_subtitle: "Navigating the tech landscape with strategic insights and tailored advice to enhance your tech infrastructure and strategies for a digital age.",
    //       services_three_second_services_section_three_power_phrase: "Empowering Strategies with Tech Insight",
        
    //       services_three_second_services_section_four_title_superior: "Design UI/UX",
    //       services_three_second_services_section_four_title: "Design UI/UX",
    //       services_three_second_services_section_four_subtitle: "Elevating online presence with creative, user-centric design. Our UI/UX solutions promise seamless navigation, aesthetic appeal, and unmatched user satisfaction.",
    //       services_three_second_services_section_four_power_phrase: "Creating Compelling Digital Narratives",
        
    //       services_three_second_services_get_started_button: "Get Started",

          
    //       resources_download_ebook_section_title_mini:"Free ebook",
    //       resources_download_ebook_section_title:"Download our eBook on automations",
    //       resources_download_ebook_section_title_story_one:"In this EBook you will find valuable information about the four packages we offer. Experiment, create and automate processes.",
    //       resources_download_ebook_section_title_story_one_author:"Max Innovator",
    //       resources_download_ebook_section_title_story_one_position:"Chief Experiment Officer (CEO of Ideas)",
    //       resources_download_ebook_section_title_story_two:"You can create strategies with our downloadable resource, catch up on what your competitors are applying and leave the work to the machines.",
    //       resources_download_ebook_section_title_story_two_author:"Alex Murphy a.k.a. RoboCop",
    //       resources_download_ebook_section_title_story_two_position:"Director of Automated Strategy Enforcement",
    //       resources_download_ebook_section_download_history:"Enter your email and you will receive an email with our free EBook on how to automate your business and spend time on what is really important.",
    //       resources_download_ebook_section_language_ebook:"EBook Language",
    //       resources_download_ebook_section_boton_download:"Download",


    //       blog_newsletter_title: "Newsletter",
    //       blog_newsletter_subtitle: "Subscribe to our newsletter today to receive updates on the latest trends in integration and automation.",
    //       blog_newsletter_newsletter_language: "Newsletter language",
    //       blog_newsletter_policy_one: "I accept the",
    //       blog_newsletter_policy_two: " Privacy Policy",
    //       blog_newsletter_email_adress_input: "Email Address",
    //       blog_newsletter_subscribe_button: "Subscribe",
        
    //       blog_recent_news_title: "Recent News",
    //       blog_categories_title: "Categories",
    //       blog_recent_comments_title: "Recent Comments",
    //       blog_recent_comments_empty_title: "There are no comments",
    //       blog_recent_comments_empty_subtitle: "Be the first to leave one!",
    //       blog_read_more_card: "Read More",
    //       blog_comments_card: "Comments",
        
    //       blog_comments_reply: "Leave a Reply",
    //       blog_comments_email_not_published: "Your email address will not be published",
    //       blog_comments_consent: "By accepting the policy I consent to my name and email being stored and used to send me updates and news.",
        
    //       blog_details_article_category: "Category:",
    //       blog_details_article_share: "Share:",
    //       blog_details_article_author: "Author",
    //       blog_details_article_last_comments: "Last comments:",
        
    //       generic_your_message: "Your message...",
    //       generic_your_name: "Your Name",
    //       generic_your_email: "Your Email",
    //       generic_send_message: "Send Message",
        
    //       generic_newsletter_toast_error_politics: "You must accept the privacy policy to subscribe.",
    //       generic_newsletter_toast_error_select_language: "Please select a language.",
    //       generic_toast_success_send_message: "Message sent successfully",
    //       generic_toast_success_send_message_moderation: "Your message has been successfully submitted. It will be reviewed by our moderators before being published. Thank you for your contribution!",
    //       generic_toast_error_notsend_message: "Could not send the message",



    //       // POLICIES
    //       newsletter_policies_title_footer: "Newsletter Policies",
    //       policies_title_mini_newsletter: "Terms and conditions",
    //       policies_newsletter_title: "Newsletter Policies",
    //       policies_newsletter_title_one: "Newsletter Subscription Policy",
    //       policies_newsletter_description_one: "By subscribing to our newsletter, you agree to receive periodic communications from us, which may include news, updates, promotions, and exclusive content related to Invoke App. We are committed to using your personal information (such as your email address) exclusively for these purposes and in accordance with our Privacy Policy.",
    //       policies_newsletter_title_two: "Collection of Information",
    //       policies_newsletter_description_two: "To subscribe to our newsletter, we only require your email address. Additional information may be requested to personalize your experience, but providing such information is entirely voluntary.",
    //       policies_newsletter_title_three: "Use of Information",
    //       policies_newsletter_description_three: "The information you provide is used to send you our newsletters and related communications. We will not share your personal information with third parties without your explicit consent, except as necessary for the email service or as required by law.",
    //       policies_newsletter_title_four: "Opt-Out Right",
    //       policies_newsletter_description_four: "You have the right to unsubscribe from our newsletter at any time. Each email sent will include a link at the bottom to `unsubscribe,` allowing you to cancel your subscription easily and automatically.",
    //       policies_newsletter_title_five: "Policy Updates",
    //       policies_newsletter_description_five: "We reserve the right to modify this subscription policy at any time. Updates will be effective immediately upon posting on our website. By continuing to use our newsletter service after such updates, you agree to the modifications.",
    //       policies_newsletter_title_six: "Contact",
    //       policies_newsletter_description_six: "If you have questions or concerns about our subscription policy, please contact us through",

    //       ebook_download_policies_title_footer: "EBook Download Policies",
    //       policies_title_mini_ebook: "Terms and conditions",
    //       policies_ebook_download_title: "EBook Download Policies",
    //       policies_ebook_download_title_one: "EBook Download Policy",
    //       policies_ebook_download_description_one: "By downloading our eBook, you consent to provide us with your email address and agree to receive periodic communications from Invoke App. These communications may include updates, news, and exclusive content relevant to our offerings. Your personal information will be handled in accordance with our Privacy Policy, ensuring its use solely for the purposes mentioned.",
    //       policies_ebook_download_title_two: "Information Collection",
    //       policies_ebook_download_description_two: "To download our eBook, we require your email address. While we may request additional information to tailor your experience, the provision of such details is completely optional.",
    //       policies_ebook_download_title_three: "Use of Information",
    //       policies_ebook_download_description_three: "The information collected will be used to facilitate your eBook download and to send you related communications. We pledge not to share your personal data with third parties without your explicit permission, except as needed for service provision or as mandated by law.",
    //       policies_ebook_download_title_four: "Opt-Out Right",
    //       policies_ebook_download_description_four: "You reserve the right to opt out of receiving our communications at any time. Each communication will include an `unsubscribe` link, allowing you to cease subscription effortlessly.",
    //       policies_ebook_download_title_five: "Policy Modifications",
    //       policies_ebook_download_description_five: "We retain the right to alter these eBook download policies at our discretion. Changes become effective immediately upon their publication on our site. Your continued engagement with our eBook downloads signifies your acceptance of these changes.",
    //       policies_ebook_download_title_six: "Inquiries",
    //       policies_ebook_download_description_six: "Should you have any questions or concerns regarding our eBook download policies, please feel free to reach out to us through",
        
    //       contact_policies_title_footer: "Contact Policies",
    //       policies_title_mini_contact: "Terms and Conditions",
    //       policies_contact_title: "Contact Policies",
    //       policies_contact_title_one: "Information Collection for Contact",
    //       policies_contact_description_one: "When you contact us via email or through our website, we collect your email address and any other information you choose to provide. This information is used to respond to your inquiries and provide support or information related to our services.",
    //       policies_contact_title_two: "Use of Contact Information",
    //       policies_contact_description_two: "Your contact information, primarily your email address, will be used to communicate with you in response to your inquiries. We may also use this information to send you updates or information about our services if you have consented to receive such communications.",
    //       policies_contact_title_three: "Protection of Your Information",
    //       policies_contact_description_three: "We are committed to protecting the information you share with us. Your contact information will be stored securely and will not be shared with third parties without your explicit consent, except as necessary to provide you with the services requested or as required by law.",
    //       policies_contact_title_four: "Opting Out",
    //       policies_contact_description_four: "You have the right to opt out of receiving communications from us at any time. You can do this by using the unsubscribe link provided in our emails or by contacting us directly to request removal from our contact list.",
    //       policies_contact_title_five: "Policy Updates",
    //       policies_contact_description_five: "We reserve the right to update these contact policies at any time. Changes will take effect immediately upon their posting on our website. Continuing to contact us following such changes constitutes your acceptance of the new terms.",
    //       policies_contact_title_six: "Contact Us",
    //       policies_contact_description_six: "If you have any questions or concerns about our contact policies, please do not hesitate to reach out to us through",
        
    //       comment_policies_title_footer: "Comment Policies",
    //       policies_title_mini_comment: "Terms and Conditions",
    //       policies_comment_title: "Comment Policies",
    //       policies_comment_title_one: "Comment Posting Rules",
    //       policies_comment_description_one: "We welcome and encourage comments on our blog posts. However, all comments must comply with our community standards, including respect for others, no hate speech, and no promotion of illegal activities. We reserve the right to remove any comments that violate these standards.",
    //       policies_comment_title_two: "Use of Personal Information",
    //       policies_comment_description_two: "To post a comment, you will be required to provide your email address. This information is used to manage comments and prevent abuse. Your email address will not be displayed publicly or used for any purposes other than comment management, without your explicit consent.",
    //       policies_comment_title_three: "Moderation and Approval",
    //       policies_comment_description_three: "All comments are subject to moderation. We aim to review and approve comments promptly, but there may be delays. We reserve the right to edit or not publish any comment for any reason, in accordance with our standards.",
    //       policies_comment_title_four: "Rights to Comments",
    //       policies_comment_description_four: "By posting a comment, you grant us a perpetual, worldwide, non-exclusive, royalty-free license to use, reproduce, modify, publish, translate, create derivative works from, distribute, and display such comments in any media.",
    //       policies_comment_title_five: "Policy Updates",
    //       policies_comment_description_five: "We reserve the right to modify these comment policies at any time. Changes will be effective immediately upon posting on our website. By continuing to post comments after such changes, you agree to the new policies.",
    //       policies_comment_title_six: "Contact",
    //       policies_comment_description_six: "If you have questions or concerns about our comment policies, please contact us through",
        
    //       cookies_policies_title_footer: "Cookie Policies",
    //       cookies_policies_title_mini: "Terms & Conditions",
    //       cookies_policies_title: "Cookie Policies",
    //       cookies_policy_title_one: "Introduction",
    //       cookies_policy_description_one: "By visiting our website, you agree to our use of cookies to enhance your browsing experience. Cookies allow us to personalize content, offer social media features, and analyze our traffic.",
    //       cookies_policy_title_two: "Information Collection",
    //       cookies_policy_description_two: "We use cookies that are essential for the operation of the site, as well as analytics cookies that help us understand how you interact with the site.",
    //       cookies_policy_title_three: "Use of Information",
    //       cookies_policy_description_three: "Information collected through cookies is used to personalize your experience and deliver relevant advertising. It is also used to improve our website and services.",
    //       cookies_policy_title_four: "Managing Cookies",
    //       cookies_policy_description_four: "You can manage your cookie preferences at any time by adjusting your browser settings. Please be aware that changing these settings may affect your experience on the site.",
    //       cookies_policy_title_five: "Consent",
    //       cookies_policy_description_five: "By using our site, you consent to the use of cookies in accordance with this policy. If you choose not to accept our cookies, some parts of the site may not function as expected.",
    //       cookies_policy_title_six: "Contact",
    //       cookies_policy_description_six: "If you have questions about our cookie policy, please feel free to contact us at letstalk@invokeapp.io",
          

    //       investors_page_commercial_dossier_download: "Download Dossier",
    //       investors_page_commercial_dossier_title: "Commercial Dossier",
    //       investors_page_commercial_dossier_description: "The ERP for the one-person billion-dollar business.\n\n" +
    //             "InvokeApp is a modular ERP built for the future of entrepreneurship: fast-moving, automated, and AI-powered. " +
    //             "We’re addressing the growing need for lean, scalable operations among solopreneurs, small teams, and digital agencies.\n\n" +
    //             "Our platform integrates key business functions (marketing, finance, HR, inventory, CRM) with plug-and-play automations and AI workflows — removing the technical barriers that slow down adoption in the SME segment.\n\n" +
    //             "- Freemium SaaS model with Premium+ tiers\n" +
    //             "- Proprietary integration framework (independent from Zapier/Make)\n" +
    //             "- AI-ready architecture with real-time analytics and gamified training\n" +
    //             "- MVP 90% complete — ready to go to market in Q3 2025\n\n" +
    //             "We’re raising capital to scale our go-to-market, finalize the payment system, and accelerate user acquisition through embedded automation workflows.",
          
    //       investors_page_investor_deck_download: "Download Deck",
    //       investors_page_investor_deck_title: "Investor Deck",
    //       investors_page_investor_deck_description: "Unlock the full potential of your business operations.\n\n" +
    //             "InvokeApp is an all-in-one ERP platform designed for digital entrepreneurs, small agencies, and growing startups. " +
    //             "Our modular system combines automation, real-time insights, and guided workflows to help you save time, reduce costs, and scale with confidence.\n\n" +
    //             "Whether you manage marketing, sales, HR, or finances, InvokeApp adapts to your business and empowers your team with smart integrations and no-code tools — all in a single, intuitive dashboard.\n\n" +
    //             "✓ Streamline processes\n" +
    //             "✓ Centralize your tools\n" +
    //             "✓ Automate without technical barriers\n\n" +
    //             "Start with our freemium model and unlock premium features as you grow."
            





    //     }
    //   },
    //   es: {
    //     translation: {
    //       navbar_home: "Inicio",
    //       navbar_about_us: "Nosotros",
    //       navbar_services: "Servicios",
    //       navbar_portfolio: "Funcionalidades",
    //       navbar_resources: "Recursos",
    //       navbar_blog: "Blog",
    //       contact_us: "Hablemos",
    //       cookies_text: "Utilizamos cookies para mejorar tu experiencia en nuestra página. Al continuar navegando en este sitio, aceptas nuestro uso de cookies. Estas cookies nos permiten ofrecerte una experiencia personalizada, mostrar publicidad relevante y obtener estadísticas de uso del sitio. Para más información sobre el uso de cookies y cómo gestionarlas, consulta nuestra Política de Cookies. Al hacer clic en 'Aceptar todas', consientes el uso de todas las cookies.",
    //       cookies_button: "Aceptar todas",

    
    //       page_title_about_us: "Nosotros",
    //       page_title_services: "Servicios",
    //       page_title_portfolio: "Funcionalidades",
    //       page_title_resources: "Recursos",
    //       page_title_blog: "Blog",
    //       page_title_blog_details: "Detalles del Artículo",
    //       page_title_policies: "Políticas",
    //       page_title_contact_us: "Contáctanos",
    






    //       home_slider_title_superior_one: "Impulsamos tu agencia",
    //       home_slider_title_superior_two: "Soluciones integrales para agencias digitales",
    //       home_slider_title_main_copy_one1: "Pisa el acelerador de tu agencia digital",
    //       home_slider_title_main_copy_one2: "y simplifica tu mundo digital",
    //       home_slider_title_main_copy_two1: "Da el paso y transforma tu agencia con GenAI y workflows",
    //       home_slider_title_main_copy_two2: "eficiencia, velocidad y escalabilidad",
    
    //       core_coreprelaunch_title_mini: "core.invokeapp",
    //       core_coreprelaunch_title_slogan: "De emprendedor a visionario",
    //       core_coreprelaunch_description: "¡Regístrate para el lanzamiento previo y se uno de los privilegiados en lanzar tu agencia a la estratosfera!",
    //       core_coreprelaunch_button_text: "Únete",
    //       core_coreprelaunch_title_more_info: "Información",
    //       core_coreprelaunch_description1_more_info: "Nuestra plataforma está diseñada pensando en las agencias digitales que buscan llevar sus negocios al siguiente nivel. Ofrecemos potentes workflows con agentes de inteligencia artificial, que ayudarán a automatizar tareas, tomar mejores decisiones y ahorrar tiempo. Imagina contar con una plataforma que te simplifica la gestión de tu negocio, desde las finanzas hasta la atención al cliente, y que además aprende y se adapta contigo. Queremos que te enfoques en lo que realmente importa: hacer crecer tu agencia, mientras nosotros te damos todo lo que necesitas para que sea más rápido, eficiente y exitoso.",
    //       core_coreprelaunch_description2_more_info: "Únase a nuestro equipo y eleve su proyecto con nuestro avanzado sistema ERP. Aproveche el poder de las integraciones sin inconvenientes y la automatización estratégica para transformar sus operaciones comerciales y alcanzar nuevas cotas de éxito.",
    //       core_coreprelaunch_button_more_information: "¿Más información?",
          

    //       home_faqs_questions_title_superior_1 : "Llevamos tu proyecto a ",
    //       home_faqs_questions_title_superior_2 : " donde tu visión guíe",
    //       home_faqs_questions_title_inferior_1 : "Impulsa tu negocio con nuestros workflows y automatizaciones diseñadas para transformar ideas en resultados.",
    //       home_faqs_questions_title_inferior_2 : "Juntos simplificaremos procesos, aumentaremos tu productividad y te ayudaremos a alcanzar el éxito que tu proyecto merece.",
    //       home_faqs_questions_button : "Descubre más",
    //       home_faqs_questions_tileline_title_1 : "¿Cómo vamos a impulsar el crecimiento de tu negocio?",
    //       home_faqs_questions_tileline_subtitle_1 : "Conectaremos las herramientas que ya utilizas, automatizaremos tus procesos clave y te proporcionaremos datos en tiempo real para que tomes decisiones estratégicas y lleves tu negocio al siguiente nivel.",
    //       home_faqs_questions_tileline_title_2 : "¿Qué beneficios obtendrás al automatizar tus procesos?",
    //       home_faqs_questions_tileline_subtitle_2 : "Ahorrarás tiempo, eliminarás errores humanos y te centrarás en lo que realmente importa: hacer crecer tu negocio con mayor precisión y agilidad.",
    //       home_faqs_questions_tileline_title_3 : "¿Nuestro ERP se adapta a las necesidades de tu proyecto?",
    //       home_faqs_questions_tileline_subtitle_3 : "Por supuesto. Diseñamos soluciones flexibles y personalizables que evolucionan contigo, sin importar si estás comenzando o escalando tu empresa.",
    //       home_faqs_questions_tileline_title_4 : "¿Cómo te acompañaremos en tu aprendizaje como emprendedor?",
    //       home_faqs_questions_tileline_subtitle_4 : "Nuestro Learning Center está diseñado para cada etapa del ciclo de vida de tu empresa. Desde tus primeros pasos hasta la expansión, accederás a conocimientos clave en tecnología, finanzas, marketing y más. Te brindamos las herramientas necesarias para que tomes decisiones informadas y lleves tu proyecto al éxito.",
    //       home_faqs_questions_tileline_title_5 : "¿Cómo te beneficiarás de la gamificación en tu negocio?",
    //       home_faqs_questions_tileline_subtitle_5 : "Transformaremos tus objetivos en logros motivadores. Con nuestra gamificación, cada paso que des hacia el crecimiento de tu negocio se convertirá en una meta alcanzada, fomentando la productividad y el compromiso de tu equipo. ¡Hacer crecer tu empresa será más emocionante que nunca!",



    //       home_two_features_title_superior_mini: "La plataforma de los visionarios",
    //       home_two_features_title_one: "Tu proyecto ",
    //       home_two_features_title_two: "despegando",
    //       home_two_features_subtitle: "Explora nuevos horizontes con automatizaciones que liberan tu potencial. Sumérgete en un mundo donde dejas de tomar decisiones basadas en la intuición.",
    //       home_two_features_button_text: "Únete al Prelanzamiento",
    //       home_two_features_card_title_one: "Herramientas en las que delegar tu proyecto",
    //       home_two_features_card_description_one: "Automatiza y optimiza tu negocio con soluciones diseñadas para devolverte lo más valioso: tu tiempo.",
    //       home_two_features_card_title_two: "Centro de aprendizaje para que apliques los mejores conocimientos",
    //       home_two_features_card_description_two: "Descubre recursos prácticos y estrategias efectivas para llevar tu emprendimiento al siguiente nivel.",
    //       home_two_features_card_title_three: "Decisiones basadas en datos",
    //       home_two_features_card_description_three: "Empodera tus estrategias con insights precisos que convierten datos en oportunidades de crecimiento.",
    //       home_two_features_card_title_four: "Plataforma gamificada",
    //       home_two_features_card_description_four: "Haz que cada meta sea un logro emocionante mientras alcanzas tus objetivos de negocio con motivación y diversión.",
    

    //       home_about_title_mini: "Nuestra Esencia",
    //       home_about_title_big: "Simplificando Tu Éxito",
    //       home_about_subtitle: "Sumérgete en un mundo donde la tecnología sirve a la creatividad. En invokeapp, nos especializamos en crear integraciones y automatizaciones fluidas que potencian tu presencia digital y optimizan tu flujo de trabajo.",
    //       home_about_caption_one: "Integraciones Sin Esfuerzo",
    //       home_about_caption_two: "Maestría en Automatización",
    //       home_about_caption_three: "Libertad Creativa",
    //       home_about_discover_services: "Explora las Posibilidades",
    
          
    //       home_capabilities_title_mini: "Nuestra Visión",
    //       home_capabilities_title_big: "Transforma tu Negocio con Tecnología",
    //       home_capabilities_subtitle: "Desde esa chispa de inspiración hasta resultados increíbles, hacemos que la tecnología trabaje para ti. Con nuestras soluciones inteligentes de integración y automatización, llevarás tu negocio al siguiente nivel sin complicaciones.",
    //       home_capabilities_caption_one: "- Delega y automatiza como nunca antes",
    //       home_capabilities_caption_two: "- Aprende, aplica y toma decisiones que transforman",
    //       home_capabilities_caption_three: "- Únete a la mejor comunidad de emprendimiento",
          
          
    //       // home_services_title_mini: "Pisa el acelerador",
    //       // home_services_title_big: "Eleva Tu Flujo de Trabajo",
    //       // home_services_title_mobileapps: "Plataformas Integradas",
    //       // home_services_subtitle_mobileapps: "Crea soluciones que conecten tu contenido con tu audiencia y empieza a delegar tu proyecto.",
    //       // home_services_title_backend: "Sistemas Automatizados",
    //       // home_services_subtitle_backend: "Asegura que tu proyecto sea tan inteligente como tus ideas, con sistemas que se comunican entre sí y automatizan tus procesos.",
    //       // home_services_title_consulting: "Perspectivas Estratégicas",
    //       // home_services_subtitle_consulting: "Avanza con nuestra servicio de soporte para diseñar soluciones específicas a tu modelo de negocio.",
    //       // home_services_title_database: "Datos al Alcance de Tu Mano",
    //       // home_services_subtitle_database: "Organiza, accede y utiliza tus datos con sistemas diseñados para la eficiencia.",
    //       // home_services_title_analytics: "De los Datos a la Acción",
    //       // home_services_subtitle_analytics: "Transforma los datos en decisiones con análisis que resaltan oportunidades para la automatización y la eficiencia.",
    //       // home_services_title_uiuxdesign: "Experiencias Atractivas",
    //       // home_services_subtitle_uiuxdesign: "Diseño que comprende el viaje de tu proyecto, optimizado para la interacción y conversión.",
    //       // home_services_title_webapps: "Aplicación Sin Fisuras",
    //       // home_services_subtitle_webapps: "Aplicación poderosa pero intuitiva, que unen tus servicios con tu audiencia.",
    //       // home_services_title_saas: "Control de tu compañía",
    //       // home_services_subtitle_saas: "Extiende el alcance y capacidades de tu servicio agregando personal a la plataforma de manera sencilla.",
    
        
    //       home_services_title_mini: "Tu Aliado para Crecer",
    //       home_services_title_big: "Herramientas para Emprendedores",
    //       home_services_title_mobileapps: "Integraciones que Conectan",
    //       home_services_subtitle_mobileapps: "Conecta tus plataformas favoritas y automatiza tareas para enfocarte en lo que importa: hacer crecer tu negocio.",
    //       home_services_title_backend: "Automatización Inteligente",
    //       home_services_subtitle_backend: "Deja que la tecnología haga el trabajo pesado por ti con procesos automatizados que simplifican tu día a día.",
    //       home_services_title_consulting: "Una Comunidad que Impulsa",
    //       home_services_subtitle_consulting: "Únete a una red de emprendedores y accede a soluciones colaborativas diseñadas para crecer juntos.",
    //       home_services_title_database: "Aprende y Aplica",
    //       home_services_subtitle_database: "Descubre nuestro centro de aprendizaje, con recursos prácticos para dominar herramientas, IA y estrategias de negocio.",
    //       home_services_title_analytics: "Decisiones Basadas en IA",
    //       home_services_subtitle_analytics: "Aprovecha análisis inteligentes que te muestran el camino hacia la eficiencia y el éxito empresarial.",
    //       home_services_title_uiuxdesign: "Gamificación que Motiva",
    //       home_services_subtitle_uiuxdesign: "Convierte cada paso en una experiencia emocionante con un sistema gamificado que premia tu progreso.",
    //       home_services_title_webapps: "Tecnología al Servicio de tu Negocio",
    //       home_services_subtitle_webapps: "Herramientas intuitivas y potentes diseñadas para emprendedores que buscan soluciones sin complicaciones.",
    //       home_services_title_saas: "Haz Crecer tu Equipo",
    //       home_services_subtitle_saas: "Añade colaboradores, delega tareas y expande tu negocio con una plataforma pensada para escalar.",
          

    //       home_contact_area_title_mini: "Crecemos si tu lo haces primero",
    //       home_contact_area_title_big: "¿Preguntas? ¿Ideas? Pruébanos",
    
    //       home_brands_customers_title_mini: "Socios en el Éxito",
    //       home_brands_customers_title_big: "Empoderandote con más de 100 plataformas",
    //       home_brands_customers_subtitle: "Tu visión, nuestra tecnología. Juntos, creamos experiencias digitales que marcan la diferencia.",
    
    //       home_contact_title: "Conéctate con Nosotros",
    //       home_contact_address: "Donde estamos",
    //       home_contact_email: "Contáctanos",
    
    //       home_footer_title_company: "Tecnología",
    //       home_footer_company_about_us: "Nosotros",
    //       home_footer_company_services: "Soluciones",
    //       home_footer_company_consulting: "Consultoría Tech",
    //       home_footer_company_blog: "Historias",
    //       home_footer_company_policies: "Políticas",
    //       home_footer_company_contactus: "Conecta",
    //       home_footer_title_resources: "Formación",
    //       home_footer_resources_customers: "Casos de éxito",
    //       home_footer_resources_pricing: "Valor",
    //       home_footer_resources_news: "Blog",
    //       home_footer_resources_support: "Soporte",
    //       home_footer_title_usecases: "Crecimiento",
    //       home_footer_usecases_uiuxdesign: "Preseed",
    //       home_footer_usecases_mobileapp: "Seed",
    //       home_footer_usecases_apiintegration: "Growth",
    //       home_footer_usecases_database: "ScaleUp",
    //       home_footer_usecases_software: "Maturity",
    //       home_footer_usecases_analytics: "Pricing",
    //       home_footer_title_information: "Contacto",

    //       about_us_two_faq_title_mini: "Perspectivas",
    //       about_us_two_faq_title_big_one: "Experiencia Tecnológica",
    //       about_us_two_faq_title_big_two: "para la Integración Efectiva",
    //       about_us_two_faq_function_one_title: "Simplificando Conceptos Complejos",
    //       about_us_two_faq_function_one_content: "Haciendo accesibles conceptos tecnológicos complejos, porque la innovación prospera en la simplicidad.",
    //       about_us_two_faq_function_two_title: "Rendimiento Digital Mejorado",
    //       about_us_two_faq_function_two_content: "Optimizando plataformas digitales para el máximo rendimiento, garantizando velocidad, eficiencia y satisfacción.",
    //       about_us_two_faq_function_three_title: "Soluciones Integradas",
    //       about_us_two_faq_function_three_content: "Conectando sistemas y herramientas sin esfuerzo para mejorar la eficiencia y el trabajo en equipo, impulsando tus proyectos hacia adelante.",
        
    //       about_us_two_achievement_title_mini: "Logros",
    //       about_us_two_achievement_title_big: "Abanderando la Excelencia Técnica",
    //       about_us_two_achievement_subtitle: "Impulsa la innovación y la excelencia con nosotros. Elevando proyectos y la satisfacción del cliente a nuevas alturas.",
    //       about_us_two_achievement_function_one: "Integraciones Fluidas",
    //       about_us_two_achievement_function_two: "Soluciones Avanzadas en Apps Móviles",
    //       about_us_two_achievement_discover_more: "Descubre Más",
        
    //       services_three_second_services_title: "Nuestra Experiencia",
    //       services_three_second_services_subtitle: "Guiándote a través de los desafíos de hoy con nuestro equipo de primera.",
        
    //       services_three_second_services_section_one_title_superior: "Aplicaciones Móviles",
    //       services_three_second_services_section_one_title: "Aplicaciones Móviles",
    //       services_three_second_services_section_one_subtitle: "Transformando ideas en aplicaciones móviles atractivas y centradas en el usuario. Ofreciendo experiencias destacadas en iOS y Android, combinando funcionalidad con belleza.",
    //       services_three_second_services_section_one_power_phrase: "Creando Viajes de Apps Inmersivos",
        
    //       services_three_second_services_section_two_title_superior: "Backend e Integraciones",
    //       services_three_second_services_section_two_title: "Backend e Integraciones",
    //       services_three_second_services_section_two_subtitle: "Desarrollando backends fuertes y escalables. Dominando datos, interacciones de usuarios y suaves integraciones de servicios de terceros para una experiencia completa.",
    //       services_three_second_services_section_two_power_phrase: "Diseñando Ecosistemas de Backend Unificados",
        
    //       services_three_second_services_section_three_title_superior: "Consultoría Tecnológica",
    //       services_three_second_services_section_three_title: "Consultoría Tecnológica",
    //       services_three_second_services_section_three_subtitle: "Navegando el paisaje tecnológico con perspectivas estratégicas y consejos a medida para mejorar tu infraestructura tecnológica y estrategias para una era digital.",
    //       services_three_second_services_section_three_power_phrase: "Estrategias Potenciadas con Perspectiva Tecnológica",
        
    //       services_three_second_services_section_four_title_superior: "Diseño UI/UX",
    //       services_three_second_services_section_four_title: "Diseño UI/UX",
    //       services_three_second_services_section_four_subtitle: "Elevando la presencia en línea con diseño creativo y centrado en el usuario. Nuestras soluciones UI/UX prometen una navegación sin fisuras, atractivo estético y satisfacción de usuario sin igual.",
    //       services_three_second_services_section_four_power_phrase: "Creando Narrativas Digitales Atractivas",
        
    //       services_three_second_services_get_started_button: "Comenzar",



    //       resources_download_ebook_section_title_mini: "Ebook gratuito",
    //       resources_download_ebook_section_title: "Descarga nuestro eBook sobre automatizaciones",
    //       resources_download_ebook_section_title_story_one: "En este eBook encontrarás información valiosa sobre los cuatro paquetes que ofrecemos. Experimenta, crea y automatiza procesos.",
    //       resources_download_ebook_section_title_story_one_author: "Max Innovator",
    //       resources_download_ebook_section_title_story_one_position: "Jefe de Experimentación de Ideas (CEO of Ideas)",
    //       resources_download_ebook_section_title_story_two: "Puedes crear estrategias con nuestro recurso descargable, ponerte al día sobre lo que tus competidores están aplicando y dejar el trabajo a las máquinas.",
    //       resources_download_ebook_section_title_story_two_author: "Alex Murphy alias RoboCop",
    //       resources_download_ebook_section_title_story_two_position: "Director de Cumplimiento de Estrategias Automatizadas",
    //       resources_download_ebook_section_download_history: "Ingresa tu correo electrónico y recibirás un email con nuestro eBook gratuito sobre cómo automatizar tu negocio y dedicar tiempo a lo que realmente importa.",
    //       resources_download_ebook_section_language_ebook: "Idioma del eBook",
    //       resources_download_ebook_section_boton_download: "Descargar",
        



    //       blog_newsletter_title: "Newsletter",
    //       blog_newsletter_subtitle: "Suscríbete a nuestra newsletter hoy para recibir actualizaciones sobre las últimas tendencias en integración y automatización.",
    //       blog_newsletter_newsletter_language: "Idioma de la Newsletter",
    //       blog_newsletter_policy_one: "Acepto la ",
    //       blog_newsletter_policy_two: "Política de Privacidad",
    //       blog_newsletter_email_adress_input: "Dirección de Email",
    //       blog_newsletter_subscribe_button: "Suscribirse",
        
    //       blog_recent_news_title: "Noticias Recientes",
    //       blog_categories_title: "Categorías",
    //       blog_recent_comments_title: "Comentarios Recientes",
    //       blog_recent_comments_empty_title: "No hay comentarios",
    //       blog_recent_comments_empty_subtitle: "¡Sé el primero en dejar uno!",
    //       blog_read_more_card: "Leer Más",
    //       blog_comments_card: "Comentarios",
        
    //       blog_comments_reply: "Deja un Comentario",
    //       blog_comments_email_not_published: "Tu dirección de email no será publicada",
    //       blog_comments_consent: "Al aceptar la política doy mi consentimiento para que mi nombre y email sean almacenados y utilizados para enviarme actualizaciones y noticias.",
        
    //       blog_details_article_category: "Categoría:",
    //       blog_details_article_share: "Compartir:",
    //       blog_details_article_author: "Autor",
    //       blog_details_article_last_comments: "Últimos comentarios:",
        
    //       generic_your_message: "Tu mensaje...",
    //       generic_your_name: "Tu Nombre",
    //       generic_your_email: "Tu Email",
    //       generic_send_message: "Enviar Mensaje",
        
    //       generic_newsletter_toast_error_politics: "Debes aceptar la política de privacidad para suscribirte.",
    //       generic_newsletter_toast_error_select_language: "Por favor, selecciona un idioma.",
    //       generic_toast_success_send_message: "Mensaje enviado con éxito",
    //       generic_toast_success_send_message_moderation: "Tu mensaje ha sido enviado con éxito. Será revisado por nuestros moderadores antes de ser publicado. ¡Gracias por tu contribución!",
    //       generic_toast_error_notsend_message: "No se pudo enviar el mensaje",



    //       // POLICIES
    //       newsletter_policies_title_footer: "Políticas de la Newsletter",
    //       policies_title_mini: "Términos y condiciones",
    //       policies_newsletter_title: "Políticas del Boletín",
    //       policies_newsletter_title_one: "Política de Suscripción al Boletín",
    //       policies_newsletter_description_one: "Al suscribirte a nuestro boletín, aceptas recibir comunicaciones periódicas de nuestra parte, que pueden incluir noticias, actualizaciones, promociones y contenido exclusivo relacionado con Invoke App. Nos comprometemos a utilizar tu información personal (como tu dirección de correo electrónico) exclusivamente para estos fines y de acuerdo con nuestra Política de Privacidad.",
    //       policies_newsletter_title_two: "Recopilación de Información",
    //       policies_newsletter_description_two: "Para suscribirte a nuestro boletín, solo requerimos tu dirección de correo electrónico. Puede solicitarse información adicional para personalizar tu experiencia, pero proporcionar dicha información es completamente voluntario.",
    //       policies_newsletter_title_three: "Uso de la Información",
    //       policies_newsletter_description_three: "La información que proporcionas se utiliza para enviarte nuestros boletines y comunicaciones relacionadas. No compartiremos tu información personal con terceros sin tu consentimiento explícito, excepto cuando sea necesario para el servicio de correo electrónico o según lo requiera la ley.",
    //       policies_newsletter_title_four: "Derecho de Baja",
    //       policies_newsletter_description_four: "Tienes el derecho de darte de baja de nuestro boletín en cualquier momento. Cada correo enviado incluirá un enlace en la parte inferior para `darse de baja`, permitiéndote cancelar tu suscripción de manera fácil y automática.",
    //       policies_newsletter_title_five: "Actualizaciones de la Política",
    //       policies_newsletter_description_five: "Nos reservamos el derecho de modificar esta política de suscripción en cualquier momento. Las actualizaciones serán efectivas inmediatamente después de su publicación en nuestro sitio web. Al continuar utilizando nuestro servicio de boletín después de tales actualizaciones, aceptas las modificaciones.",
    //       policies_newsletter_title_six: "Contacto",
    //       policies_newsletter_description_six: "Si tienes preguntas o inquietudes sobre nuestra política de suscripción, por favor contáctanos a través de",
        
    //       ebook_download_policies_title_footer: "Políticas de Descarga del EBook",
    //       policies_title_mini_ebook: "Términos y condiciones",
    //       policies_ebook_download_title: "Políticas de Descarga de EBook",
    //       policies_ebook_download_title_one: "Política de Descarga de EBook",
    //       policies_ebook_download_description_one: "Al descargar nuestro EBook, consientes en proporcionarnos tu dirección de correo electrónico y aceptas recibir comunicaciones periódicas de Invoke App. Estas comunicaciones pueden incluir actualizaciones, noticias y contenido exclusivo relevante para nuestras ofertas. Tu información personal será manejada de acuerdo con nuestra Política de Privacidad, asegurando su uso exclusivamente para los fines mencionados.",
    //       policies_ebook_download_title_two: "Recolección de Información",
    //       policies_ebook_download_description_two: "Para descargar nuestro EBook, requerimos tu dirección de correo electrónico. Aunque podemos solicitar información adicional para personalizar tu experiencia, la provisión de tales detalles es completamente opcional.",
    //       policies_ebook_download_title_three: "Uso de la Información",
    //       policies_ebook_download_description_three: "La información recopilada será utilizada para facilitar la descarga de tu EBook y enviarte comunicaciones relacionadas. Nos comprometemos a no compartir tus datos personales con terceros sin tu permiso explícito, excepto según sea necesario para la prestación del servicio o según lo exija la ley.",
    //       policies_ebook_download_title_four: "Derecho de Cancelación",
    //       policies_ebook_download_description_four: "Reservas el derecho de optar por no recibir nuestras comunicaciones en cualquier momento. Cada comunicación incluirá un enlace de `cancelar suscripción`, permitiéndote terminar la suscripción de manera sencilla.",
    //       policies_ebook_download_title_five: "Modificaciones a la Política",
    //       policies_ebook_download_description_five: "Nos reservamos el derecho de modificar estas políticas de descarga de EBook a nuestro criterio. Los cambios se vuelven efectivos inmediatamente tras su publicación en nuestro sitio. Tu continua interacción con nuestras descargas de EBook señala tu aceptación de estos cambios.",
    //       policies_ebook_download_title_six: "Consultas",
    //       policies_ebook_download_description_six: "Si tienes alguna pregunta o inquietud respecto a nuestras políticas de descarga de EBook, no dudes en ponerte en contacto con nosotros a través de",
        
    //       contact_policies_title_footer: "Políticas de Contacto",
    //       policies_title_mini_contact: "Términos y Condiciones",
    //       policies_contact_title: "Políticas de Contacto",
    //       policies_contact_title_one: "Recolección de Información para Contacto",
    //       policies_contact_description_one: "Cuando te pones en contacto con nosotros vía email o a través de nuestra página web, recopilamos tu dirección de correo electrónico y cualquier otra información que elijas proporcionar. Esta información se utiliza para responder a tus consultas y ofrecer soporte o información relacionada con nuestros servicios.",
    //       policies_contact_title_two: "Uso de la Información de Contacto",
    //       policies_contact_description_two: "Tu información de contacto, principalmente tu dirección de correo electrónico, será utilizada para comunicarnos contigo en respuesta a tus consultas. También podemos usar esta información para enviarte actualizaciones o información sobre nuestros servicios si has consentido recibir tales comunicaciones.",
    //       policies_contact_title_three: "Protección de Tu Información",
    //       policies_contact_description_three: "Estamos comprometidos a proteger la información que compartes con nosotros. Tu información de contacto será almacenada de manera segura y no será compartida con terceros sin tu consentimiento explícito, excepto lo necesario para proporcionarte los servicios solicitados o según lo requerido por la ley.",
    //       policies_contact_title_four: "Opción de Exclusión",
    //       policies_contact_description_four: "Tienes el derecho de optar por no recibir comunicaciones de nuestra parte en cualquier momento. Puedes hacerlo utilizando el enlace de cancelación de suscripción proporcionado en nuestros correos electrónicos o contactándonos directamente para solicitar la eliminación de nuestra lista de contactos.",
    //       policies_contact_title_five: "Actualizaciones de la Política",
    //       policies_contact_description_five: "Nos reservamos el derecho de actualizar estas políticas de contacto en cualquier momento. Los cambios entrarán en vigor inmediatamente tras su publicación en nuestra página web. Continuar contactándonos tras dichos cambios constituye tu aceptación de los nuevos términos.",
    //       policies_contact_title_six: "Contáctanos",
    //       policies_contact_description_six: "Si tienes alguna pregunta o preocupación sobre nuestras políticas de contacto, no dudes en ponerte en contacto con nosotros a través de",
        
    //       comment_policies_title_footer: "Políticas de Comentarios",
    //       policies_title_mini_comment: "Términos y Condiciones",
    //       policies_comment_title: "Políticas de Comentarios",
    //       policies_comment_title_one: "Reglas para Publicar Comentarios",
    //       policies_comment_description_one: "Damos la bienvenida y alentamos los comentarios en nuestras publicaciones del blog. Sin embargo, todos los comentarios deben cumplir con nuestros estándares de comunidad, incluyendo el respeto hacia los demás, no al discurso de odio y no a la promoción de actividades ilegales. Nos reservamos el derecho de eliminar cualquier comentario que viole estos estándares.",
    //       policies_comment_title_two: "Uso de Información Personal",
    //       policies_comment_description_two: "Para publicar un comentario, se requerirá que proporciones tu dirección de correo electrónico. Esta información se utiliza para gestionar los comentarios y prevenir abusos. Tu dirección de correo electrónico no se mostrará públicamente ni se utilizará para otros fines que no sean la gestión de comentarios, sin tu consentimiento explícito.",
    //       policies_comment_title_three: "Moderación y Aprobación",
    //       policies_comment_description_three: "Todos los comentarios están sujetos a moderación. Nuestro objetivo es revisar y aprobar los comentarios de manera pronta, pero puede haber retrasos. Nos reservamos el derecho de editar o no publicar cualquier comentario por cualquier motivo, de acuerdo con nuestros estándares.",
    //       policies_comment_title_four: "Derechos sobre los Comentarios",
    //       policies_comment_description_four: "Al publicar un comentario, nos otorgas una licencia perpetua, mundial, no exclusiva, libre de regalías para usar, reproducir, modificar, publicar, traducir, crear obras derivadas de, distribuir y mostrar dichos comentarios en cualquier medio.",
    //       policies_comment_title_five: "Actualizaciones de la Política",
    //       policies_comment_description_five: "Nos reservamos el derecho de modificar estas políticas de comentarios en cualquier momento. Los cambios serán efectivos inmediatamente después de su publicación en nuestro sitio web. Al continuar publicando comentarios después de dichos cambios, aceptas las nuevas políticas.",
    //       policies_comment_title_six: "Contacto",
    //       policies_comment_description_six: "Si tienes preguntas o preocupaciones acerca de nuestras políticas de comentarios, por favor contáctanos a través de",

    //       cookies_policies_title_footer: "Políticas de Cookies",
    //       cookies_policies_title_mini: "Términos y Condiciones",
    //       cookies_policies_title: "Políticas de Cookies",
    //       cookies_policy_title_one: "Introducción",
    //       cookies_policy_description_one: "Al visitar nuestro sitio web, aceptas el uso de cookies para mejorar tu experiencia de navegación. Las cookies nos permiten personalizar contenido, ofrecer funciones de redes sociales y analizar nuestro tráfico.",
    //       cookies_policy_title_two: "Recopilación de Información",
    //       cookies_policy_description_two: "Utilizamos cookies que son esenciales para el funcionamiento del sitio, así como cookies de análisis que nos ayudan a comprender cómo interactúas con el sitio.",
    //       cookies_policy_title_three: "Uso de la Información",
    //       cookies_policy_description_three: "La información recopilada mediante cookies se utiliza para personalizar tu experiencia y enviar publicidad relevante. También se utiliza para mejorar nuestro sitio web y servicios.",
    //       cookies_policy_title_four: "Administración de Cookies",
    //       cookies_policy_description_four: "Puedes gestionar tus preferencias de cookies en cualquier momento ajustando la configuración de tu navegador.",
    //       cookies_policy_title_five: "Consentimiento",
    //       cookies_policy_description_five: "Al utilizar nuestro sitio, consientes el uso de cookies de acuerdo con esta política. Si decides no aceptar nuestras cookies, algunas partes del sitio pueden no funcionar como se espera.",
    //       cookies_policy_title_six: "Contacto",
    //       cookies_policy_description_six: "Si tienes preguntas sobre nuestra política de cookies, no dudes en contactarnos en",



    //       investors_page_commercial_dossier_download: "Descargar Dossier",
    //       investors_page_commercial_dossier_title: "Dossier Comercial",
    //       investors_page_commercial_dossier_description: "El ERP para negocios unipersonales de mil millones de dólares.\n\nInvokeApp es un ERP modular creado para el futuro del emprendimiento: ágil, automatizado y potenciado por IA. Abordamos la creciente necesidad de operaciones escalables y eficientes para solopreneurs, equipos pequeños y agencias digitales.\n\nNuestra plataforma integra funciones clave del negocio (marketing, finanzas, RRHH, inventario, CRM) con automatizaciones plug-and-play y flujos de trabajo con IA, eliminando las barreras técnicas que dificultan la adopción en el segmento PyME.\n\n- Modelo SaaS freemium con planes Premium+\n- Framework de integraciones propio (independiente de Zapier o Make)\n- Arquitectura preparada para IA, con analítica en tiempo real y formación gamificada\n- MVP al 90% — listo para salir al mercado en Q3 2025\n\nEstamos levantando capital para escalar nuestra estrategia de lanzamiento, finalizar el sistema de pagos y acelerar la adquisición de usuarios mediante flujos de automatización integrados.",
          
    //       investors_page_investor_deck_download: "Descargar Deck",
    //       investors_page_investor_deck_title: "Investor Deck",
    //       investors_page_investor_deck_description: "Libera todo el potencial de tus operaciones empresariales.\n\nInvokeApp es una plataforma ERP todo-en-uno diseñada para emprendedores digitales, pequeñas agencias y startups en crecimiento. Nuestro sistema modular combina automatización, analítica en tiempo real y flujos guiados para ayudarte a ahorrar tiempo, reducir costes y escalar con confianza.\n\nYa sea que gestiones marketing, ventas, RRHH o finanzas, InvokeApp se adapta a tu negocio y potencia a tu equipo con integraciones inteligentes y herramientas no-code, todo desde un panel intuitivo.\n\n✓ Optimiza procesos\n✓ Centraliza tus herramientas\n✓ Automatiza sin barreras técnicas\n\nComienza con nuestro modelo freemium y desbloquea funciones premium a medida que creces."



    //     }
    //   }
    // }





  }
  );

export default i18n;
























///ORIGINAL TRANSLATION IN ENGLISH

// en: {
//   translation: {
//    navbar_home: "Home",
//    navbar_about_us: "About Us",
//    navbar_services: "Services",
//    navbar_portfolio: "Portfolio",
//    navbar_resources: "Resources",
//    navbar_blog: "Blog",
//    contact_us: "Contact Us",

//    page_title_about_us:"About Us",
//    page_title_services:"Services",
//    page_title_portfolio:"Our Portfolio",
//    page_title_resources:"Resources",
//    page_title_blog:"Our Blog",
//    page_title_blog_details:"Blog Details",
//    page_title_contact_us:"Contact Us",
   

//   /// HOME PAGE AND COMPONENTS
//    home_slider_title_superior_one: "Elevating your experience",
//    home_slider_title_superior_two: "We provide faster products to infoproducters",
//    home_slider_title_main_copy_one1: "We provide fast and beautiful apps ",
//    home_slider_title_main_copy_one2: "in a lightweight package",
//    home_slider_title_main_copy_two1: "Our technology is used in Google, Instagram ",
//    home_slider_title_main_copy_two2: "and other big platforms",
   
//    home_about_title_mini:"Who we are",
//    home_about_title_big:"Unlocking Technological Potential",
//    home_about_subtitle:"Welcome to our technology consulting and development firm! We are dedicated to pushing boundaries and unlocking the true potential of your business through innovative and cutting-edge solutions.",
//    home_about_caption_one:"Custom Mobile App Development",
//    home_about_caption_two:"User-Centric Design",
//    home_about_caption_three:"Scalable and Reliable Solutions",
//    home_about_discover_services:"Discover Our Services",

//    home_capabilities_title_mini:"Capabilities",
//    home_capabilities_title_big:"Strategy-led Mobile App Design & Development",
//    home_capabilities_subtitle:"At our technology consultancy, we bring your app ideas to life with a strategy-led approach and attention to every detail of mobile app design and development. Our capabilities encompass the following stages:",
//    home_capabilities_caption_one:"- Analysis & Idea",
//    home_capabilities_caption_two:"- Design & Development",
//    home_capabilities_caption_three:"- Testing & Launch",
   
//    home_services_title_mini:"Our Services",
//    home_services_title_big:"Provide awesome customer service with our tools.",
//    home_services_title_mobileapps : "Mobile Apps",
//    home_services_subtitle_mobileapps : "Create intuitive and powerful mobile applications that elevate user experiences and drive business growth.",
//    home_services_title_backend : "Backends & APIs",
//    home_services_subtitle_backend : "Build robust backends and APIs that ensure seamless communication and data management for your applications.",
//    home_services_title_consulting : "Consulting",
//    home_services_subtitle_consulting : "Leverage our expert technology consulting services to make informed decisions and accelerate your digital transformation.",
//    home_services_title_database : "Database",
//    home_services_subtitle_database : "Design, optimize, and manage databases to store and retrieve data efficiently, ensuring data integrity and security.",
//    home_services_title_analytics : "Data Analytics",
//    home_services_subtitle_analytics : "Extract valuable insights from your data with our advanced analytics solutions, enabling data-driven decision-making.",
//    home_services_title_uiuxdesign : "UI/UX Design",
//    home_services_subtitle_uiuxdesign : "Craft visually stunning and user-friendly UI/UX designs that captivate users and enhance app usability.",
//    home_services_title_webapps : "Web Apps",
//    home_services_subtitle_webapps : "Develop dynamic and scalable web applications that cater to your specific business needs and deliver outstanding performance.",
//    home_services_title_saas : "SaaS",
//    home_services_subtitle_saas : "Transform your software into a Software-as-a-Service (SaaS) model, enabling scalable and accessible solutions for your customers.",

//    home_contact_area_title_mini:"Explore our dynamic team for endless possibilities!",
//    home_contact_area_title_big:"Do you have any question? Feel free to contact us",

//    home_brands_customers_title_mini:"Our Customers",
//    home_brands_customers_title_big:"Join 100+ satisfied clients who've benefited from our mobile app expertise.",
//    home_brands_customers_subtitle:"From crafting simple icons to developing comprehensive websites and applications, we bring your ideas to life.",
   
//    home_contact_title:"Get in touch",
//    home_contact_address:"Address",
//    home_contact_email:"Email Address",


//    home_footer_title_company:"Company",
//    home_footer_company_about_us:"About Us",
//    home_footer_company_services:"Services",
//    home_footer_company_consulting:"Consulting",
//    home_footer_company_blog:"Blog",
//    home_footer_company_contactus:"Contact Us",
//    home_footer_title_resources:"Resources",
//    home_footer_resources_customers:"Customers",
//    home_footer_resources_pricing:"Pricing",
//    home_footer_resources_news:"News",
//    home_footer_resources_support:"Support",
//    home_footer_title_usecases:"Use Cases",
//    home_footer_usecases_uiuxdesign :"UI/UX Design",
//    home_footer_usecases_mobileapp :"Mobile App Development",
//    home_footer_usecases_apiintegration :"API Integration",
//    home_footer_usecases_database :"Database",
//    home_footer_usecases_software :"Software As A Service",
//    home_footer_usecases_analytics :"Data Analytics & Business Intelligence",
//    home_footer_title_information:"Information",


//   /// ABOUT US PAGE AND COMPONENTS
//    about_us_two_faq_title_mini: "Insights",
//    about_us_two_faq_title_big_one: "Tech Expertise ",
//    about_us_two_faq_title_big_two: " for Innovation",
//    about_us_two_faq_function_one_title: "Simplifying Complex Concepts",
//    about_us_two_faq_function_one_content: "Demystifying intricate tech concepts with clear explanations, because innovation doesn't have to be perplexing.",
//    about_us_two_faq_function_two_title: "Amplified Digital Performance",
//    about_us_two_faq_function_two_content: "Enhancing digital platforms for optimal speed, efficiency, and user satisfaction, because tech excellence matters.",
//    about_us_two_faq_function_three_title: "Integrated Solutions",
//    about_us_two_faq_function_three_content: "Seamlessly connecting diverse systems and tools to maximize efficiency and collaboration, because integration drives progress.",

//    about_us_two_achievement_title_mini: "Accomplishments",
//    about_us_two_achievement_title_big: "Empowering with Technical Excellence",
//    about_us_two_achievement_subtitle: "Unleash innovation and mastery with us. We take it to the next level, leaving a trail of successful projects and satisfied clients.",
//    about_us_two_achievement_function_one: "Streamlined Integrations",
//    about_us_two_achievement_function_two: "Innovative Mobile Apps Solutions",
//    about_us_two_achievement_discover_more: "Discover More",



//   /// SERVICES PAGE AND COMPONENTS
//    services_three_second_services_title: "These Are Our Expertise Areas",
//    services_three_second_services_subtitle: "We help you weather today's uncertainty through our best team.",

//    services_three_second_services_section_one_title_superior: "Mobile Apps",
//    services_three_second_services_section_one_title: "Mobile Apps",
//    services_three_second_services_section_one_subtitle: "Transforming ideas into interactive and user-centric mobile applications. Crafting engaging experiences for iOS and Android platforms, catering to diverse user needs and preferences. Seamlessly blending functionality, aesthetics, and performance to create apps that stand out.",
//    services_three_second_services_section_one_power_phrase: "Sculpting Immersive App Experiences",

//    services_three_second_services_section_two_title_superior: "Backend & Integrations",
//    services_three_second_services_section_two_title: "Backend & Integrations",
//    services_three_second_services_section_two_subtitle: "Building robust and scalable backend systems that power your applications. Expertly handling data management, user authentication, and seamless integrations with third-party services. Ensuring smooth communication between front-end interfaces and back-end functionality for a holistic user experience.",
//    services_three_second_services_section_two_power_phrase: "Architecting Cohesive Backend Landscapes",

//    services_three_second_services_section_three_title_superior: "Tech Consulting",
//    services_three_second_services_section_three_title: "Tech Consulting",
//    services_three_second_services_section_three_subtitle: "Guiding your business through the ever-evolving tech landscape. Providing strategic insights and tailored recommendations to optimize your technology infrastructure and operations. From identifying opportunities for digital transformation to overcoming technical challenges, our consulting services pave the way for informed decision-making.",
//    services_three_second_services_section_three_power_phrase: "Empowering Business through Tech Expertise",

//    services_three_second_services_section_four_title_superior: "Design UI/UX",
//    services_three_second_services_section_four_title: "Design UI/UX",
//    services_three_second_services_section_four_subtitle: "Elevate your online presence with our specialized UI/UX design services. We blend creativity, user-centered design, and technical expertise to create interfaces that captivate and engage. Whether you're building a website, app, or platform, our design solutions ensure seamless navigation, stunning aesthetics, and exceptional user satisfaction.",
//    services_three_second_services_section_four_power_phrase: "Crafting Digital Experiences that Resonate",

//    services_three_second_services_get_started_button: "Get Started",



//   /// BLOG PAGE AND COMPONENTS
//    blog_newsletter_title:"Newsletter",
//    blog_newsletter_subtitle:"Subscribe to our newsletter today to receive updates on the latest news",
//    blog_newsletter_newsletter_language:"Newsletter language",
//    blog_newsletter_policy_one:"I accept the",
//    blog_newsletter_policy_two:" Privacy Policy",
//    blog_newsletter_email_adress_input:"Email Address",
//    blog_newsletter_subscribe_button:"Subscribe",

//    blog_recent_news_title:"Recent News",
//    blog_categories_title:"Categories",
//    blog_recent_comments_title:"Recent Comments",
//    blog_recent_comments_empty_title:"There are no comments",
//    blog_recent_comments_empty_subtitle:"Be the first to leave one!",
//    blog_read_more_card:"Read More",
//    blog_comments_card:"Comments",

//    blog_comments_reply:"Leave a Reply",
//    blog_comments_email_not_published:"Your email address will not be a published",
//    blog_comments_consent:"I consent to my name and email being stored and used to send me updates and news.",

//    blog_details_article_category:"Category:   ",
//    blog_details_article_share:"Share:   ",
//    blog_details_article_author:"Author",
//    blog_details_article_last_comments:"Last comments:   ",
   

//    /// GENERIC MESSAGES
//    generic_your_message:"Your message...",
//    generic_your_name:"Your Name",
//    generic_your_email:"Your Email",
//    generic_send_message:"Send Message",

//    generic_newsletter_toast_error_politics:"You must accept the privacy policy to subscribe.",
//    generic_newsletter_toast_error_select_language:"Please select a language.",
//    generic_toast_success_send_message:"Message sent succesfully",
//    generic_toast_success_send_message_moderation:"Your message has been successfully submitted. It will be reviewed by our moderators before being published. Thank you for your contribution!",
//    generic_toast_error_notsend_message:"Could not send the message",

//   }
// },














